/* SYK zoek-maatwerk (07-07) — gedrag voor de varianten uit Thema-instellingen → 🔎 Zoeken.
   Werkt BOVENOP de native flow: custom-async.js blijft de livesearch-sectie fetchen en
   injecteren; wij reageren op de injectie (observer op #livesearch) en vullen aan.
   Config: window.SYK_SEARCH (gezet door snippets/syk-search-assets.liquid). */
(function () {
  'use strict';
  var CFG = window.SYK_SEARCH || {};
  /* actieve results-config D: op een COLLECTIEPAGINA overrulen de collectie-instellingen (D.coll)
     de kaart-/filtersleutels, zodat de collectie-productkaart+filters LOS van de search-results
     instelbaar zijn (wens eigenaar 10-07). Op zoekpagina's is D identiek aan CFG -> nul
     gedragsverandering. D = CFG met, op collecties, de niet-lege coll-sleutels eroverheen; sleutels
     die coll niet bevat vallen terug op D. Vanaf hier leest de hele module D (globale D.->D.),
     behalve deze opbouw + de window.SYK_SEARCH-lezing (bracket-notatie, niet meegenomen). */
  var sykBody = document.body || document.documentElement;
  var sykIsColl = !!(sykBody && sykBody.classList && sykBody.classList.contains('template-collection'));
  var sykIsSearch = !!(sykBody && sykBody.classList && sykBody.classList.contains('template-search'));
  var D = {};
  (function () {
    for (var k in CFG) { if (k !== 'coll') D[k] = CFG[k]; }
    var c = CFG['coll'];
    if (sykIsColl && c) { for (var k2 in c) { var v = c[k2]; if (v !== null && v !== undefined && v !== '') D[k2] = v; } }
  })();
  if (!CFG['variant'] && !CFG['resultsPlus'] && !CFG['collOn'] && !CFG['collBtnImg']) return;
  /* zoekregels vast op idle inladen (review-fix 17-07): de localStorage-parse/CDN-fetch gebeurt
     dan buiten het typ-pad, zodat de eerste suggest-render vrijwel altijd een gevulde regelmap
     treft en de 600ms-race in sykRegelsSnel zelden afgaat */
  if (CFG['zoekregels']) {
    (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(function () { try { sykRegels(); } catch (eZR) {} });
  }
  /* zoeklaag-teksten per taal (21-07): gevuld door syk-search-assets (D.i18n); NL = fallback */
  var SYKT = D.i18n || {};
  /* label-contrast (melding eigenaar 21-07: 'Label-kleur' op wit gezet -> witte tekst op wit
     pilletje was onleesbaar): bij een LICHTE labelkleur wordt de vaste witte teksts vervangen
     door navy via --syk-label-tekst. Draait vóór de eerste label-render (labels zijn JS-werk). */
  (function () {
    try {
      var v = getComputedStyle(document.body || document.documentElement).getPropertyValue('--syk-label').trim();
      var m = v.match(/^#?([0-9a-f]{3}|[0-9a-f]{6})$/i);
      if (!m) return;
      var h = m[1];
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      var n = parseInt(h, 16);
      var lum = (0.299 * (n >> 16 & 255) + 0.587 * (n >> 8 & 255) + 0.114 * (n & 255)) / 255;
      if (lum > 0.6) document.documentElement.style.setProperty('--syk-label-tekst', '#0b2c44');
    } catch (eLC) {}
  })();

  /* Collection button list: [collectie-afbeelding] + [titel] (wens eigenaar 10-07). De button-list
     is een thema-sectie; per collectie halen we de afbeelding op via de mini-datasectie syk-colimg
     (dag-cache) en zetten hem vóór de titel in de pill. Zelfstandige opt-in (syk_coll_btnlist_img). */
  if (CFG['collBtnImg'] && sykIsColl) {
    var sykColImgVlucht = {};
    var sykColImg = function (handle) {
      var ck = 'sykColImg:' + handle;
      if (sykColImgVlucht[ck]) return sykColImgVlucht[ck];
      var uit = cacheLees(ck);
      if (uit !== null && uit !== undefined) { sykColImgVlucht[ck] = Promise.resolve(uit); return sykColImgVlucht[ck]; }
      sykColImgVlucht[ck] = fetch('/collections/' + encodeURIComponent(handle) + '?section_id=syk-colimg', { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (h) { var t = document.createElement('div'); t.innerHTML = h; var s = t.querySelector('[data-syk-colimg]'); var u = s ? (s.textContent || '').trim() : ''; cacheSchrijf(ck, u); return u; })
        .catch(function () { delete sykColImgVlucht[ck]; return ''; });
      return sykColImgVlucht[ck];
    };
    var sykBtnlistImg = function () {
      var sec = document.querySelector('[id*="collection_button_list"]');
      if (!sec) return;
      [].forEach.call(sec.querySelectorAll('.link-btn a[href*="/collections/"]'), function (a) {
        if (a.getAttribute('data-syk-colimg-done')) return;
        var m = String(a.getAttribute('href') || '').split('?')[0].match(/\/collections\/([^\/?#]+)/);
        if (!m) return;
        a.setAttribute('data-syk-colimg-done', '1');
        a.classList.add('syk-btn-img');
        sykColImg(m[1]).then(function (url) {
          if (!url || a.querySelector('.syk-btnimg')) return;
          var img = document.createElement('img');
          img.className = 'syk-btnimg'; img.src = url; img.alt = ''; img.loading = 'lazy'; img.width = 22; img.height = 22;
          a.insertBefore(img, a.firstChild);
        });
      });
    };
    sykBtnlistImg();
    [200, 700, 1800].forEach(function (t) { setTimeout(sykBtnlistImg, t); });
  }

  /* Sub-collectie tegels (ul.l4cl.category) bovenaan een collectie: het thema toont ze
     GECENTREERD (justify-center) terwijl breadcrumb/toolbar/productgrid links uitlijnen ->
     de uitlijning oogde 'zoek'. De CSS (pre-header) zet ze op flex-start; hier plaatsen we een
     "Collecties"-kop ervoor zodat de bezoeker ze duidelijk als collecties herkent, los van het
     productgrid dat al "Alle producten (N)" als kop heeft. Idempotent + retries want het thema
     kan de sectie herbouwen. Opt-in syk_coll_subcol (via D.subcol). LET OP: de tegels gebruiken
     mix-blend-mode:multiply op de foto -> NOOIT een gekleurd overlay-element over de tegel leggen
     (dat pikt de multiply op als backdrop = donkere blobs); daarom een kop ERVOOR i.p.v. een badge. */
  if (CFG['collOn'] && sykIsColl && D.subcol) {
    var sykSubcolBouw = function () {
      var ul = document.querySelector('ul.l4cl.category');
      if (!ul) return;
      if ((D.subcolStijl || 'tegels') === 'pills') {
        /* sub-collecties als PILLS i.p.v. afbeeldings-tegels (wens eigenaar 14-07): zelfde chip-component
           als de zoek-categorieën (rond fotootje + titel, .syk-ls-chip). De thema-tegel-<ul> wordt verborgen
           (data-attr + CSS) en vervangen door een pill-rail ervoor. Idempotent; herbouwt de sectie het thema
           (nieuwe <ul>-node zonder de vlag), dan ruimt hij de oude rail op en bouwt opnieuw. */
        if (ul.getAttribute('data-syk-subpills') === '1') return;
        var items = [].slice.call(ul.children).map(function (li) {
          var a = li.querySelector('a[href*="/collections/"]');
          if (!a) return null;
          var img = li.querySelector('img');
          return { url: a.getAttribute('href'), title: (li.textContent || '').replace(/\s+/g, ' ').trim(), img: img ? img.getAttribute('src') : '' };
        }).filter(function (c) { return c && c.title; });
        if (!items.length) return;
        [].forEach.call(document.querySelectorAll('.syk-subcol-pillrail'), function (r) { if (r.parentNode) r.parentNode.removeChild(r); });
        var vk = ul.previousElementSibling;
        if (vk && vk.classList && vk.classList.contains('syk-subcol-kop')) vk.parentNode.removeChild(vk);
        /* HERONTWERP 21-07 (wens eigenaar: 'duidelijk en overzichtelijk'): beeld-tegels in een rustig
           raster i.p.v. een muur van tekstpills. Desktop: auto-fill-grid, ingeklapt op ~2 rijen met
           'Toon alle N'; mobiel: 2-rijen horizontale snap-rail. Foto op 128px opgevraagd (retina). */
        var MAXDICHT = 14;
        var meerNodig = items.length > MAXDICHT;
        var tMeer = (SYKT.subMeer || 'Toon alle {n}').replace('{n}', items.length);
        var tMinder = SYKT.subMinder || 'Toon minder';
        var rail = document.createElement('div');
        rail.className = 'syk-ls syk-subcol-pillrail';
        rail.innerHTML = '<p class="syk-ls-kop">' + esc(D.subcolKop || 'Collecties') + ' <span class="syk-subcol-tel">' + items.length + '</span></p>' +
          '<div class="syk-subcol-scrollwrap"><div class="syk-subcol-grid' + (meerNodig ? ' syk-subcol-grid--dicht' : '') + '">' +
          items.map(function (c) {
            /* crop=center&height=430&width=128 in de thema-src = een smalle CDN-strook: bij staande
               kostuums oogt dat toevallig goed, bij vierkante foto's (pruiken!) blijft een oog over
               (melding eigenaar 27-07). Crop+height strippen -> CDN levert de VOLLEDIGE foto;
               object-fit:contain in de CSS toont hem heel. */
            var bron = c.img ? String(c.img)
              .replace(/([?&])crop=[^&]*&?/g, '$1')
              .replace(/([?&])height=[^&]*&?/g, '$1')
              .replace(/width=\d+/, 'width=128')
              .replace(/\?&+/, '?').replace(/&&+/g, '&').replace(/[?&]$/, '') : '';
            var thumb = bron
              ? '<img src="' + esc(bron) + '" alt="" loading="lazy" width="64" height="64">'
              : '<b>' + esc((c.title.charAt(0) || '?').toUpperCase()) + '</b>';
            return '<a class="syk-subcol-tegel" href="' + esc(c.url) + '"><span class="syk-subcol-thumb">' + thumb + '</span><span class="syk-subcol-naam">' + esc(c.title) + '</span></a>';
          }).join('') + '</div>' +
          '<button type="button" class="syk-subcol-pijl" aria-label="' + esc(SYKT.subPijl || 'Verder scrollen') + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>' +
          (meerNodig ? '<button type="button" class="syk-subcol-meer" data-meer="' + esc(tMeer) + '" data-minder="' + esc(tMinder) + '">' + esc(tMeer) + ' \u25be</button>' : '');
        ul.setAttribute('data-syk-subpills', '1');
        ul.parentNode.insertBefore(rail, ul);
        /* scroll-pijl op de rail (wens eigenaar 27-07): de mobiele 2-rijen-rail verbergt zijn
           scrollbalk (CSS scrollbar-width:none) -> niets verraadt dat er rechts meer collecties
           staan. Fade + rond pijltje, puur overflow-gedreven: toont alleen als er echt overloop
           is EN het einde nog niet bereikt is (desktop-raster heeft geen overloop -> nooit een
           pijl). Tik = ~70% railbreedte verder (smooth, tenzij prefers-reduced-motion). */
        var swrap = rail.querySelector('.syk-subcol-scrollwrap');
        var sgrid = rail.querySelector('.syk-subcol-grid');
        var supd = function () {
          var rek = sgrid.scrollWidth - sgrid.clientWidth;
          swrap.classList.toggle('syk-subcol-scroll--meer', rek > 24 && sgrid.scrollLeft < rek - 16);
        };
        sgrid.addEventListener('scroll', supd, { passive: true });
        window.addEventListener('resize', supd, { passive: true });
        rail.querySelector('.syk-subcol-pijl').addEventListener('click', function () {
          var stap = Math.round(sgrid.clientWidth * 0.7);
          var voor = sgrid.scrollLeft;
          var zacht = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          sgrid.scrollBy({ left: stap, behavior: zacht });
          /* vangnet (droogtest 27-07): sommige engines negeren smooth-scrollBy op een snap-rail ->
             dan hard springen; en supd expliciet, want programmatic scroll vuurt niet overal een
             scroll-event (gebruikers-swipes doen dat wel — de listener hierboven is het hoofdpad) */
          setTimeout(function () { if (Math.abs(sgrid.scrollLeft - voor) < 8) sgrid.scrollLeft = voor + stap; supd(); }, 260);
          setTimeout(supd, 700);
        });
        supd(); setTimeout(supd, 350);
      } else {
        ul.classList.add('syk-subcol');
        var vorige = ul.previousElementSibling;
        if (vorige && vorige.classList && vorige.classList.contains('syk-subcol-kop')) return;
        var h = document.createElement('h2');
        h.className = 'syk-subcol-kop';
        h.textContent = D.subcolKop || 'Collecties';
        ul.parentNode.insertBefore(h, ul);
      }
    };
    sykSubcolBouw();
    [150, 600, 1600].forEach(function (t) { setTimeout(sykSubcolBouw, t); });
    /* 'Toon alle N' open/dicht (gedelegeerd + one-shot: overleeft thema-herbouw van de sectie) */
    if (!window.__sykSubMeer) {
      window.__sykSubMeer = 1;
      document.addEventListener('click', function (e) {
        var k = e.target && e.target.closest ? e.target.closest('.syk-subcol-meer') : null;
        if (!k) return;
        var rail2 = k.closest('.syk-subcol-pillrail');
        var grid = rail2 && rail2.querySelector('.syk-subcol-grid');
        if (!grid) return;
        var open = grid.classList.toggle('syk-subcol-grid--open');
        k.innerHTML = (open ? (k.getAttribute('data-minder') || 'Toon minder') + ' \u25b4' : (k.getAttribute('data-meer') || 'Toon alle') + ' \u25be');
      }, true);
    }
  }

  function geldEUR(cents) {
    try { return (cents / 100).toLocaleString(((window.SYK_DELIV_I18N || {}).locale || 'nl-NL'), { style: 'currency', currency: 'EUR' }); }
    catch (e) { return '€ ' + (cents / 100).toFixed(2).replace('.', ','); }
  }

  /* ---- drawer stil verversen na quick-add (zelfde patroon als sykVerversDrawer in syk-pdp.js:
     sectie-fetch -> innerHTML-replace met behoud van a.m6pn-close -> thema-inits + levertijd-event) ---- */
  function verversDrawer() {
    try { sykCartHaal(true); } catch (e) {} /* cart-snapshot vers houden voor de look-rail (functie-hoisting: staat verderop) */
    fetch('/?section_id=side-cart', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var box = document.getElementById('cart'); if (!box) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var vers = tmp.querySelector('#shopify-section-side-cart'); if (!vers) return;
        var sluit = box.querySelector(':scope > a.m6pn-close');
        box.innerHTML = vers.innerHTML;
        if (sluit) box.appendChild(sluit);
        try {
          if (typeof amountRun === 'function') {
            var els = box.querySelectorAll('.input-amount:not(.semantic-input-initialized)');
            [].forEach.call(els, amountRun);
            if (typeof amountClick === 'function') amountClick(els);
          }
        } catch (e) {}
        try { window.dispatchEvent(new CustomEvent('fetchDeliverytimes')); } catch (e) {}
      })
      .catch(function () {});
  }
  function telBij(n) {
    var c = document.getElementById('cart-count');
    if (c) c.textContent = String((parseInt(c.textContent || '0', 10) || 0) + n);
  }

  /* levertijd-vangnet in de drawer (melding eigenaar: regel toonde alleen "128 cm ·"): het thema
     rendert per regel een VERBORGEN standaardtekst (instelling default_product_deliverytime_in_stock)
     + een lege .custom-deliverytime die de levertijd-API vult — maar de API kent niet elke sku
     (deliveryDate null, live gemeten voor 5055294866677/84) en dan bleef de regel leeg. Zolang de
     API-tekst leeg is de standaardtekst tonen; vult de API alsnog, dan wint die (idempotent in
     beide volgordes; classList-writes zijn geen childList/characterData-mutatie, dus geen lus). */
  if (!window.__sykDrawerVangnet) {
    window.__sykDrawerVangnet = true;
    var sykDrawerVangnet = function () {
      [].forEach.call(document.querySelectorAll("#cart .custom-deliverytime"), function (cd) {
        var ouder = cd.parentNode;
        if (!ouder) return;
        var std = null;
        [].forEach.call(ouder.children, function (k) { if (k !== cd && /\bstrong\b/.test(String(k.className))) std = k; });
        if (!std) return;
        if (cd.textContent.trim()) std.classList.add("hidden");
        else std.classList.remove("hidden");
      });
    };
    (function () {
      var box = document.getElementById("cart");
      if (!box || !window.MutationObserver) return;
      var t2;
      try {
        new MutationObserver(function () { clearTimeout(t2); t2 = setTimeout(sykDrawerVangnet, 900); })
          .observe(box, { childList: true, subtree: true, characterData: true });
      } catch (e) {}
      setTimeout(sykDrawerVangnet, 1200);
    })();
  }

  /* ---- na elke suggest-injectie: levertijd vullen + C-extra's ---- */
  var ls = document.getElementById('livesearch');
  var t;
  /* iOS-fix (melding eigenaar 22-07): de mobiele modal-hoogte rekende met een vaste 125px top-offset;
     op het fullscreen-zoekscherm staat de modal lager en viel de sticky CTA-knop onder de viewport.
     Hier de ECHTE top meten en als CSS-var doorgeven (zie syk-search.css).
     Gezond-verstand-band: een meting van 0 (nog geen layout) of extreem laag (>55% van het scherm)
     zou de scroll-box respectievelijk te hoog of piepklein maken — dan de oude 125px.
     De meting MOET vers blijven (audit 22-07, ernst 'breekt'): de var stuurt sinds de min-height-fix
     ook de ONDERgrens van de box. Blijft er een te lage waarde staan — bv. gemeten met een ingeklapte
     header en daarna heropend met een volle header — dan wordt min-height groter dan de beschikbare
     hoogte en zakt de groene knop opnieuw onder het scherm: exact de oorspronkelijke klacht. Daarom
     hermeten bij resize/orientatiewissel en de var opruimen bij het sluiten (zie sluitZoek). */
  function meetLsTop(poging) {
    if (!ls) return;
    poging = poging || 0;
    try {
      var rect = ls.getBoundingClientRect();
      /* naInjectie draait óók terwijl de modal nog verborgen is (o.a. de 400ms-timer na load en de
         childList-observer tijdens het injecteren). De rect is dan volledig 0, dat valt buiten de
         band, en we schreven de terugval 125px weg — terwijl de echte top 69 is. Live gemeten 22-07:
         box liep dan tot 756 bij een scherm van 812, dus 56px te kort (onschuldig: de knop komt er
         juist hoger door, nooit lager, maar de witte box dekt niet tot de schermrand). Daarom bij een
         nog niet uitgemeten modal NIET de terugval wegschrijven maar het volgende frame opnieuw
         proberen; na 8 frames (~130ms) opgeven en laat de CSS zelf op de veilige 125px terugvallen. */
      if (!rect.height && !Math.round(rect.top)) {
        if (poging < 8) requestAnimationFrame(function () { meetLsTop(poging + 1); });
        return;
      }
      var lsTop = Math.round(rect.top);
      var lsMax = Math.round((window.innerHeight || 800) * 0.55);
      if (!(lsTop >= 40 && lsTop <= lsMax)) lsTop = 125;
      document.documentElement.style.setProperty('--syk-ls-top', lsTop + 'px');
    } catch (e9) {}
  }
  var lsTopT;
  function meetLsTopLater() {
    clearTimeout(lsTopT);
    lsTopT = setTimeout(function () { if (ls && ls.offsetParent !== null) meetLsTop(); }, 120);
  }
  try {
    window.addEventListener('resize', meetLsTopLater, { passive: true });
    window.addEventListener('orientationchange', meetLsTopLater, { passive: true });
  } catch (e10) {}
  /* ---- BRON van de productlijst in de zoekbalk (instelling syk_search_bron), 07-08-2026 ----
     De zoekbalk gebruikt Shopify's predictive search, de resultatenpagina de gewone zoekopdracht
     (hier via Search & Discovery). Twee motoren, twee rankings: live gemeten kwamen de eerste tien
     bij 'hippie pak' op 4 van de 10 overeen, bij 'rode cape' op 10 van de 10. Wie ze gelijk wil
     trekken zet deze instelling op 'pagina'; dan halen we de productlijst op bij de sectie
     syk-zoekresultaten, die exact de treffers van de resultatenpagina rendert in dezelfde rij-opmaak.
     Standaard staat de instelling op 'suggest' = ongewijzigd gedrag, dus dit pad ligt dan stil.
     Bewust: de predictive-lijst blijft staan tot de vervanging binnen is (nooit een leeg gat), en
     mislukt de fetch, dan blijft die gewoon staan. */
  /* ---- STER-BESLISSING op één plek (09-08-2026) ----
     De volle zoekpagina matcht alleen hele woorden, de suggest prefix-matcht; daarom plakken we een
     ster achter de zoekterm ('legerpak' gaf 5 i.p.v. 72 resultaten). Bij VERZAMELWOORDEN pakt dat
     verkeerd uit: op 'hippie pak' groeit de uitkomst van 94 naar 1076 treffers en schuiven een shirt
     en een snor tussen de pakken. Op tien echte zoektermen beoordeeld: alleen bij dit soort termen
     (thema + verzamelwoord) merkt een klant er iets van; bij 'pruik', 'hoed', 'handschoenen',
     'bretels', 'jurk' en 'cape' is er geen verschil en dóet de ster juist goed werk (zonder ster
     verschijnt bij 'ninja masker' een robotmasker in de top).
     De eigenaar beheert de woordenlijst zelf in de theme editor (syk_search_geen_ster). LEEG = de
     ster gaat overal mee, dus exact het gedrag van vóór deze wijziging.
     Vergelijking op het LAATSTE WOORD, exact: 'hippie pak' -> 'pak'. Bewust geen achtervoegsel-
     vergelijking, want dan zou 'ninjapak' ook raken terwijl de ster daar juist nodig is. Wie
     'pakje' wil vangen zet dat er los bij. */
  var sykGeenSter = String(D.geenSter || '').toLowerCase().split(/[,;\n\r]+/).map(function (w) { return w.trim(); }).filter(Boolean);
  function sykSterTerm(term) {
    term = String(term || '').trim();
    if (!term) return term;
    if (/[*"']/.test(term)) return term; /* bezoeker tikt zelf al een operator: niets overheen zetten */
    if (sykGeenSter.length) {
      var laatste = term.toLowerCase().split(/\s+/).pop();
      if (sykGeenSter.indexOf(laatste) > -1) return term;
    }
    return term + '*';
  }
  function sykBronPagina() { return (D.bron || 'suggest') === 'pagina'; }
  var sykBronVlucht = {};
  var sykBronTimer = null;
  function sykVervangLijst() {
    if (!sykBronPagina() || !ls) return;
    var inp0 = zoekInput();
    var q = String((inp0 && inp0.value) || '').trim();
    if (!q) return;
    var ul0 = ls.querySelector('.syk-lsu');
    if (!ul0) return; /* niets-gevonden-staat heeft geen lijst: ongemoeid laten */
    var sleutel = q.toLowerCase();
    if (ul0.getAttribute('data-syk-q') === sleutel) return; /* al vervangen voor deze term */
    /* wachten tot het typen even stilvalt: het thema hertekent per letter, en zonder rem zou dat
       per toetsaanslag een zoekopdracht kosten */
    clearTimeout(sykBronTimer);
    sykBronTimer = setTimeout(function () {
      /* dezelfde term als de knop 'Bekijk alle resultaten' (met ster), anders zou de lijst alsnog
         van de pagina kunnen afwijken — de ster is daar dragend: 'legerpak' geeft 5 resultaten
         zonder ster en 72 met */
      var term = sykSterTerm(q);
      var url = '/search?q=' + encodeURIComponent(term) + '&section_id=syk-zoekresultaten';
      if (!sykBronVlucht[sleutel]) {
        sykBronVlucht[sleutel] = fetch(url, { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
        /* geheugen begrenzen: de map groeit anders een hele sessie door */
        var namen = Object.keys(sykBronVlucht);
        if (namen.length > 40) delete sykBronVlucht[namen[0]];
      }
      sykBronVlucht[sleutel].then(function (html) {
        if (!html || !ls) return;
        var inpN = zoekInput();
        if (String((inpN && inpN.value) || '').trim().toLowerCase() !== sleutel) return; /* term inmiddels gewijzigd */
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var nieuw = tmp.querySelector('ul.syk-lsu');
        if (!nieuw || !nieuw.children.length) return; /* geen bruikbare treffers: predictive-lijst laten staan */
        var huidig = ls.querySelector('.syk-lsu');
        if (!huidig || !huidig.parentNode) return;
        nieuw.setAttribute('data-syk-q', sleutel);
        huidig.parentNode.replaceChild(nieuw, huidig);
        /* de tweeling-samenvoeging (ninjazwaard <-> ninja zwaard) uitzetten op deze wrap: die zou
           predictive-rijen terugmengen in een lijst die juist exact de pagina moet zijn. De
           zoekpagina vangt samenstellingen zelf al af via de ster. */
        var wrapB = ls.querySelector('.syk-ls');
        if (wrapB) wrapB.setAttribute('data-syk-comp', '1');
        /* de waarnemer kijkt alleen naar directe kinderen van #livesearch, dus een vervanging
           dieper in de boom komt daar niet binnen: verrijking (levertijden, plusknop, labels)
           hier zelf opnieuw aftrappen. Herhaling is veilig, want de poort hierboven stopt meteen. */
        naInjectie();
      });
    }, 220);
  }
  function naInjectie() {
    try { window.dispatchEvent(new CustomEvent('fetchDeliverytimes')); } catch (e) {}
    if (!ls) return;
    /* iOS-fix (melding eigenaar 22-07): de mobiele modal-max-height rekende met een vaste 125px
       top-offset; op het fullscreen-zoekscherm staat de modal lager en viel de sticky CTA-knop
       onder de viewport. Echte top hier meten en als CSS-var doorgeven (zie syk-search.css).
       Gezond-verstand-band (v2): een meting van 0 (nog geen layout) of extreem laag (>55% van het
       scherm) zou de scroll-box respectievelijk te hoog of piepklein maken — dan de oude 125px. */
    meetLsTop();
    sykVervangLijst(); /* instelling 'Bron van de productlijst' = pagina: lijst gelijktrekken met de resultatenpagina */
    /* collectie-chips in de MODAL rangschikken (melding eigenaar 14-07: 'de collecties in de search-
       modal wijken af en zijn willekeurig') — het thema levert ze in Shopify's ruwe relevantie; hier
       dezelfde ranking als op de resultatenpagina. Vóór de merge, en sykMergeChips herhaalt hem daarna. */
    var wrapC = ls.querySelector('.syk-ls');
    var inpC = zoekInput();
    if (wrapC && inpC) { sykRangeerChips(wrapC, inpC.value); sykModalCats(wrapC, inpC.value); }
    /* levertijd in suggest-rijen: snelste over alle leverbare maten (eigen bulk, niet de thema-vuller) */
    sykCompMerge(); /* samenstellingen: tweeling-schrijfwijze (ninjazwaard <-> ninja zwaard) stil mee-mengen */
    var geen = ls.querySelector('.syk-ls-geen');
    if (geen) {
      sykDymToon(geen);
      /* cart-beslissing pas op een VERSE snapshot (review #1: bij trage /cart.js besliste dit pad
         eenmalig 'geen cart' en corrigeerde nooit); appends binnen het paneel triggeren de
         childList-observer niet, dus async beslissen is hier veilig en idempotent */
      sykCartHaal().then(function () {
        if (!geen.isConnected) return;
        var cmG = sykCartModus();
        if (cmG) vulCartLook(geen); /* ook bij een tikfout mét gevulde cart: stuur op afmaken van de look */
        if (cmG !== 'focus') vulTrending(geen);
      });
    }
    var dspans = [].slice.call(ls.querySelectorAll('.syk-lsp-deliv[data-syk-skus]:not([data-syk-klaar])'));
    if (dspans.length) {
      var items2 = [], gezien = {};
      dspans.forEach(function (sp) {
        sp.setAttribute('data-syk-klaar', '1');
        String(sp.getAttribute('data-syk-skus') || '').split(',').forEach(function (sku) {
          if (sku && !gezien[sku]) { gezien[sku] = 1; items2.push({ sku: sku, quantity: 1, available: true }); }
        });
      });
      if (items2.length) {
        bulkHaal(items2).then(function (dmap) {
          dspans.forEach(function (sp) {
            var v = sykLeverInfo(dmap, String(sp.getAttribute('data-syk-skus') || '').split(','), true);
            if (v) { sp.textContent = v.t; if (v.laat) sp.classList.add('syk-lsp-deliv--laat'); }
          });
        });
      }
    }
    var x = ls.querySelector('.syk-ls-xsell');
    var eerste = ls.querySelector('.syk-lsp[data-pid]');
    if (x && eerste && !x.getAttribute('data-syk-klaar')) {
      x.setAttribute('data-syk-klaar', '1');
      fetch('/recommendations/products.json?product_id=' + eerste.getAttribute('data-pid') + '&limit=4&intent=complementary', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var ps = (d && d.products) || [];
          if (!ps.length) return;
          var rail = x.querySelector('.syk-ls-xrail'); if (!rail) return;
          rail.innerHTML = ps.map(function (p) {
            var img = (p.featured_image || (p.images && p.images[0]) || '');
            return '<a class="syk-ls-xkaart" href="' + p.url + '">' +
              (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
              '<b>' + (p.title || '') + '</b><span>' + geldEUR(p.price) + '</span></a>';
          }).join('');
          x.hidden = false;
        })
        .catch(function () {});
    }
  }
  /* ---- recente zoekopdrachten (localStorage) + recent bekeken in de lege staat ---- */
  var RS_KEY = 'sykRecentSearch';
  var sykLsTimers = []; /* uitgestelde lege-staat-openers: cancelbaar (adversarial #3: de +450ms-naslag heropende de overlay na sluiten) */
  function sykLsPlan(fn, ms) { sykLsTimers.push(setTimeout(fn, ms)); }
  function sykLsCancel() { sykLsTimers.forEach(clearTimeout); sykLsTimers = []; }
  var sykNavigeert = false; /* thema wist het zoekveld bij enter -> zonder vlag klapte onze lege staat open tijdens het laden */
  function leesRecent() {
    try {
      var ruw = JSON.parse(localStorage.getItem(RS_KEY) || '[]');
      var uit = [];
      ruw.forEach(function (x) { var t2 = String(x).replace(/\*+$/, '').trim(); if (t2 && uit.indexOf(t2) < 0) uit.push(t2); });
      return uit;
    } catch (e) { return []; }
  }
  function bewaarZoekterm(term) {
    term = String(term || '').replace(/\*+$/, '').trim();
    if (term.length < 3) return;
    var l = leesRecent().filter(function (x) { return x.toLowerCase() !== term.toLowerCase(); });
    l.unshift(term);
    try { localStorage.setItem(RS_KEY, JSON.stringify(l.slice(0, 6))); } catch (e) {}
  }
  /* dag-cache (sessionStorage): herhaalweergaven tonen leverdata/kaartdata direct; dagstempel
     voorkomt bevroren leverdagen over de 23:59-grens (zelfde les als de upsell-cache) */
  var DAG = (function () { var d = new Date(); return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); })();
  function cacheLees(key) { try { var raw = JSON.parse(sessionStorage.getItem(key) || 'null'); return (raw && raw.d === DAG) ? raw.v : null; } catch (e) { return null; } }
  function cacheSchrijf(key, v) { try { sessionStorage.setItem(key, JSON.stringify({ d: DAG, v: v })); } catch (e) {} }
  var pCache = {};
  function haalProduct(h) {
    if (!pCache[h]) {
      var uitCache = cacheLees('sykP:' + h);
      if (uitCache) { pCache[h] = Promise.resolve(uitCache); }
      else {
        pCache[h] = fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p2) {
            if (!p2) return null;
            var slank = { title: p2.title, url: p2.url, price: p2.price, price_min: p2.price_min, price_max: p2.price_max, featured_image: p2.featured_image, available: p2.available, options: p2.options,
              variants: (p2.variants || []).map(function (v) { return { title: v.title, options: v.options, available: v.available, sku: v.sku, barcode: v.barcode, id: v.id }; }) };
            cacheSchrijf('sykP:' + h, slank);
            return slank;
          })
          .catch(function () { return null; });
      }
    }
    return pCache[h];
  }
  function esc(x) { return String(x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  /* ---- typtolerantie 'Bedoelde je …?' (wens eigenaar 09-07: 'piraadje' vond piraten niet) ----
     woordenboek uit eigen winkel-data: collectie-handles (menustructuur), populaire zoektermen,
     thema-namen, eigen extra termen (setting) en — zodra geladen — trending-collectietitels.
     Matcher = begrensde Damerau-Levenshtein PLUS voorvoegsel-regel + verkleinwoord-stam
     ('piraadje' -> stam 'piraad' -> voorvoegsel 'pira' op 'piraten'), want kale edit-afstand
     mist juist de typische NL-tikfouten. Een kandidaat wordt pas getoond nadat suggest.json
     bevestigt dat de term echt resultaten heeft (max 3 kandidaten, dag-cache). */
  var sykDymDict = null;
  function sykDymVoeg(kaart, term, gewicht) {
    term = String(term || '').trim();
    if (term.length < 4 || /^\d+$/.test(term)) return;
    var k = term.toLowerCase();
    if (!kaart[k] || gewicht > kaart[k].g) kaart[k] = { t: term, g: gewicht };
  }
  function sykDymBouw() {
    if (sykDymDict) return sykDymDict;
    var kaart = {};
    (D.menu || []).forEach(function (u) {
      var m = String(u || '').split('?')[0].match(/\/collections\/([^\/?#]+)\/?$/);
      if (!m) return;
      var delen = m[1].split('-').filter(function (w) { return w.length >= 4 && !/^\d+$/.test(w); });
      delen.forEach(function (w) { sykDymVoeg(kaart, w, 2); });
      if (delen.length > 1) sykDymVoeg(kaart, delen.join(' '), 1);
    });
    String(D.pop || '').split(',').forEach(function (t2) { sykDymVoeg(kaart, t2, 3); });
    String(D.themas || '').split(/\r?\n/).forEach(function (r) { var d2 = r.split('|'); if (d2 && d2[1]) sykDymVoeg(kaart, d2[1], 2); });
    String(D.dymExtra || '').split(/[,;\r\n]+/).forEach(function (t2) { sykDymVoeg(kaart, t2, 4); });
    sykDymDict = kaart;
    /* trending-collectietitels verrijken het woordenboek, maar ALLEEN als de data er al is
       (review #12: zelf de fetch starten kost een zware sectie-render op elke 0-resultatenpagina
       terwijl het antwoord toch te laat komt voor de suggestie van dat moment) */
    function meng(data) {
      if (!data || !data.producten) return;
      data.producten.forEach(function (d) {
        (d.collecties || []).forEach(function (c) {
          if (!c || !c.t) return;
          String(c.t).split(/\s+/).forEach(function (w) { sykDymVoeg(kaart, w, 2); });
          sykDymVoeg(kaart, c.t, 1);
        });
      });
    }
    var warm = cacheLees('sykTrend');
    if (warm) meng(warm);
    else if (trendCache) trendCache.then(meng);
    return kaart;
  }
  function sykDymAfstand(a, b, cap) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > cap) return cap + 1;
    var vorige = [], voorvorige = [], rij, i, j;
    for (j = 0; j <= lb; j++) vorige[j] = j;
    for (i = 1; i <= la; i++) {
      rij = [i];
      var beste = i;
      for (j = 1; j <= lb; j++) {
        var kost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        var v = Math.min(vorige[j] + 1, rij[j - 1] + 1, vorige[j - 1] + kost);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) v = Math.min(v, voorvorige[j - 2] + 1);
        rij[j] = v;
        if (v < beste) beste = v;
      }
      if (beste > cap) return cap + 1;
      voorvorige = vorige; vorige = rij;
    }
    return vorige[lb];
  }
  function sykDymPrefix(a, b) { var n = Math.min(a.length, b.length), i = 0; while (i < n && a.charAt(i) === b.charAt(i)) i++; return i; }
  function sykDymKandidaten(q) {
    q = String(q || '').replace(/\*+$/, '').trim().toLowerCase();
    if (D.dym === false || q.length < 4 || /\d/.test(q)) return [];
    var stam = q.replace(/(tje|dje|pje|kje|je)$/, '');
    if (stam.length < 4) stam = q;
    var dict = sykDymBouw();
    if (dict[q]) return []; /* term bestaat letterlijk in het woordenboek -> geen correctie */
    var uit = [];
    for (var k in dict) {
      var beste = null;
      var vormen = stam === q ? [q] : [q, stam];
      for (var vi = 0; vi < vormen.length; vi++) {
        var vorm = vormen[vi];
        var doelen = k.indexOf(' ') > -1 ? [k, k.split(' ')[0]] : [k];
        for (var di = 0; di < doelen.length; di++) {
          var doel = doelen[di];
          if (doel.length < 4) continue;
          var d = sykDymAfstand(vorm, doel, 3);
          var p = sykDymPrefix(vorm, doel);
          var score = -1;
          if (d <= 1) score = 100 - d;
          else if (d === 2 && Math.min(vorm.length, doel.length) >= 5) score = 88;
          else if (p >= 4 && p >= Math.ceil(vorm.length * 0.55)) score = 60 + p * 3 - d;
          if (score < 0) continue;
          score += dict[k].g * 2 - vi; /* eigen termen > populaire termen > handle-woorden; stam-match telt ietsje minder */
          if (di === 1) score -= 3; /* match op alleen het eerste woord van een meerwoordige term: het kale woord wint ('hawaai' -> 'hawaii', niet 'hawaii slinger') */
          if (!beste || score > beste.s) beste = { t: dict[k].t, s: score };
        }
      }
      if (beste) uit.push(beste);
    }
    uit.sort(function (a, b) { return b.s - a.s; });
    var gezien = {}, top = [];
    uit.forEach(function (c) { var k2 = c.t.toLowerCase(); if (!gezien[k2] && k2 !== q) { gezien[k2] = 1; top.push(c.t); } });
    return top.slice(0, 3);
  }
  var sykDymVluchten = {};
  function sykDymCheck(term) {
    var key = 'sykDym:' + term.toLowerCase();
    var uitCache = cacheLees(key);
    if (uitCache !== null) return Promise.resolve(uitCache);
    if (sykDymVluchten[key]) return sykDymVluchten[key]; /* zelfde kandidaat tijdens typen: 1 fetch */
    sykDymVluchten[key] = fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,collection&resources[limit]=1', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d === null) { delete sykDymVluchten[key]; return false; } /* HTTP-fout (429/5xx): NIET dag-cachen als 'geen resultaten' */
        var rs = d.resources && d.resources.results;
        var ok = !!(rs && ((rs.products && rs.products.length) || (rs.collections && rs.collections.length)));
        cacheSchrijf(key, ok);
        return ok;
      })
      .catch(function () { delete sykDymVluchten[key]; return false; });
    return sykDymVluchten[key];
  }
  function sykDymZoek(q) {
    var ks = sykDymKandidaten(q);
    /* samenstellings-splitsing als STERKSTE kandidaat vooraan (bv. 'rood ninjapak' -> 'rood ninja
       pak'): zelfde query met een compound-woord gesplitst, geverifieerd via sykDymCheck */
    var comp = sykCompound(q);
    if (comp && ks.indexOf(comp) < 0) ks.unshift(comp);
    if (!ks.length) return Promise.resolve(null);
    var i = -1;
    function volgende() {
      i++;
      if (i >= ks.length) return Promise.resolve(null);
      return sykDymCheck(ks[i]).then(function (ok) { return ok ? ks[i] : volgende(); });
    }
    return volgende();
  }
  function sykDymToon(geen) {
    if (D.dym === false || !geen || geen.getAttribute('data-syk-dym')) return;
    geen.setAttribute('data-syk-dym', '1');
    var inp = zoekInput();
    var q = inp ? inp.value : '';
    if (!String(q).trim()) {
      var mk = geen.querySelector('.syk-ls-geenkop');
      var mm = mk && mk.textContent.match(/[‘']([^’']+)[’']/);
      q = mm ? mm[1] : '';
    }
    sykDymZoek(q).then(function (term) {
      if (!term || !geen.isConnected || geen.querySelector('.syk-ls-dym')) return;
      var p = document.createElement('p');
      p.className = 'syk-ls-dym';
      p.innerHTML = esc(D.tDym || 'Bedoelde je') + ' <a class="syk-dym-term" href="/search?q=' + encodeURIComponent(sykSterTerm(term)) + '" data-syk-sug="' + esc(term) + '">' + esc(term) + '</a>?';
      var kop = geen.querySelector('.syk-ls-geenkop');
      if (kop && kop.parentNode) kop.parentNode.insertBefore(p, kop.nextSibling);
      else geen.insertBefore(p, geen.firstChild);
    });
  }
  /* ---- ZERO-RESULT-RADAR (golf 1, wens eigenaar 14-07): zoek-gebeurtenissen naar GA/Elevar via de
     bestaande dataLayer. Alleen op de VOLLE resultatenpagina (niet in de suggest: die vuurt per
     toetsaanslag = ruis). Query getruncat op 80 tekens, lowercase, nooit aan een gebruiker gekoppeld.
     Events: syk_actie 'nul' (definitief dood spoor), 'herstel' (auto-Bedoelde-je toegepast),
     'dym' (link getoond), 'dym_klik', 'intent' (prijs/doelgroep-vertaling). Opt-out: syk_search_radar. */
  function sykRadar(actie, data) {
    if (D.radar === false) return;
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: 'syk_zoek', syk_actie: actie };
      if (data) { for (var k in data) { o['syk_' + k] = String(data[k]).toLowerCase().slice(0, 80); } }
      window.dataLayer.push(o);
    } catch (e) {}
  }
  /* ---- PRIJS/DOELGROEP-INTENT (golf 1): 'goedkoop ninjapak' -> sorteer laag-hoog; 'onder 20 euro' ->
     prijsfilter; 'piratenpak dames' -> doelgroep-token (filter-match gebeurt runtime tegen het native
     formulier op de resultatenpagina). Zelfde strip-patroon als de kleur-strip. Getallen tellen alleen
     als prijs mét euroteken/euro-woord of <=90 (maten beginnen bij 92 — geen botsing met maat-query's). */
  function sykIntent(q) {
    var res = { kern: '', sort: '', lte: 0, groep: '' };
    var s = ' ' + String(q || '').toLowerCase().replace(/\s+/g, ' ').trim() + ' ';
    if (/ (goedkoop|goedkope|goedkoopste|budget|voordelig|voordelige) /.test(s)) {
      res.sort = 'price-ascending';
      s = s.replace(/ (goedkoop|goedkope|goedkoopste|budget|voordelig|voordelige) /g, ' ');
    }
    /* review-fix 14-07: 'tot 12 jaar' / 'tot 6 personen' is een LEEFTIJD/AANTAL, geen prijs — het getal
       telt alleen als prijs wanneer er GEEN eenheidswoord op volgt (negative lookahead). */
    var pm = s.match(/ (?:onder|tot|max(?:imaal)?) (?:de )?(?:€ ?)?(\d{1,3})( ?(?:euro|eur|€))? (?!(?:jaar|jr|jarigen?|personen|pers|maanden|mnd|cm|delig|dlg|stuks|st|uur|man|kids|weken|dagen) )/);
    if (pm) {
      var bedrag = parseInt(pm[1], 10);
      if (bedrag > 0 && (pm[2] || bedrag <= 90)) { res.lte = bedrag; s = s.replace(pm[0], ' '); }
    }
    var gm = s.match(/ (dames|heren|vrouwen|mannen|jongens|jongen|meisjes|meisje) /);
    if (gm) { res.groep = gm[1]; } /* strippen gebeurt pas als er echt een filteroptie voor bestaat */
    res.kern = s.replace(/\s+/g, ' ').trim();
    return (res.sort || res.lte || res.groep) && res.kern ? res : null;
  }
  /* stam-vormen voor de doelgroep-match tegen de filteropties (Dames/Heren/Meisjes/Jongens) */
  var SYK_GROEP_STAM = { dames: 'dame', vrouwen: 'dame', heren: 'here', mannen: 'here', jongens: 'jongen', jongen: 'jongen', meisjes: 'meisje', meisje: 'meisje' };
  /* ---- DOELGROEP-FILTERS ONTHOUDEN (09-08, melding eigenaar: 'het duurt even en dan herlaadt de
     pagina' bij 'piraten kostuum dames') ----
     De intent-vertaling draaide PAS op de resultatenpagina: die laadde eerst volledig (gemeten ~1,2 s
     en ~1 MB), waarna wij 'dames' uit de query haalden, er een filter van maakten en met
     location.replace de pagina NÓG een keer lieten laden. Twee keer betalen dus, met een zichtbare
     herlading ertussen.
     De enige reden dat het niet meteen bij Enter kon, is dat we de naam van de filter-checkbox alleen
     uit de DOM van een resultatenpagina kennen. Die onthouden we nu: elke resultaten- of
     collectiepagina schrijft de gevonden koppeling weg, en bij de volgende zoekopdracht bouwen we de
     definitieve url meteen — één lading.
     Koud geheugen (allereerste keer) = precies het oude gedrag, dus nooit slechter. De filternamen van
     deze winkel zijn stabiel (filter.p.m.lightspeed.filters_116127) maar worden bij elke
     resultatenpagina ververst, dus een hernoeming corrigeert zichzelf. */
  var SYK_GROEPCACHE = 'sykGroepFilters';
  function sykGroepCacheLees() {
    try { return JSON.parse(localStorage.getItem(SYK_GROEPCACHE) || '{}') || {}; } catch (e) { return {}; }
  }
  function sykGroepCacheVul() {
    var vakjes = document.querySelectorAll('form.f8fl input[type="checkbox"]');
    if (!vakjes.length) return;
    var map = sykGroepCacheLees(), veranderd = false;
    [].forEach.call(vakjes, function (i2) {
      if (!i2.name) return;
      var li2 = i2.closest ? i2.closest('li') : null;
      var lbl2 = String((li2 ? li2.textContent : i2.value) || '').replace(/\s+/g, ' ').trim().toLowerCase();
      for (var g in SYK_GROEP_STAM) {
        if (lbl2.indexOf(SYK_GROEP_STAM[g]) !== 0) continue;
        if (!map[g] || map[g].n !== i2.name || map[g].v !== i2.value) { map[g] = { n: i2.name, v: i2.value }; veranderd = true; }
      }
    });
    if (veranderd) { try { localStorage.setItem(SYK_GROEPCACHE, JSON.stringify(map)); } catch (e2) {} }
  }
  /* bouwt de DEFINITIEVE zoek-url voor een ingetikte term: de kern-query plus de sorteer-, prijs- en
     doelgroep-vertaling in één keer. Kunnen we de doelgroep niet omzetten (nog niets onthouden), dan
     blijft dat woord gewoon in de query staan en doet de resultatenpagina het alsnog zoals voorheen. */
  function sykZoekUrl(term) {
    var basis = '/search?q=';
    term = String(term || '').trim();
    if (!term) return basis;
    var it = D.intent === false ? null : sykIntent(term.replace(/\*+$/, ''));
    if (!it) return basis + encodeURIComponent(sykSterTerm(term));
    var extra = [], kern = it.kern;
    if (it.sort) extra.push('sort_by=' + encodeURIComponent(it.sort));
    if (it.lte) extra.push('filter.v.price.lte=' + encodeURIComponent(String(it.lte)));
    if (it.groep) {
      var onthouden = sykGroepCacheLees()[it.groep];
      if (onthouden && onthouden.n) {
        extra.push(encodeURIComponent(onthouden.n) + '=' + encodeURIComponent(onthouden.v));
        kern = kern.replace(new RegExp('(^| )' + it.groep + '( |$)', 'g'), ' ').replace(/\s+/g, ' ').trim();
      }
    }
    if (!extra.length || !kern) return basis + encodeURIComponent(sykSterTerm(term));
    /* zelfde vangnet als de pagina-variant: voorkomt dat de doelpagina nóg eens gaat vertalen */
    try { sessionStorage.setItem('sykIntentBlok', kern); } catch (e3) {}
    return basis + encodeURIComponent(sykSterTerm(kern)) + '&' + extra.join('&');
  }
  /* ---- GEDEELDE COLLECTIE-RANKING (wens eigenaar 14-07). Volgorde: (1) titel bevat de query als LOS
     WOORD, (2) titelwoord EINDIGT op de query — de samenstelling ('Boerenzakdoek' bij 'zakdoek'),
     (3) de rest. Binnen dezelfde rang: KORTERE titel eerst (de generieke hoofdcollectie 'Bandanas'
     vóór de verdiepingen 'Bruine bandana'), daarna pas de menuvolgorde. TOP-LEVEL zodat zowel de
     resultatenpagina (bouwCatsRail) als de SUGGEST-MODAL hem gebruikt: de chips daar komen uit de
     thema-sectie en stonden dus nog in Shopify's ruwe relevantie ('willekeurig'). ---- */
  /* enkelvoud/meervoud (melding eigenaar 14-07: 'masker' toonde de HOOFDcollectie "Maskers" niet):
     de woord-match eiste een niet-letter ná de term, maar bij "Maskers" volgt een 's' — de hoofd-
     collectie zakte daardoor onder de sub-collecties ("Ninja masker"). Nu telt een meervouds-uitgang
     (s/en/es) mee, en zoeken we óók op de stam, zodat 'maskers' net zo goed op "Masker" matcht. */
  function sykStam(w) {
    w = String(w || '').toLowerCase().trim();
    var s;
    if (/en$/.test(w) && w.length - 2 >= 3) s = w.slice(0, -2);
    else if (/s$/.test(w) && w.length - 1 >= 4) s = w.slice(0, -1);
    else return w;
    /* NL dubbele medeklinker: 'pakken' -> 'pakk' -> 'pak'; 'maskers' -> 'masker' (ongemoeid) */
    if (s.length >= 4 && /([bcdfgklmnprstv])\1$/.test(s)) s = s.slice(0, -1);
    return s.length >= 3 ? s : w;
  }
  /* meervouds-uitgangen die op een titel mogen volgen — inclusief de NL medeklinker-verdubbeling
     ('pak' -> 'pakken'), zodat de hoofdcollectie "Pakken" bij 'pak' als woord-match telt */
  function sykMeervoud(w) {
    var laatste = w.slice(-1);
    var dub = /[bcdfgklmnprstv]/.test(laatste) ? '|' + laatste + 'en' : '';
    return '(s|en|es' + dub + ')?';
  }
  function sykColVormen(q) {
    var uit = [];
    [String(q || '').toLowerCase().trim(), sykStam(q)].forEach(function (w) { if (w && uit.indexOf(w) < 0) uit.push(w); });
    return uit;
  }
  function sykColCmp(q) {
    var res = sykColVormen(q).map(function (w) {
      var e = w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var mv = sykMeervoud(w);
      return {
        woord: new RegExp('(^|[^a-zà-ÿ])' + e + mv + '([^a-zà-ÿ]|$)'),
        samen: new RegExp('[a-zà-ÿ]' + e + mv + '([^a-zà-ÿ]|$)')
      };
    });
    var volgorde = D.menu || [];
    var doelH = sykRegelHandle(q); /* zoekregel-doel: altijd bovenaan (rang -1); '' zolang de regels niet geladen zijn */
    function rang(t, u) {
      if (doelH && String(u || '').split('?')[0].replace(/\/+$/, '').split('/').pop() === doelH) return -1;
      t = String(t || '').toLowerCase();
      for (var i = 0; i < res.length; i++) { if (res[i].woord.test(t)) return 0; }
      for (var j = 0; j < res.length; j++) { if (res[j].samen.test(t)) return 1; }
      return 2;
    }
    return function (aT, aU, bT, bU) {
      var r = rang(aT, aU) - rang(bT, bU); if (r) return r;
      var l = String(aT || '').length - String(bT || '').length; if (l) return l;
      var ia = volgorde.indexOf(String(aU || '').split('?')[0]), ib = volgorde.indexOf(String(bU || '').split('?')[0]);
      return (ia < 0 ? volgorde.length : ia) - (ib < 0 ? volgorde.length : ib);
    };
  }
  /* ---- SAMENSTELLINGS-COLLECTIES (melding eigenaar 14-07: 'Boerenzakdoek' kwam niet terug bij
     'zakdoek', ook niet met een beschrijving). LIVE VASTGESTELD: Shopify's suggest matcht collecties
     ALLEEN op de TITEL — beschrijvingen worden niet geïndexeerd (test: 'knapzak' en
     'teambuildingsactiviteiten' staan wél in de Boerenzakdoek-beschrijving en geven 0 collecties).
     En 'zakdoek' matcht niet op 'Boerenzakdoek', want Shopify matcht per woord en 'zakdoek' is geen
     begin van dat woord — exact dezelfde NL-samenstellings-crux als 'ninjapak'.
     Oplossing zonder admin-werk: de menustructuur (D.menu) bevat alle collectie-paden. Zoek daarin de
     handles die op de zoekterm EINDIGEN en waar een LETTER aan voorafgaat (boeren|zakdoek = een echte
     samenstelling; 'ninja-pak' heeft een streepje en wordt door Shopify zelf al gevonden). Die handles
     bevragen we expliciet — dan levert de suggest ze mét titel en foto. De ranking (sykColCmp) zet ze
     daarna op rang 1, dus vóór de generieke/kleur-collecties. ---- */
  function sykCompoundHandles(q) {
    var uit = [];
    q = String(q || '').toLowerCase().trim();
    if (q.length < 4 || /\s/.test(q)) return uit; /* alleen één heel woord: samenstellingen zijn woorddelen */
    /* óók op de stam zoeken + meervoud toestaan, zodat 'maskers' dezelfde samenstellingen vindt
       als 'masker' (olifantenmasker/paardenmaskers) */
    var res = sykColVormen(q).map(function (w) {
      return new RegExp('[a-z0-9à-ÿ]' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + sykMeervoud(w) + '$');
    });
    var menu = D.menu || [];
    for (var i = 0; i < menu.length && uit.length < 3; i++) {
      var m = String(menu[i] || '').match(/\/collections\/([^\/?#]+)/);
      if (!m) continue;
      var h = m[1].toLowerCase();
      if (h === q) continue;
      var raak = false;
      for (var j = 0; j < res.length; j++) { if (res[j].test(h)) { raak = true; break; } }
      if (!raak) continue;
      var term = h.replace(/-/g, ' ');
      if (uit.indexOf(term) < 0) uit.push(term);
    }
    return uit;
  }
  /* ---- ZOEKREGELS (wens eigenaar 17-07): geaccordeerde synoniemen -> doelcollectie. Bron:
     shop.metafields.syk.zoekregels = file_reference naar een CDN-JSON {v,cols:{handle:[termen]}}
     (3.669 termen, elk vooraf live geverifieerd als gat in de zoekfunctie). De URL bevat een
     ?v=-versie, dus één fetch per versie en daarna localStorage — nooit op het kritieke pad.
     Effect (sinds 21-07 'stil als een echt synoniem'): (1) de suggest toont de doelcollectie-
     producten direct (tweeling-mechaniek in sykCompMerge) en de collectie staat als eerste chip
     (rang -1), (2) Enter/0-resultaten gaan geluidloos naar de doelcollectie — geen banner. ---- */
  var sykRegelMap = null, sykRegelBelofte = null;
  function sykRegelNorm(s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function sykRegels() {
    if (sykRegelBelofte) return sykRegelBelofte;
    var url = D.zoekregels;
    if (!url) { sykRegelMap = {}; sykRegelBelofte = Promise.resolve(sykRegelMap); return sykRegelBelofte; }
    var sleutel = 'sykZR:' + url;
    try {
      var raw = JSON.parse(localStorage.getItem(sleutel) || 'null');
      if (raw && raw.m) { sykRegelMap = raw.m; sykRegelBelofte = Promise.resolve(sykRegelMap); return sykRegelBelofte; }
    } catch (e) {}
    sykRegelBelofte = fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d2) {
        /* review-fix 17-07 (2x): een storing (429/5xx/onzin-antwoord) NOOIT cachen én sykRegelMap
           op null LATEN — null betekent overal 'niet geladen', zodat ook de dag-cache-guard in
           sykColsVoor een storing niet als 'geladen' aanziet */
        if (!d2 || !d2.cols || typeof d2.cols !== 'object') return {};
        var m = {}, cols = d2.cols;
        for (var h in cols) {
          var ts = cols[h] || [];
          for (var i = 0; i < ts.length; i++) { var t = sykRegelNorm(ts[i]); if (t && !m[t]) m[t] = h; }
        }
        sykRegelMap = m;
        try {
          /* oude versies opruimen (de URL verandert per upload), dan de nieuwe bewaren */
          for (var k = localStorage.length - 1; k >= 0; k--) { var n = localStorage.key(k); if (n && n.indexOf('sykZR:') === 0 && n !== sleutel) localStorage.removeItem(n); }
          localStorage.setItem(sleutel, JSON.stringify({ m: m }));
        } catch (e2) {}
        return m;
      })
      .catch(function () { return {}; }); /* netwerkfout: map blijft null = 'niet geladen' */
    return sykRegelBelofte;
  }
  /* regels mét tijdslimiet: de suggest/het herstel-pad mag NOOIT blijven hangen op een trage
     CDN-fetch (review-fix 17-07) — na de limiet gewoon door zonder regels, zelfherstellend bij
     de volgende render/paginalading */
  function sykRegelsSnel(ms) {
    return Promise.race([sykRegels(), new Promise(function (res) { setTimeout(res, ms || 600); })]);
  }
  /* synchrone lookup (pas gevuld ná sykRegels()); ook de stam per woord proberen zodat
     'mombakkessen'/'stetsons' de enkelvoud-regel raken */
  function sykRegelHandle(q) {
    if (!sykRegelMap) return '';
    q = sykRegelNorm(q);
    if (!q) return '';
    if (sykRegelMap[q]) return sykRegelMap[q];
    var st = q.split(' ').map(sykStam).join(' ');
    return (st !== q && sykRegelMap[st]) || '';
  }
  function sykHaalCols(term) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=collection&resources[limit]=' + Math.max(D.catsMax || 8, 10), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d2) {
        /* review-fix 17-07: storing = null (niet []), zodat sykColsVoor een onvolledige golf
           kan herkennen en zo'n set niet dag-cachet (doelchip zou anders een dag ontbreken) */
        if (!d2) return null;
        return ((d2.resources && d2.resources.results && d2.resources.results.collections) || []).map(function (c) {
          return { title: c.title, url: c.url, img: (c.featured_image && c.featured_image.url) ? c.featured_image.url : '' };
        });
      })
      .catch(function () { return null; });
  }
  /* ÉÉN bron voor de collectie-chips (modal + resultatenpagina): query + compound-tweeling
     ('ninjazwaard' -> 'ninja zwaard') + kleur-gestripte kern ('rood ninjapak' -> 'ninja pak') +
     de samenstellings-handles hierboven. Samengevoegd, ontdubbeld op kaal pad, dag-gecachet. */
  var sykColVluchten = {};
  function sykColsVoor(q) {
    q = String(q || '').trim();
    var sleutel = 'sykCats4:' + q.toLowerCase(); /* v4: dag-cache vernieuwd bij invoering zoekregels */
    var uitC = cacheLees(sleutel);
    /* review-fix 17-07: ook op een dag-cache-hit eerst de regels (met tijdslimiet) laden, anders
       mist sykColCmp zijn rang -1 en zakt de doelcollectie-chip weg of trimt hij af */
    if (uitC) return sykRegelsSnel().then(function () { return uitC; });
    if (sykColVluchten[sleutel]) return sykColVluchten[sleutel];
    var termen = [q];
    var tw = sykCompound(q);
    if (tw && termen.indexOf(tw) < 0) termen.push(tw);
    sykKernKandidaten(q).forEach(function (t) { if (termen.indexOf(t) < 0) termen.push(t); });
    sykCompoundHandles(q).forEach(function (t) { if (termen.indexOf(t) < 0) termen.push(t); });
    sykColVluchten[sleutel] = sykRegelsSnel().then(function () {
      /* zoekregel-treffer: de doelcollectie expliciet mee-bevragen, want Shopify's suggest vindt
         hem op het synoniem zelf niet ('mombakkes' matcht 'Maskers' niet) — de handle-woorden wél */
      var rh = sykRegelHandle(q);
      /* TOCTOU-fix 17-07: het 'regels waren geladen'-oordeel HIER vastleggen (bij de termen-opbouw),
         niet pas bij het cache-schrijven — regels die tussen de 600ms-race en de write binnenkomen
         mogen een doelchip-loze set niet alsnog dag-cachebaar maken */
      var regelsWaren = sykRegelMap !== null;
      if (rh) { var rt = rh.replace(/-/g, ' '); if (termen.indexOf(rt) < 0) termen.unshift(rt); }
      return Promise.all(termen.map(sykHaalCols)).then(function (sets) { return { sets: sets, regelsWaren: regelsWaren }; });
    }).then(function (uit) {
      var sets = uit.sets;
      var gezien = {}, cols = [], allesOk = true;
      sets.forEach(function (s) {
        if (s === null) { allesOk = false; return; } /* mislukte suggest-fetch: golf onvolledig */
        s.forEach(function (c) {
          var pad = String(c.url || '').split('?')[0];
          if (pad && !gezien[pad]) { gezien[pad] = 1; cols.push(c); }
        });
      });
      /* review-fix 17-07: alleen dag-cachen als de regels bij de TERMEN-OPBOUW geladen waren ÉN
         alle suggest-fetches slaagden — anders zou een set zónder doelcollectie-chip (bijv. omdat
         precies de doelterm-fetch faalde) de hele dag blijven hangen */
      if (cols.length && uit.regelsWaren && allesOk) cacheSchrijf(sleutel, cols);
      delete sykColVluchten[sleutel];
      return cols;
    }).catch(function () { delete sykColVluchten[sleutel]; return []; });
    return sykColVluchten[sleutel];
  }
  /* ---- weergave categorieën (instelling syk_search_cats_stijl): 'pills' = de compacte knop,
     'tegels' = een wit kaartje met een grote ronde foto boven de naam — dezelfde stijl als het
     Collecties-raster bovenaan een collectiepagina (.syk-subcol-tegel). De opmaak zit VOLLEDIG in
     syk-search.css achter .syk-ls-chips--tegels; de markup van een chip blijft dus ongewijzigd, zodat
     het rangschikken/samenvoegen/afkappen hieronder één op één blijft werken. ---- */
  function sykCatTegels() { return (D.catsStijl || 'pills') === 'tegels'; }
  /* de telling (het bolletje '389') komt ALLEEN uit de server-render: Shopify's suggest.json — waar wij
     de extra categorieën vandaan halen — kent het veld products_count niet eens (live nagekeken 07-08,
     velden: body/featured_image/handle/id/published_at/title/url). Vandaar dat sommige tegels wél en
     andere géén getal hadden (melding eigenaar). Daarom staat de telling standaard UIT: liever overal
     hetzelfde dan half. Aan te zetten met syk_search_cats_tel; dan tonen de tegels die het getal kennen
     het alsnog. De klasse stuurt puur de CSS aan. */
  function sykCatTel() { return D.catsTel === true; }
  function sykCatKlas() {
    return 'syk-ls-chips' + (sykCatTegels() ? ' syk-ls-chips--tegels' : '') + (sykCatTel() ? ' syk-ls-chips--tel' : '');
  }
  /* suggest.json levert de KALE cdn-url — de ORIGINELE collectiefoto, gemeten op deze winkel 19 kB
     tot 497 kB per stuk. Die stond hier in een <img> van 26px (pills) of 64px (tegels), tot 8 stuks
     boven de vouw: megabytes voor niets. Daarom ALTIJD een maat meegeven aan de CDN.
     Review-fix 07-08: dit stond eerst achter een 'alleen in tegel-modus'-poort, waardoor juist de
     STANDAARDweergave (pills) de originelen bleef laden. De maat volgt nu de weergave: pills tonen
     26px, tegels 64px, allebei op dubbele resolutie voor retina. */
  function sykCdnBreedte(u, px) {
    u = String(u || '');
    if (!u) return u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + px);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + px;
  }
  function sykCatImg(u) { return sykCdnBreedte(u, sykCatTegels() ? 128 : 64); }
  /* de MODAL aanvullen met dezelfde collecties als de resultatenpagina (melding eigenaar 14-07: 'de
     collecties in de search-modal wijken af'). Het thema haalt er in de suggest maar ~6 op, wij op de
     resultatenpagina 10 — daardoor miste de hoofdcollectie ('Bandanas' bij 'zakdoek') in de modal.
     Zelfde dag-cache als de resultatenpagina, dus meestal nul extra netwerk. Daarna rangschikken. */
  /* review-fix 07-08: het blok 'Verder zoeken in' (affiniteit) gebruikt DEZELFDE chip-markup en zit in
     de LEGE staat. Zonder poort kan een querySelector('.syk-ls-chips') die rij te pakken krijgen en er
     de categorieën van de half getypte zoekterm in schuiven. Zelfde patroon als sykCompMerge (r. ~1078). */
  function sykCatBox(wrap) {
    if (!wrap || !wrap.querySelector) return null;
    if (wrap.classList && wrap.classList.contains('syk-ls-leeg')) return null;
    var b = wrap.querySelector('.syk-ls-chips');
    if (b && b.closest && (b.closest('.syk-ls-affiniteit') || b.closest('.syk-ls-leeg'))) return null;
    return b;
  }
  function sykModalCats(wrap, q) {
    q = String(q || '').trim();
    if (!q || D.cats === false || !wrap || !wrap.querySelector) return;
    if (wrap.classList && wrap.classList.contains('syk-ls-leeg')) return;
    var box = sykCatBox(wrap);
    if (box && box.getAttribute('data-syk-cats') === q.toLowerCase()) return; /* al aangevuld voor deze query */
    function vul(cols) {
      if (!cols || !cols.length || !wrap.isConnected) return;
      if (!box || !box.isConnected) {
        /* review-fix 17-07: het thema rendert GEEN categorieën-rail als de suggest 0 collecties
           vond — precies het normale geval bij een zoekregel-synoniem ('lasso' -> Cowboy
           accessoires). Bouw kop+rail dan zelf, op de vaste plek direct na de term-regel; alleen
           binnen onze eigen modal-markup (.syk-ls-term aanwezig), dus drawer/variant C ongemoeid. */
        box = sykCatBox(wrap);
        if (!box) {
          var term0 = wrap.querySelector('.syk-ls-term');
          if (!term0 || !term0.parentNode) return;
          var kopC = document.createElement('p');
          kopC.className = 'syk-ls-kop';
          kopC.textContent = D.tCats || 'Categorieën';
          box = document.createElement('div');
          box.className = sykCatKlas();
          term0.parentNode.insertBefore(box, term0.nextSibling);
          term0.parentNode.insertBefore(kopC, box);
        }
        if (box.getAttribute('data-syk-cats') === q.toLowerCase()) return;
      }
      box.setAttribute('data-syk-cats', q.toLowerCase());
      var heb = {};
      [].forEach.call(box.querySelectorAll('a'), function (a) { heb[String(a.getAttribute('href') || '').split('?')[0]] = 1; });
      /* ALLES eerst toevoegen, dan pas rangschikken en PAS DAARNA afkappen — bij afkappen vooraf viel
         de hoofdcollectie er al af (staat in Shopify's ruwe volgorde vaak achteraan: 'Bandanas' was
         daar #10) voordat de ranking hem naar voren kon halen. */
      /* 07-08: in ÉÉN schrijfactie invoegen (fragment) i.p.v. per chip — scheelt evenzoveel
         her-layouts in de dropdown; zie de flikker-analyse bij sykRangeerChips. */
      var fragN = document.createDocumentFragment();
      cols.forEach(function (c) {
        var pad = String(c.url || '').split('?')[0];
        if (!pad || heb[pad]) return;
        heb[pad] = 1;
        var a2 = document.createElement('a');
        a2.className = 'syk-ls-chip';
        a2.setAttribute('href', c.url);
        /* geen foto: de beginletter als terugval, net als de collectietegels op een collectiepagina
           (CSS leest hem via content:attr(data-letter)) — anders staat er een leeg grijs rondje */
        if (!c.img) a2.setAttribute('data-letter', String(c.title || '?').trim().charAt(0).toUpperCase());
        a2.innerHTML = (c.img ? '<img src="' + esc(sykCatImg(c.img)) + '" alt="" loading="lazy">' : '') + '<span>' + esc(c.title) + '</span>';
        fragN.appendChild(a2);
      });
      var erbij = fragN.childNodes.length;
      if (erbij) box.appendChild(fragN);
      sykRangeerChips(wrap, q);
      var maxC = D.catsMax || 8;
      var afgekapt = 0;
      while (box.children.length > maxC && box.lastElementChild) { box.removeChild(box.lastElementChild); afgekapt++; }
      /* review-fix 07-08: alleen terug naar het begin als de rij ECHT veranderde. Stond deze reset
         onvoorwaardelijk, dan werd de bezoeker die net door de categorieën veegt alsnog teruggezet
         zodra de (trage) suggest-golf binnenkomt met precies dezelfde categorieën — dat is exact
         het 'te veel verversen' waar de melding over ging, en het omzeilde de poort in
         sykRangeerChips. Voegde de golf wél iets toe of kapte hij af, dan hoort de belangrijkste
         categorie weer vooraan in beeld te staan en resetten we wel. */
      if (erbij || afgekapt) { try { box.scrollLeft = 0; } catch (eS2) {} }
    }
    sykColsVoor(q).then(vul); /* gedeelde bron: incl. samenstellings-collecties (Boerenzakdoek) */
  }
  /* dezelfde ranking op een BESTAANDE chip-rij in de suggest-modal (dom-herordening, idempotent) */
  /* ---- zoeksuggestie-chip krijgt een echte foto (wens eigenaar 29-08). Tussen de categorie-tegels
     mengt het THEMA ook Shopify's ZOEKSUGGESTIES ('zigeuner outfit'): die linken naar /search?q=...
     en hebben nooit een afbeelding — het suggest-object kent alleen url/text/styled_text. Ze vielen
     dus terug op de grijze beginletter, en handmatig een collectie aanmaken lost dat maar één keer
     op (morgen typt een klant een nieuwe term). Nu erft de tegel de foto van het EERSTE product dat
     die zoekterm oplevert. TWEE TRAPPEN, want Shopify's suggest eist dat álle woorden matchen:
       1. gewone suggest — precies; dekte in de meting 20/24 termen;
       2. suggest mét het body-veld (fields=title,product_type,variants.title,vendor,body) — die
          vond de resterende 4/4 ('zigeuner outfit', 'piraten bril', 'clown accessoire',
          'armband hawaii'), allemaal mét foto.
     Levert ook trap 2 niets, dan een LOEPJE i.p.v. een letter (klasse syk-ls-chip--zoekterm):
     eerlijker, want het is een zoekopdracht en geen categorie. Dag-cache + vlucht-dedupe zoals de
     rest van dit bestand; opt-in via syk_search_qimg (D.qimg), standaard UIT. ---- */
  var sykQimgVluchten = {};
  function sykQimgHaal(term) {
    var key = 'sykQimg:' + term.toLowerCase();
    var uitCache = cacheLees(key);
    if (uitCache !== null) return Promise.resolve(uitCache);
    if (sykQimgVluchten[key]) return sykQimgVluchten[key]; /* zelfde term tijdens typen: 1 fetch */
    var basis = '/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=1';
    var breed = basis + '&resources[options][fields]=title,product_type,variants.title,vendor,body';
    function foto(u) {
      return fetch(u, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (d === null) return null; /* HTTP-fout (429/5xx): NIET dag-cachen als 'geen foto' */
          var p = (d.resources && d.resources.results && d.resources.results.products) || [];
          return (p[0] && (p[0].image || p[0].featured_image)) || '';
        })
        .catch(function () { return null; });
    }
    sykQimgVluchten[key] = foto(basis)
      .then(function (u1) { return u1 ? u1 : foto(breed); })
      .then(function (u) {
        delete sykQimgVluchten[key];
        if (u === null) return ''; /* netwerkfout: deze render zonder foto, morgen opnieuw proberen */
        cacheSchrijf(key, u || '');
        return u || '';
      });
    return sykQimgVluchten[key];
  }
  function sykQimgVerrijk(root) {
    if (!D.qimg || !root) return;
    [].forEach.call(root.querySelectorAll('a.syk-ls-chip[data-letter]'), function (a) {
      if (a.getAttribute('data-syk-qimg')) return; /* deze chip is al behandeld */
      var href = String(a.getAttribute('href') || '');
      var pad = href.split('?')[0].replace(/^https?:\/\/[^/]+/, '');
      if (pad !== '/search') return; /* alleen zoeksuggesties; collecties nooit aanraken */
      var m = href.match(/[?&]q=([^&]*)/);
      if (!m) return;
      var term = '';
      try { term = decodeURIComponent(m[1].replace(/\+/g, ' ')).trim(); } catch (e) { return; }
      if (!term) return;
      a.setAttribute('data-syk-qimg', '1');
      sykQimgHaal(term).then(function (url) {
        if (!a.isConnected) return; /* modal is intussen hertekend */
        if (url && !a.querySelector('img')) {
          var img = document.createElement('img');
          img.src = sykCatImg(url); img.alt = ''; img.loading = 'lazy';
          a.insertBefore(img, a.firstChild);
        } else if (!url) {
          a.classList.add('syk-ls-chip--zoekterm'); /* vangnet: loepje i.p.v. letter */
        }
        /* letter weg zodra er iets beters staat; het grijze rondje eronder blijft en wordt door de
           foto afgedekt — exact zoals bij een collectietegel */
        a.removeAttribute('data-letter');
      });
    });
  }
  function sykRangeerChips(wrap, q) {
    if (!wrap || !String(q || '').trim()) return;
    sykQimgVerrijk(wrap); /* dekt alle drie de chip-paden: thema-render, merge en onze eigen bouw */
    var box = sykCatBox(wrap); /* nooit de affiniteitsrij van de lege staat herordenen */
    if (!box) return;
    var as = [].slice.call(box.querySelectorAll('a'));
    if (as.length < 2) return;
    var cmp = sykColCmp(String(q).trim());
    function titel(a) { var s = a.querySelector('span'); return ((s ? s.textContent : a.textContent) || '').trim(); }
    as.sort(function (a, b) { return cmp(titel(a), a.getAttribute('href'), titel(b), b.getAttribute('href')); });
    /* FLIKKER-FIX 07-08 (melding eigenaar: 'nogal flikkeren en te veel verversen'). Hiervoor stond
       hier `as.forEach(box.appendChild)`. appendChild op een kind dat er AL staat is een verplaatsing:
       de node wordt losgemaakt en opnieuw ingevoegd — ook als de volgorde al klopte. In de browser
       gemeten op de live modal: per zoekterm TWEE bursts van 6 verwijderingen + 6 toevoegingen bij een
       ongewijzigd aantal van 6, dus elke categorie werd 2x volledig opnieuw ingevoegd en elke <img>
       opnieuw geverfd. Bij de kleine pills viel dat niet op, bij tegels van 54px wel.
       Nu: eerst vergelijken. Klopt de volgorde al (het normale geval bij een herhaalde render), dan
       raken we de DOM NIET aan = nul herverf. Alleen als er echt iets verschuift schrijven we, en dan
       in ÉÉN keer via een fragment i.p.v. per element. */
    var huidig = [].slice.call(box.children);
    var gelijk = huidig.length === as.length;
    if (gelijk) { for (var iG = 0; iG < as.length; iG++) { if (huidig[iG] !== as[iG]) { gelijk = false; break; } } }
    if (!gelijk) {
      var frag = document.createDocumentFragment();
      as.forEach(function (a) { frag.appendChild(a); });
      box.appendChild(frag);
      /* rail terug naar het BEGIN (melding eigenaar 14-07: 'de categorieën springen in, je ziet de
         laatste i.p.v. de eerste'): de horizontaal scrollende chip-rij behoudt zijn scrollpositie over
         de opeenvolgende suggest-renders heen, dus na een herordening weer op 0 — de belangrijkste
         categorie staat vooraan en moet dus zichtbaar zijn. 07-08 binnen de !gelijk-tak gehaald: bij
         een ONgewijzigde rij mag een bezoeker die net aan het vegen is niet teruggesprongen worden. */
      try { box.scrollLeft = 0; } catch (eS) {}
    }
  }
  /* ---- samenstellingen (wens eigenaar 09-07): 'ninjazwaard' en 'ninja zwaard' horen hetzelfde
     te tonen — de NL-samenstellings-crux. De volle zoekpagina doet dit al goed (wildcard-zoek,
     live gemeten: beide schrijfwijzen ~dezelfde set), de SUGGEST niet (predictive matcht per
     woord). Oplossing: detecteer de tweeling-schrijfwijze via het woordenboek — een splitsing
     telt ALLEEN als beide helften een bekend winkelwoord zijn (dus nooit los 'ninja' + los
     'zwaard' zoeken) — en meng de suggest-render van die tweeling stil samen met de huidige:
     ontbrekende producten en categorie-chips erbij; bij 0 eigen resultaten omwisselen met
     bronregel. Instelbaar via syk_search_comp. ---- */
  function sykCompWoord(w) {
    /* geldig deelwoord: exact in het woordenboek, of (>=4 tekens) voorvoegsel van een term */
    if (w.length < 3) return false;
    var dict = sykDymBouw();
    if (dict[w]) return true;
    if (w.length < 4) return false;
    for (var k in dict) { if (k.indexOf(w) === 0) return true; }
    return false;
  }
  /* veelvoorkomende NL-productsuffixen in deze winkel: laat 'ninjapak' -> 'ninja pak' splitsen ook
     als 'pak' niet los in het woordenboek staat (melding eigenaar 10-07: 'rood ninjapak' gaf 0,
     'rood ninja pak' gaf 7). Langste suffix eerst zodat 'pakken' vóór 'pak' matcht. */
  var SYK_SUF = ['kostuums', 'kostuum', 'pakken', 'handschoenen', 'oorbellen', 'schoenen', 'brillen', 'maskers', 'pruiken', 'mutsen', 'hoeden', 'jasje', 'jurkje', 'sokken', 'ketting', 'shirt', 'broek', 'jurk', 'cape', 'masker', 'pruik', 'muts', 'hoed', 'bril', 'set', 'sets', 'pak', 'jas'];
  function sykSplitWoord(w) {
    /* splits één compound-woord in twee delen: eerst een evenwichtige woordenboek-splitsing,
       anders op een bekend productsuffix (prefix moet een woord of >=4 tekens zijn) */
    if (w.length < 6 || /\d/.test(w)) return null;
    var beste = null;
    for (var i = 3; i <= w.length - 3; i++) {
      var L = w.slice(0, i), R = w.slice(i);
      if (sykCompWoord(L) && sykCompWoord(R)) { var sc = Math.min(L.length, R.length); if (!beste || sc > beste.s) beste = { t: L + ' ' + R, s: sc }; }
    }
    if (beste) return beste.t;
    for (var si = 0; si < SYK_SUF.length; si++) {
      var suf = SYK_SUF[si];
      if (w.length > suf.length + 2 && w.slice(-suf.length) === suf) {
        var pre = w.slice(0, w.length - suf.length);
        if (sykCompWoord(pre) || pre.length >= 4) return pre + ' ' + suf;
      }
    }
    return null;
  }
  function sykCompound(q) {
    if (D.comp === false) return null;
    q = String(q || '').replace(/\*+$/, '').trim().toLowerCase();
    if (!q || /\d/.test(q)) return null;
    var delen = q.split(/\s+/);
    if (delen.length === 1) { return q.length >= 7 ? sykSplitWoord(q) : null; }
    /* meerwoordig: splits élk splitsbaar compound-woord ('rood ninjapak' -> 'rood ninja pak') */
    var veranderd = false;
    var uit = delen.map(function (w) { if (w.length >= 6) { var s = sykSplitWoord(w); if (s) { veranderd = true; return s; } } return w; });
    if (veranderd) return uit.join(' ');
    /* geen splitsbaar woord: probeer de twee woorden samen te voegen (ninja pak -> ninjapak) */
    if (delen.length === 2 && delen[0].length >= 3 && delen[1].length >= 3) return delen.join('');
    return null;
  }
  /* kleur-woorden strippen -> de KERN van de query, zodat de affiniteit-collectie gevonden wordt.
     De predictive-API geeft bv. de 'Ninja pak'-collectie ALLEEN terug bij exact 'ninja pak' (2 woorden,
     geen kleur); 'rood ninjapak' / 'rood ninja pak' / 'ninjapak' geven 0 collecties. sykKernKandidaten
     stript de kleur en levert zowel de gestripte als de compound-vorm op ('rood ninjapak' -> ['ninjapak',
     'ninja pak']) zodat de spatie-vorm de collectie oplevert. Gebruikt in de dropdown (sykCompMerge) en
     de resultaten-categorierail. */
  var SYK_KLEURWRD = ['wit', 'witte', 'zwart', 'zwarte', 'grijs', 'grijze', 'antraciet', 'zilver', 'zilveren', 'zilverkleurig', 'rood', 'rode', 'bordeaux', 'donkerrood', 'oranje', 'terracotta', 'geel', 'gele', 'goud', 'gouden', 'goudkleurig', 'creme', 'crème', 'beige', 'taupe', 'groen', 'groene', 'donkergroen', 'lichtgroen', 'mint', 'olijf', 'legergroen', 'kaki', 'petrol', 'turquoise', 'aqua', 'blauw', 'blauwe', 'donkerblauw', 'marineblauw', 'navy', 'lichtblauw', 'babyblauw', 'kobalt', 'paars', 'paarse', 'lila', 'violet', 'aubergine', 'roze', 'knalroze', 'hardroze', 'babyroze', 'fuchsia', 'magenta', 'bruin', 'bruine', 'donkerbruin', 'lichtbruin', 'koper', 'brons', 'blond', 'nude', 'transparant', 'neongeel', 'neongroen', 'neonroze', 'neonoranje', 'fluor', 'multicolor', 'gekleurd'];
  function sykIsKleurwoord(w) {
    w = String(w || '').toLowerCase();
    if (!w) return false;
    if (SYK_KLEURWRD.indexOf(w) >= 0) return true;
    for (var i = 0; i < SYK_KLEURWRD.length; i++) { var k = SYK_KLEURWRD[i]; if (w === k + 'e' || w === k + 'en') return true; }
    return false;
  }
  function sykStripKleur(q) {
    var w = String(q || '').toLowerCase().replace(/\*+$/, '').trim().split(/\s+/).filter(Boolean);
    if (w.length < 2) return null;
    var kern = w.filter(function (x) { return !sykIsKleurwoord(x); });
    if (!kern.length || kern.length === w.length) return null; /* niets gestript, of alles kleur */
    return kern.join(' ');
  }
  function sykKernKandidaten(q) {
    if (D.comp === false) return [];
    var uit = [], s = sykStripKleur(q);
    if (s) { uit.push(s); var c = sykCompound(s); if (c && uit.indexOf(c) < 0) uit.push(c); }
    return uit;
  }
  var sykCompVluchten = {};
  function sykCompHaal(variant) {
    var key = 'sykComp:' + variant;
    var uitCache = cacheLees(key);
    if (uitCache !== null) return Promise.resolve(uitCache);
    if (sykCompVluchten[key]) return sykCompVluchten[key];
    sykCompVluchten[key] = fetch('/search/suggest?q=' + encodeURIComponent(variant) + '&resources[limit]=10&resources[options][fields]=title,body,product_type,variants.title,vendor,tag,variants.sku,variants.barcode&resources[limit_scope]=each&section_id=livesearch', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (h) {
        if (h === null) { delete sykCompVluchten[key]; return ''; } /* HTTP-fout: niet cachen */
        if (h.length < 60000) cacheSchrijf(key, h);
        return h;
      })
      .catch(function () { delete sykCompVluchten[key]; return ''; });
    return sykCompVluchten[key];
  }
  function sykMergeChips(wrap, bronChips) {
    if (!bronChips || !bronChips.children.length) return;
    var eigenChips = sykCatBox(wrap); /* zelfde poort: nooit in de affiniteitsrij mengen */
    if (!eigenChips) {
      var kop = bronChips.previousElementSibling;
      var term2 = wrap.querySelector('.syk-ls-term');
      if (term2 && term2.parentNode === wrap) {
        wrap.insertBefore(bronChips, term2.nextSibling);
        if (kop && kop.classList && kop.classList.contains('syk-ls-kop')) wrap.insertBefore(kop, bronChips);
      }
    } else {
      var urls = {};
      [].forEach.call(eigenChips.querySelectorAll('a'), function (a) { urls[String(a.getAttribute('href') || '').split('?')[0]] = 1; });
      [].forEach.call(bronChips.querySelectorAll('a'), function (a) {
        if (!urls[String(a.getAttribute('href') || '').split('?')[0]] && eigenChips.children.length < 6) eigenChips.appendChild(a);
      });
    }
    /* na elke merge opnieuw rangschikken — de bijgemengde chips (tweeling/kern) worden achteraan
       geappend en zouden anders de volgorde bederven (wens eigenaar 14-07) */
    var inpM = zoekInput();
    if (inpM) sykRangeerChips(wrap, inpM.value);
  }
  /* kleur-gestripte kern -> de affiniteit-collectie-chip in de dropdown mengen (rood ninjapak -> ninja pak);
     probeert de kandidaten op volgorde, de eerste met chips wint (1 extra livesearch-fetch, gecachet). */
  function sykKernChipsInject(wrap, q) {
    var kand = sykKernKandidaten(q);
    if (!kand.length) return;
    (function probeer(i) {
      if (i >= kand.length || !wrap.isConnected) return;
      sykCompHaal(kand[i]).then(function (h) {
        if (!h || !wrap.isConnected) return;
        var tmp = document.createElement('div'); tmp.innerHTML = h;
        var bronChips = tmp.querySelector('.syk-ls-chips');
        if (bronChips && bronChips.children.length) sykMergeChips(wrap, bronChips);
        else probeer(i + 1);
      });
    })(0);
  }
  function sykCompMerge() {
    if (!ls || D.comp === false) return;
    var wrap = ls.querySelector('.syk-ls');
    if (!wrap || wrap.classList.contains('syk-ls-leeg') || wrap.getAttribute('data-syk-comp')) return;
    var inp = zoekInput();
    var q = inp && inp.value ? inp.value.trim() : '';
    if (!q) return;
    var variant = sykCompound(q);
    if (!variant) {
      /* ZOEKREGEL als tweeling (wens eigenaar 21-07: synoniem DIRECT tonen, geen sprong/banner):
         'mombakkes' -> doelcollectie-handle als zoekvorm 'maskers', zelfde stille meng/omwissel-
         machinerie als de compound-tweeling. Regels laden async: nog niet binnen -> na laden
         nogmaals proberen (de comp-vlag staat dan nog niet). */
      if (D.zoekregels && sykRegelMap === null && !wrap.getAttribute('data-syk-regelwacht')) {
        /* freeze-fix (toets 21-07): ONE-SHOT en alleen her-invoken als de map echt geladen werd —
           bij een storing blijft sykRegelMap bewust null terwijl de belofte settled is; zonder
           deze twee guards herplant de retry zich per microtask = bevroren tab. */
        wrap.setAttribute('data-syk-regelwacht', '1');
        sykRegels().then(function () { if (sykRegelMap !== null && wrap.isConnected && !wrap.getAttribute('data-syk-comp')) sykCompMerge(); });
      }
      var rhM = sykRegelHandle(q);
      if (rhM) variant = rhM.replace(/-/g, ' ');
    }
    if (!variant) {
      /* geen compound-tweeling (query met cijfer, 3+ woorden of niets splitsbaars): de kleur-strip-
         kernchips ('rood ninjapak' -> collectie 'Ninja pak') mogen dan niet mee-sneuvelen achter deze
         gate (adversarial review 14-07); eigen idempotentie-vlag los van data-syk-comp. */
      if (!wrap.getAttribute('data-syk-kern')) { wrap.setAttribute('data-syk-kern', '1'); sykKernChipsInject(wrap, q); }
      return;
    }
    wrap.setAttribute('data-syk-comp', '1');
    sykCompHaal(variant).then(function (h) {
      if (!h || !wrap.isConnected) return;
      var inp2 = zoekInput();
      if (!inp2 || inp2.value.trim() !== q) return; /* gebruiker typte door: verse render volgt toch */
      var tmp = document.createElement('div'); tmp.innerHTML = h;
      var bron = tmp.querySelector('.syk-ls');
      if (!bron) return;
      var extraLis = [].slice.call(bron.querySelectorAll('.syk-lsp[data-pid]'));
      var geen = wrap.querySelector('.syk-ls-geen');
      if (geen) {
        if (!extraLis.length) return; /* tweeling heeft ook niets — dym mag zijn werk doen */
        /* 0 eigen resultaten -> tweeling volledig tonen, met bronregel onder de titel */
        wrap.innerHTML = bron.innerHTML;
        var term = wrap.querySelector('.syk-ls-term');
        if (term && term.parentNode) {
          var noot = document.createElement('p');
          noot.className = 'syk-ls-compnote';
          noot.innerHTML = (SYKT.gezochtAls || 'Gezocht als') + ' ‘<b>' + esc(variant) + '</b>’';
          term.parentNode.insertBefore(noot, term.nextSibling);
        }
        naInjectie(); /* levertijden/verrijking voor de nieuwe rijen (data-syk-comp voorkomt een lus) */
        sykKernChipsInject(wrap, q); /* affiniteit-collectie ook bij 0 eigen resultaten */
        return;
      }
      var ul = wrap.querySelector('.syk-lsu');
      if (ul && extraLis.length) {
        var pids = {};
        [].forEach.call(ul.querySelectorAll('.syk-lsp[data-pid]'), function (li) { pids[li.getAttribute('data-pid')] = 1; });
        extraLis.forEach(function (li) {
          if (pids[li.getAttribute('data-pid')] || ul.children.length >= 8) return;
          ul.appendChild(li);
        });
      }
      /* categorie-chips van de tweeling mee-mengen ('Ninja zwaarden (14)' ontbrak bij 'ninjazwaard') +
         de kleur-gestripte kern-collectie ('rood ninjapak' -> 'ninja pak') */
      sykMergeChips(wrap, bron.querySelector('.syk-ls-chips'));
      sykKernChipsInject(wrap, q);
      naInjectie();
    });
  }
  /* ---- cart-bewuste suggest (wens eigenaar 09-07): zit er iets in de winkelwagen, dan stuurt
     de lege zoekstaat op het AFMAKEN van de aankoop — 'Maak je look compleet' bij het laatst
     toegevoegde item (S&D complementary, terugval related; zelfde bron als het PDP-blok en de
     set-korting) in plaats van bestsellers/thema's. Modus instelbaar: uit / boven / focus. ---- */
  var sykCartSnap = null, sykCartTijd = 0, sykRecsVlucht = {}, sykLookLeeg = {};
  /* service-artikelen (garantie/toeslag e.d.) — gedeeld met bestsellers-filter en look-anker */
  var SYK_SERVICE_RE = /(prioriteit|garantie|verzeker|cadeaubon|gift ?card|verzendkost|toeslag|fooi|sample)/i;
  function sykCartHaal(vers) {
    if (!vers && sykCartSnap && Date.now() - sykCartTijd < 10000) return Promise.resolve(sykCartSnap);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) { sykCartSnap = c; sykCartTijd = Date.now(); } return sykCartSnap || { items: [] }; })
      .catch(function () { return sykCartSnap || { items: [] }; });
  }
  function sykCartAnker() {
    /* eerste cart-regel die GEEN service-artikel is (prioriteitsverzending/garantie wordt vaak
       als laatste toegevoegd — daar wil je geen look omheen bouwen) */
    var items = (sykCartSnap && sykCartSnap.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (!SYK_SERVICE_RE.test(String(items[i].product_title || items[i].title || ''))) return items[i];
    }
    return null;
  }
  function sykCartModus() {
    if (D.cartLook === 'uit' || D.cartLook === false) return '';
    var anker = sykCartAnker();
    if (!anker || sykLookLeeg[anker.product_id]) return ''; /* geen echt product of geen aanbevelingen -> normale lege staat */
    return D.cartLook || 'focus';
  }
  function vulCartLook(doel) {
    var mod = sykCartModus();
    if (!mod || !doel || doel.getAttribute('data-syk-cartlook')) return false;
    var laatst = sykCartAnker();
    if (!laatst) return false;
    doel.setAttribute('data-syk-cartlook', '1');
    var items = (sykCartSnap && sykCartSnap.items) || [];
    var inCart = {};
    items.forEach(function (it) { inCart[it.product_id] = 1; });
    var wrap = document.createElement('div');
    wrap.className = 'syk-ls-cartlook';
    wrap.innerHTML = '<p class="syk-ls-kop">' + esc(D.tCartLook || 'Maak je look compleet') + '</p>' +
      '<p class="syk-ls-cartsub">' + esc(D.tCartLookSub || 'past bij') + ' ‘' + esc(laatst.product_title || laatst.title || '') + '’</p>' +
      '<div class="syk-ls-rvrail"><span class="syk-cartskel"></span><span class="syk-cartskel"></span><span class="syk-cartskel"></span></div>';
    /* wrap DIRECT plaatsen met skelet-kaarten (anders staart de klant in focus-modus naar een
       leeg paneel tot recommendations+leverdata binnen zijn) — render() vult de rail in situ */
    var bel = doel.querySelector('.syk-ls-bel');
    if (bel && bel.parentNode === doel) doel.insertBefore(wrap, bel);
    else if (doel.querySelector('.syk-ls-geenkop')) doel.appendChild(wrap);
    else doel.insertBefore(wrap, doel.firstChild);
    function haalRecs(intent) {
      /* dag-cache + vluchtcache: het thema herbouwt de lege staat bij elke leeg-veld-actie —
         zonder cache zou elke herbouw opnieuw recommendations ophalen */
      var key = 'sykRecs:' + laatst.product_id + ':' + intent;
      if (sykRecsVlucht[key]) return sykRecsVlucht[key];
      var uitCache = cacheLees(key);
      if (uitCache) { sykRecsVlucht[key] = Promise.resolve(uitCache); return sykRecsVlucht[key]; }
      sykRecsVlucht[key] = fetch('/recommendations/products.json?product_id=' + laatst.product_id + '&limit=10&intent=' + intent, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (d === null) { delete sykRecsVlucht[key]; return []; } /* HTTP-fout (429/5xx): NIET cachen, volgende cyclus probeert opnieuw */
          var slank = (d.products || []).map(function (p) {
            return { id: p.id, title: p.title, url: p.url, price: p.price, price_min: p.price_min, price_max: p.price_max,
              available: p.available, featured_image: p.featured_image, options: p.options,
              variants: (p.variants || []).map(function (v) { return { available: v.available, sku: v.sku, barcode: v.barcode, id: v.id, options: v.options, option1: v.option1, option2: v.option2, option3: v.option3 }; }) };
          });
          cacheSchrijf(key, slank);
          return slank;
        })
        .catch(function () { delete sykRecsVlucht[key]; return []; });
      return sykRecsVlucht[key];
    }
    haalRecs('complementary').then(function (ps) {
      return ps.length ? ps : haalRecs('related');
    }).then(function (ps) {
      ps = (ps || []).filter(function (p) {
        if (p.available === false || inCart[p.id]) return false;
        return !SYK_SERVICE_RE.test(String(p.title || ''));
      }).slice(0, 8);
      if (!ps.length) {
        /* geen aanbevelingen voor dit product -> onthoud dat en gedraag je als zonder cart */
        sykLookLeeg[laatst.product_id] = 1;
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        if (!doel.isConnected) return;
        if (doel.classList.contains('syk-ls-leeg') && ls) {
          /* lege staat: volledig herbouwen — sykCartModus() geeft nu '' dus pop/themas/trending/rv komen terug */
          ls.innerHTML = '';
          ls.appendChild(bouwLegeStaat());
          vulLegeStaat();
        } else if (mod === 'focus') { vulTrending(doel); }
        return;
      }
      var kaarten = ps.map(function (p) {
        var optNamen = (p.options || []).map(function (o) { return (o && o.name) || o; });
        var mi = optNamen.indexOf('Maat') > -1 ? optNamen.indexOf('Maat') : 0;
        var maten = [], seen = {};
        (p.variants || []).forEach(function (v) {
          if (v.available === false) return;
          var naam = (v.options && v.options[mi]) || v['option' + (mi + 1)] || '';
          if (naam && naam !== 'Default Title' && !seen[naam]) { seen[naam] = 1; maten.push(naam); }
        });
        return { titel: p.title, url: p.url, prijs: p.price, prijsMin: p.price_min, prijsMax: p.price_max,
          foto: p.featured_image, maten: maten, skus: sykSkus(p, 6), beschikbaar: p.available !== false };
      });
      var bulkItems = [], gezien = {};
      kaarten.forEach(function (k) { (k.skus || []).forEach(function (sku) { if (!gezien[sku]) { gezien[sku] = 1; bulkItems.push({ sku: sku, quantity: 1, available: true }); } }); });
      function render(dmap) {
        if (!doel.isConnected || !wrap.isConnected) return;
        wrap.querySelector('.syk-ls-rvrail').innerHTML = kaarten.map(function (k) { return bouwKaartHtml(k, dmap || {}); }).join('');
        verrijkOok(); sykLabelPass();
      }
      if (bulkItems.length) bulkHaal(bulkItems).then(render); else render({});
    });
    return true;
  }
  /* gedeelde levertijd-helpers: SNELSTE datum over alle leverbare maten (verzoek eigenaar:
     kaart toonde de datum van de eerste maat terwijl een andere maat eerder leverbaar is) */
  var I18S = window.SYK_DELIV_I18N || {};
  /* eerstvolgende werkdag (sla za/zo over): levering op of vóór die dag = SNEL (groen), pas daarna
     oranje. In het weekend is maandag de eerstvolgende werkdag en dus de SNELST mogelijke levering —
     die hoort groen, niet oranje (melding eigenaar 25-07: 'ma 27 juli' stond oranje op zaterdag).
     Zelfde weekend-logica als de PDP (assets/syk-pdp.js nextBusinessDay). */
  function sykSod(x) { return new Date(x.getFullYear(), x.getMonth(), x.getDate()); }
  function sykNextBiz() { var d = sykSod(new Date()); d.setDate(d.getDate() + 1); while (d.getDay() === 0 || d.getDay() === 6) { d.setDate(d.getDate() + 1); } return d; }
  function sykInHuis(d) {
    var dd = sykSod(d);
    var n2 = Math.round((dd - sykSod(new Date())) / 86400000);
    if (n2 <= 0) return { t: I18S.today || 'Vandaag in huis', laat: false };
    if (n2 === 1) return { t: I18S.tomorrow || 'Morgen in huis', laat: false };
    /* maand AFGEKORT (07-08, melding eigenaar 'de leverdatum loopt uit de productkaart'): op een
       resultaatkaart houdt de levertijdregel naast het truck-icoon maar ~91px over. Live gemeten:
       'ma 28 september in huis' is 128px en liep dus over twee à drie regels, waarvan de kaart er
       maar één toonde en de rest wegknipte. 'ma 28 sep in huis' is 91px en past op één regel vanaf
       390px; daaronder reserveert syk-search.css twee regels. Deze functie voedt ALLEEN de
       rasterkaarten (zoek + collectie), niet de dropdown of de PDP — die hebben hun eigen tekst. */
    var ds = d.toLocaleDateString(I18S.locale || 'nl', { weekday: 'short', day: 'numeric', month: 'short' });
    /* oranje pas ná de eerstvolgende werkdag; t/m die dag (bv. maandag in het weekend) = groen */
    return { t: (I18S.dateTpl || '{d} in huis').replace('{d}', ds), laat: dd.getTime() > sykNextBiz().getTime() };
  }
  function sykSkus(p, cap) {
    var uit = [];
    (p.variants || []).forEach(function (v) { if (v.available && uit.length < (cap || 6)) uit.push(String(v.barcode || v.sku || v.id)); });
    return uit;
  }
  function sykSnelste(dmap, skus) {
    var beste = null;
    (skus || []).forEach(function (sku) {
      var rec = dmap[sku];
      if (rec && rec.deliveryDate) { var dd = new Date(rec.deliveryDate); if (!isNaN(dd.getTime()) && (!beste || dd < beste)) beste = dd; }
    });
    return beste;
  }
  /* gedeelde levertijd-terugval (wens eigenaar 14-07): datum uit de tussenlaag -> 'Vandaag/Morgen/<dag>
     in huis'; GEEN datum maar wél op voorraad -> 'Op voorraad' (de bulk-API/tussenlaag kent niet elke sku,
     bv. barcode 5055294866677 -> deliveryDate null; dan nooit een lege regel, maar netjes de voorraad-
     status in dezelfde badge-stijl); niet leverbaar -> 'Uitverkocht'. Zo tonen ALLE surfaces (hoofdkaart,
     look-rail, bestsellers, recent-bekeken, suggest) exact dezelfde terugval i.p.v. de losse thema-tekst. */
  function sykLeverInfo(dmap, skus, beschikbaar) {
    if (beschikbaar === false) return { t: I18S.soldout || 'Uitverkocht', sold: true };
    var beste = sykSnelste(dmap || {}, skus || []);
    if (beste) { var ih = sykInHuis(beste); return { t: ih.t, laat: ih.laat }; }
    /* de 'Op voorraad'-terugval ALLEEN als de tussenlaag de sku daadwerkelijk beantwoordde (bekend-null
       in de kaart) — bij een storing/timeout is er géén record en geven we null terug zodat de caller
       niets overschrijft en de thema-tekst blijft staan (adversarial review 14-07). */
    var bekend = false;
    (skus || []).forEach(function (s) { if (dmap && dmap[s]) bekend = true; });
    if (!bekend) return null;
    /* terugval bij ontbrekende datum: expliciete wens eigenaar = 'Op voorraad' (NIET de thema-instelling
       default_product_deliverytime_in_stock, want die staat op 'Morgen in huis' = een levertijd-belofte;
       de eigenaar koos bewust de neutrale voorraadstatus). Eigen I18S.voorraad-haak voor evt. vertaling. */
    return { t: I18S.voorraad || 'Op voorraad', voorraad: true };
  }
  function sykLeverHtml(dmap, skus, beschikbaar) {
    var v = sykLeverInfo(dmap, skus, beschikbaar);
    if (!v) return '';
    if (v.sold) return '<span class="syk-rv-lever syk-rv-sold">' + esc(v.t) + '</span>';
    var kl = v.laat ? ' syk-rv-laat' : (v.voorraad ? ' syk-rv-voorraad' : '');
    return '<span class="syk-rv-lever' + kl + '"><em></em>' + esc(v.t) + '</span>';
  }
  var bulkVluchten = {};
  function bulkHaal(items) {
    /* eerst de dag-cache, alleen ontbrekende sku's naar de API — in PARALLELLE delen van 80
       (sequentieel kostte bij 48 kaarten ~5 rondreizen na elkaar; parallel is het er effectief 1) */
    var kaart = cacheLees('sykBulk') || {};
    var missend = items.filter(function (it) { return !kaart[it.sku]; });
    if (!missend.length) return Promise.resolve(kaart);
    /* vlucht-dedupe (review #10): thema-herbouwcycli vroegen dezelfde sku-set meermaals aan
       binnen het antwoordvenster; identieke aanvragen delen nu één vlucht */
    var vluchtKey = missend.map(function (it) { return it.sku; }).sort().join(',');
    if (bulkVluchten[vluchtKey]) return bulkVluchten[vluchtKey];
    var delen = [];
    for (var i = 0; i < missend.length; i += 80) delen.push(missend.slice(i, i + 80));
    bulkVluchten[vluchtKey] = Promise.all(delen.map(function (deel) {
      var haal = fetch('https://econcepts.bemashopping.com/delivery/bulk', { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ products: deel }) })
        .then(function (r) { return r.json(); })
        .then(function (d) { return (d && d.products) || {}; })
        .catch(function () { return { __fout: 1 }; });
      /* timeout-vangnet: een hangende cross-origin respons mag de verrijking-golf niet laten stallen
         (srBezig/ookBezig blijven anders true) -> na 6s vallen we terug op leeg, de kaart houdt gewoon
         de thema-levertijd. */
      var klok = new Promise(function (res) { setTimeout(function () { res({ __fout: 1 }); }, 6000); });
      return Promise.race([haal, klok]).then(function (m) { return { m: m, deel: deel }; });
    })).then(function (uitkomsten) {
      uitkomsten.forEach(function (u) {
        /* storing/timeout: NIETS markeren — de sku blijft 'onbekend' en de kaart houdt de thema-tekst
           (adversarial review 14-07: de 'Op voorraad'-terugval mag alleen na een GESLAAGD antwoord). */
        if (!u.m || u.m.__fout) return;
        for (var k in u.m) { if (u.m[k] && u.m[k].deliveryDate) kaart[k] = u.m[k]; }
        /* geslaagd antwoord zonder datum: als 'bekend-null' in de dag-cache — de terugval mag tonen
           én de sku wordt vandaag niet nogmaals vergeefs bevraagd */
        u.deel.forEach(function (it) { if (!kaart[it.sku]) kaart[it.sku] = { deliveryDate: null }; });
      });
      cacheSchrijf('sykBulk', kaart);
      delete bulkVluchten[vluchtKey]; /* dag-cache neemt het over */
      return kaart;
    });
    return bulkVluchten[vluchtKey];
  }
  function bouwLegeStaat() {
    /* het thema toont alleen een lege-staat als er server-side een .search-placeholders
       in #livesearch staat (is er niet) — dus bouwen wij hem zelf uit de settings-config */
    var d = document.createElement('div');
    d.className = 'syk-ls syk-ls--' + (D.variant || 'a') + ' syk-ls-leeg';
    var cm = sykCartModus();
    d.setAttribute('data-syk-cart', cm);
    var html = '';
    /* cart-modus 'focus': populaire termen + thema's zijn dan afleiding — alles draait om
       de look-rail (vulLegeStaat) + recent gezocht */
    if (cm !== 'focus') {
      var pop = String(D.pop || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      if (pop.length) {
        html += '<p class="syk-ls-kop">' + esc(D.tPop || 'Populaire zoektermen') + '</p><div class="syk-ls-pills">' +
          pop.map(function (t) { return '<a class="syk-ls-pill" href="/search?q=' + encodeURIComponent(sykSterTerm(t)) + '" data-syk-sug="' + esc(t) + '">' + esc(t) + '</a>'; }).join('') + '</div>';
      }
      var themas = String(D.themas || '').split(/\r?\n/).map(function (r) { return r.split('|'); }).filter(function (d2) { return d2.length >= 2 && d2[1].trim(); });
      if (themas.length) {
        html += '<p class="syk-ls-kop">' + esc(D.tThema || 'Shop op thema') + '</p><div class="syk-ls-themas' + (D.variant === 'b' ? ' syk-ls-themas--groot' : '') + '">' +
          themas.map(function (d2) {
            var url = (d2[2] || '').trim() || ('/search?q=' + encodeURIComponent(d2[1].trim()));
            return '<a class="syk-ls-thema" href="' + esc(url) + '"><span class="syk-ls-temoji" aria-hidden="true">' + esc(d2[0].trim()) + '</span><span class="syk-ls-tnaam">' + esc(d2[1].trim()) + '</span></a>';
          }).join('') + '</div>';
      }
    }
    d.innerHTML = html;
    return d;
  }
  function bouwKaartHtml(d, dmap) {
    /* zelfde PDP-stijl kaart als 'recent bekeken' — gedeeld door rv en bestsellers */
    var prijs = (d.prijsMin != null && d.prijsMax != null && d.prijsMin !== d.prijsMax)
      ? '<small>' + esc(SYKT.vanaf || 'Vanaf') + '</small> ' + geldEUR(d.prijsMin || 0)
      : geldEUR(d.prijs || 0);
    var maten = (d.maten || []).slice(0, 8).join(' \u00b7 ');
    var lever = sykLeverHtml(dmap, d.skus, d.beschikbaar !== false);
    var kaartBadge = '';
    if (D.labelBest !== false && sykLabelBron() !== 'auto' && d.badge) {
      var railIco = sykLabelIcoon(d.badge);
      kaartBadge = '<span class="syk-kaartlabel"' + (railIco ? ' data-icoon="' + esc(railIco) + '"' : '') + '>' + esc(d.badge) + '</span>';
    }
    return '<a class="syk-ls-rvkaart" href="' + esc(d.url) + '">' + kaartBadge +
      '<span class="syk-rv-media">' + (d.foto ? '<img src="' + esc(d.foto) + '" alt="' + esc(d.titel) + '" loading="lazy">' : '') + '</span>' +
      '<span class="syk-rv-body"><b class="syk-rv-naam">' + esc(d.titel) + '</b>' +
      '<span class="syk-rv-prijs">' + prijs + '</span>' +
      '<span class="syk-rv-maten">' + esc(maten) + '</span>' +
      lever + '</span>' + sykAtcHtml(d.url, d.beschikbaar !== false) + '</a>';
  }
  /* 'Ook beschikbaar in' (metafield custom.ook_beschikbaar_in_, Lightspeed koppelt kleur-
     varianten als losse producten): per product opgehaald via de syk-ook-datasectie en als
     foto-swatches getoond in de maten-rij van kaarten die geen maat-varianten hebben. */
  var ookVluchten = {};
  function haalOok(handle) {
    if (ookVluchten[handle]) return ookVluchten[handle];
    var uitCache = cacheLees('sykOok2:' + handle);
    if (uitCache) { ookVluchten[handle] = Promise.resolve(uitCache); return ookVluchten[handle]; }
    ookVluchten[handle] = fetch('/products/' + encodeURIComponent(handle) + '?section_id=syk-ook', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var el = tmp.querySelector('[data-syk-ook]');
        var data = el ? JSON.parse(el.textContent) : { items: [] };
        if (!data || !data.items) data = { items: [] };
        cacheSchrijf('sykOok2:' + handle, data);
        return data;
      }).catch(function () { return { items: [] }; });
    return ookVluchten[handle];
  }
  /* kleurnaam -> bolletje (TOP-LEVEL, buiten het results-plus-blok, zodat verrijkOok ze in strict mode
     kan gebruiken voor de kaart-kleurstipjes): ingebouwde kaart, uitbreidbaar via D.fbarKleur ('naam|#hex'
     per regel); combi-namen ('zwart/wit') -> verdeeld bolletje, multicolor -> regenboog, onbekend -> grijs */
  var SYK_KLEURKAART = {
    wit: '#ffffff', zwart: '#141414', grijs: '#9aa3ab', antraciet: '#3b3f44', zilver: '#c6ccd4',
    rood: '#e02020', bordeaux: '#7b1e3b', donkerrood: '#9b111e', oranje: '#ff7a00', terracotta: '#cc5c3c',
    geel: '#ffd400', goud: '#d4af37', creme: '#f4ecd8', 'crème': '#f4ecd8', ivoor: '#fffbe6', champagne: '#f0e0c0', beige: '#d9c7a7', taupe: '#b3a08f',
    groen: '#2e9e44', donkergroen: '#1c6b2f', lichtgroen: '#86d96c', mint: '#98e5c0', olijf: '#708238', legergroen: '#4b5320', kaki: '#8a7d4a', petrol: '#0a6a72', turquoise: '#2ec4b6', aqua: '#35d1e0',
    blauw: '#1f6fd6', donkerblauw: '#14367f', marineblauw: '#1b2a5e', navy: '#1b2a5e', lichtblauw: '#7fc2f0', babyblauw: '#a8d3f0', kobalt: '#0047ab',
    paars: '#7c3aed', lila: '#c4a7e7', violet: '#8f00ff', aubergine: '#5b2a4a',
    roze: '#f06ba8', knalroze: '#ff2d95', hardroze: '#ff2d95', babyroze: '#f7c5d8', fuchsia: '#e3007e', magenta: '#e3007e',
    bruin: '#8b5a2b', donkerbruin: '#5c3a1e', lichtbruin: '#b07f4a', koper: '#b87333', brons: '#cd7f32',
    blond: '#f3d38d', lichaamskleur: '#f2c7a5', huidskleur: '#f2c7a5', nude: '#f2c7a5', transparant: '#eef2f5',
    neongeel: '#e8ff00', neongroen: '#39ff14', neonroze: '#ff10f0', neonoranje: '#ff5f1f', fluor: '#d9ff00'
  };
  var SYK_REGENBOOG = 'conic-gradient(#e02020,#ff7a00,#ffd400,#2e9e44,#1f6fd6,#7c3aed,#e02020)';
  function sykKleurKaart() {
    var kaart = {};
    Object.keys(SYK_KLEURKAART).forEach(function (k) { kaart[k] = SYK_KLEURKAART[k]; });
    String(D.fbarKleur || '').split(/\r?\n/).forEach(function (r) {
      var d = r.split('|');
      if (d.length >= 2 && d[1].trim()) kaart[d[0].trim().toLowerCase()] = d[1].trim();
    });
    return kaart;
  }
  function sykYiqLicht(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(String(hex).trim());
    if (!m) return false;
    var v = parseInt(m[1], 16);
    return (((v >> 16) & 255) * 299 + ((v >> 8) & 255) * 587 + (v & 255) * 114) / 1000 > 172;
  }
  function sykKleurDot(naam) {
    var n = String(naam || '').toLowerCase();
    if (/multi|meerkleur|gekleurd|regenboog|rainbow/.test(n)) {
      return '<i class="syk-fb-dot" style="background:' + SYK_REGENBOOG + '" aria-hidden="true"></i>';
    }
    var kaart = sykKleurKaart();
    var kleuren = [];
    n.split(/[^a-zà-ÿ]+/).filter(Boolean).forEach(function (w) {
      var beste = kaart[w] ? w : '';
      if (!beste) Object.keys(kaart).forEach(function (k) { if (w.indexOf(k) > -1 && k.length > beste.length) beste = k; });
      if (beste && kleuren.indexOf(kaart[beste]) < 0) kleuren.push(kaart[beste]);
    });
    kleuren = kleuren.slice(0, 3);
    var bg = kleuren.length === 0 ? '#d4dae1'
      : kleuren.length === 1 ? kleuren[0]
      : kleuren.length === 2 ? 'linear-gradient(90deg,' + kleuren[0] + ' 50%,' + kleuren[1] + ' 50%)'
      : 'linear-gradient(90deg,' + kleuren[0] + ' 33%,' + kleuren[1] + ' 33% 66%,' + kleuren[2] + ' 66%)';
    var licht = sykYiqLicht(kleuren[0] || '#d4dae1');
    return '<i class="syk-fb-dot" style="background:' + bg + '"' + (licht ? ' data-licht="1"' : '') + ' aria-hidden="true"></i>';
  }
  var ookBezig = false;
  function verrijkOok() {
    if (ookBezig) return;
    /* OOK kaarten mét maat-chips doen mee (melding eigenaar 09-07: roze trainingspak met S·M·L
       toonde de kleurvarianten niet): lege maten-rij krijgt de swatches erin (als vanouds),
       een gevulde maten-rij krijgt een eigen swatch-rij ERONDER. */
    var rijen = [].slice.call(document.querySelectorAll('.syk-rv-maten:not([data-syk-ook]):not(.syk-rv-ookrij)')).slice(0, 12);
    if (!rijen.length) return;
    ookBezig = true;
    var jobs = [];
    rijen.forEach(function (el) {
      el.setAttribute('data-syk-ook', '1');
      var kaart = el.closest ? el.closest('li.product-card, a.syk-ls-rvkaart') : null;
      var a = kaart ? (kaart.matches('a') ? kaart : kaart.querySelector('.h3 a, a[href*="/products/"]')) : null;
      var m = a && String(a.getAttribute('href') || '').split('?')[0].match(/\/products\/([^\/?#]+)\/?$/);
      if (m && m[1].indexOf('.') === -1) jobs.push({ el: el, handle: m[1], leeg: !el.textContent.trim() && !el.firstElementChild });
    });
    if (!jobs.length) { ookBezig = false; return; }
    Promise.all(jobs.map(function (j) { return haalOok(j.handle); })).then(function (ds) {
      /* layout-thrash-demping (adversarial review 14-07): kaartbreedte 1x per kaart-TYPE per golf meten
         (gridkaarten zijn even breed) i.p.v. clientWidth per kaart tussen de innerHTML-writes door;
         de overflow-checks van de mix-rij gaan gebatcht naar een rAF na alle writes (reads/writes
         gescheiden = 2 reflows per golf i.p.v. ~2 per kaart). */
      var kbCache = {};
      var mixEls = [];
      jobs.forEach(function (j, i) {
        if (D.labelBest !== false && sykLabelBron() !== 'auto' && ds[i] && ds[i].badge) {
          var kaartEl = j.el.closest('li.product-card, a.syk-ls-rvkaart');
          if (kaartEl) sykZetLabel(kaartEl, String(ds[i].badge));
        }
        var items = ((ds[i] && ds[i].items) || []).filter(function (it) { return it.av !== false && it.u; });
        var bronSet = false;
        if (!items.length && j.leeg && D.ookSet !== false) {
          /* accessoires zonder kleur-siblings (wens eigenaar 09-07, 'Sweet 16 borden'): set-genoten
             tonen uit dezelfde bron als 'Maak de look compleet'. Kaarten MET maat-chips doen hier
             bewust niet aan mee — de kleding-connecties (kleur-metafield) blijven exact zoals ze waren.
             INSTELBAAR (wens eigenaar 23-07: 'alleen ook beschikbaar in, geen aanvullende producten'):
             staat syk_search_ook_set UIT (D.ookSet === false), dan slaan we deze terugval over — dan
             tonen kaarten uitsluitend echte kleur-/persoonsvarianten uit ook_beschikbaar_in_ en blijft
             de rij leeg bij losse producten. Geldt ook op collecties (coll erft de search-sleutel). */
          items = ((ds[i] && ds[i].set) || []).filter(function (it) { return it.av !== false && it.u; });
          bronSet = true;
        }
        /* 'kleuren-onder'/'afbeelding-onder': reserveer de variant-rij ONDER de maten/thumbnails op ELKE
           kaart — óók de lege-tak (accessoires zonder maten, bv. 'Power ninja kostuum Kevin'). Anders heeft
           die kaart één variant-rij en de kledingkaarten twee, waardoor levertijd/knop hoger komt te staan
           (melding eigenaar 13-07). Reservering op alle kaarten = vaste hoogte = footer uitgelijnd (titel/
           prijs klemt het thema al gelijk). Stipjes -> .syk-rv-dotrow (22px); afbeeldingen -> .syk-rv-imgrow. */
        var vrRes = D.variantrij || 'maten';
        var resKlasse = vrRes === 'afbeelding-onder' ? 'syk-rv-imgrow' : 'syk-rv-dotrow';
        if ((vrRes === 'kleuren-onder' || vrRes === 'afbeelding-onder') && !(j.el.parentNode && j.el.parentNode.querySelector('.' + resKlasse))) {
          var drRes = document.createElement('span');
          drRes.className = 'syk-rv-maten ' + resKlasse;
          drRes.setAttribute('data-syk-ook', '1');
          j.el.parentNode.insertBefore(drRes, j.el.nextSibling);
        }
        if (!items.length) return;
        /* breedte-bewust (melding eigenaar: '+4' viel op smalle mobiele kaarten buiten beeld):
           bolletje = 28px + 6 gap; teller-reservering groeit mee met het woord erachter
           ('+10 kleuren' i.p.v. kaal '+10' — wens eigenaar 09-07, tekst instelbaar) */
        var kaartEl2 = j.el.closest ? j.el.closest('li.product-card, a.syk-ls-rvkaart') : null;
        var kbType = kaartEl2 ? (kaartEl2.matches && kaartEl2.matches('a') ? 'rail' : 'grid') : 'los';
        if (kbCache[kbType] == null) kbCache[kbType] = (kaartEl2 && kaartEl2.clientWidth) || j.el.clientWidth || 200;
        var kb = kbCache[kbType];
        /* sold-detectie vóór het budget (review-fix 14-07): synchrone data-syk-sold-vlag óf de badge */
        var isSold = D.soldnet !== false && kaartEl2 && (kaartEl2.hasAttribute('data-syk-sold') || kaartEl2.querySelector('.syk-rv-sold'));
        var breed = Math.max(64, kb - 24 - (D.atc !== false ? 48 : 8)); /* kaartbreedte - binnenmarges - ATC-zone */
        if (isSold) breed = Math.max(48, breed - Math.round(String(D.tSoldnet || 'Wel leverbaar in:').length * 6.4) - 10); /* het kopje eet mee uit het swatch-budget */
        /* uitverkocht: staat er een gereserveerde variant-rij onder de maten (modus 'afbeelding-onder'),
           dan wordt de kaart TWEEREGELIG — kopje als bijschrift op de matenrij, bolletjes op de rij
           eronder. Het budget hierboven blijft bewust ONGEWIJZIGD: de bolletjes komen dan op exact
           dezelfde rij en met exact hetzelfde aantal als bij een NIET-uitverkochte kaart, dus sold- en
           niet-sold-kaarten zien er identiek uit. Zie syk-search.css bij .syk-rv-soldkop. */
        var soldOnder = isSold ? (j.el.parentNode && j.el.parentNode.querySelector('.syk-rv-imgrow')) : null;
        var meerWoord = D.tOokMeer == null ? 'kleuren' : String(D.tOokMeer).trim();
        if (bronSet) meerWoord = D.tOokSet == null ? 'opties' : String(D.tOokSet).trim();
        var tellerRuimte = meerWoord ? 34 + Math.round(meerWoord.length * 6.4) : 34;
        var max = Math.max(1, Math.min(4, Math.floor((breed - tellerRuimte) / 34)));
        if (items.length <= Math.min(4, Math.floor(breed / 34))) max = Math.min(4, Math.floor(breed / 34)); /* alles past zonder teller */
        var toon = items.slice(0, max);
        var rest = items.length - toon.length;
        var meerTekst = meerWoord;
        if (rest === 1) {
          /* review-fix 21-07: enkelvoud per taal uit de i18n-map ('Farbe'/'color'/'opción'); alleen
             wanneer de settingtekst op de taal-default staat — een EIGEN tekst van de eigenaar
             ('varianten') houdt de oude NL-strip ('+1 variant'). Sleutel weg = ook strip. */
          var enk = bronSet ? SYKT.ookSet1 : SYKT.ookMeer1;
          var enkB = bronSet ? SYKT.ookSetB : SYKT.ookMeerB;
          if (enk && (!enkB || meerWoord === enkB)) meerTekst = enk;
          else if (/en$/.test(meerTekst)) meerTekst = meerTekst.slice(0, -2); /* '+1 kleur' / '+1 variant' */
          else if (/s$/.test(meerTekst)) meerTekst = meerTekst.slice(0, -1); /* '+1 optie' */
        }
        var swHtml = '<span class="syk-ook-rij">' +
          toon.map(function (it) {
            return '<span class="syk-ook" role="link" tabindex="0" data-url="' + esc(it.u) + '" title="' + esc(it.t || '') + '">' +
              (it.img ? '<img src="' + esc(it.img) + '" alt="' + esc(it.t || '') + '" loading="lazy">' : '') + '</span>';
          }).join('') +
          (rest > 0 ? '<span class="syk-ook-meer">+' + rest + (meerTekst ? ' ' + esc(meerTekst) : '') + '</span>' : '') + '</span>';
        var vrMode = D.variantrij || 'maten';
        /* UITVERKOCHT-VANGNET (golf 1, wens eigenaar 14-07): een uitverkochte kaart is een doodlopende
           klik terwijl de leverbare kleur-broertjes al in deze items-lijst zitten (av-gefilterd). Op
           sold-kaarten dus altijd de swatches tonen mét context-kopje 'Wel leverbaar in:' — ongeacht
           de variantrij-modus. isSold is hierboven al bepaald (sync-vlag + badge) en het kopje is
           al in het swatch-budget meegerekend. */
        if (isSold) {
          var soldKop = '<span class="syk-ook-kop">' + esc(D.tSoldnet || 'Wel leverbaar in:') + '</span>';
          if (soldOnder) {
            /* tweeregelig: bijschrift boven, hele bolletjes op de gereserveerde rij eronder */
            j.el.innerHTML = soldKop;
            j.el.classList.add('syk-rv-soldkop');
            soldOnder.innerHTML = swHtml;
          } else {
            j.el.innerHTML = soldKop + swHtml;
            j.el.classList.add('syk-rv-soldnet');
          }
        } else if (j.leeg) {
          j.el.innerHTML = swHtml; /* accessoire zonder maten: kleurbolletjes vullen de rij */
        } else if (vrMode === 'alleen-maten') {
          /* niets doen: alleen de maat-tekst blijft staan */
        } else if (vrMode === 'kleuren') {
          /* KLEUREN voor maten (oud gedrag): swatches in een eigen rij, maat-tekst verbergen */
          if (!(j.el.nextElementSibling && j.el.nextElementSibling.classList.contains('syk-rv-ookrij'))) {
            var extra = document.createElement('span');
            extra.className = 'syk-rv-maten syk-rv-ookrij';
            extra.setAttribute('data-syk-ook', '1');
            extra.innerHTML = swHtml;
            j.el.parentNode.insertBefore(extra, j.el.nextSibling);
            j.el.classList.add('syk-maten-verborgen'); /* :has()-fallback: maat-tekst verbergen */
          }
        } else if (vrMode === 'kleuren-onder') {
          /* KLEUREN op een APARTE rij ONDER de maten, als stipjes (wens eigenaar 10-07). De maten
             blijven staan; de gereserveerde .syk-rv-dotrow eronder wordt met de kleurstipjes gevuld. */
          var dotrow = j.el.parentNode && j.el.parentNode.querySelector('.syk-rv-dotrow');
          if (!dotrow) {
            dotrow = document.createElement('span');
            dotrow.className = 'syk-rv-maten syk-rv-dotrow';
            dotrow.setAttribute('data-syk-ook', '1');
            j.el.parentNode.insertBefore(dotrow, j.el.nextSibling);
          }
          dotrow.innerHTML = '<span class="syk-mt-dots" aria-label="' + esc(SYKT.kleurdots || 'ook in andere kleuren') + '">' + items.slice(0, 8).map(function (it) { return sykKleurDot(it.t || ''); }).join('') + '</span>';
        } else if (vrMode === 'afbeelding-onder') {
          /* variant-AFBEELDINGEN op een APARTE rij onder de maten (wens eigenaar 14-07): kleine ronde
             productfoto's van de kleur-broertjes i.p.v. gevulde stipjes. De maten blijven staan; de
             gereserveerde .syk-rv-imgrow eronder krijgt de swatch-thumbnails (klikbaar naar dat product,
             mét '+N kleuren'-teller). Eigen klasse (géén .syk-rv-ookrij) zodat de :has()-regel de maten
             NIET verbergt — anders zou de maat-tekst wegvallen zoals in de 'kleuren'-modus. */
          var imgrow = j.el.parentNode && j.el.parentNode.querySelector('.syk-rv-imgrow');
          if (!imgrow) {
            imgrow = document.createElement('span');
            imgrow.className = 'syk-rv-maten syk-rv-imgrow';
            imgrow.setAttribute('data-syk-ook', '1');
            j.el.parentNode.insertBefore(imgrow, j.el.nextSibling);
          }
          imgrow.innerHTML = swHtml;
        } else if (!j.el.querySelector('.syk-mt-sz')) {
          /* MATEN voor kleuren (default; wens eigenaar 10-07: kinder-maten 128/140/158cm MOETEN
             zichtbaar blijven, ook als er een kleurvariant is). De maat-tekst blijft leidend en krimpt
             nooit. De kleur-info komt als kleine ECHTE-KLEUR-STIPJES erachter (sykKleurDot uit de
             sibling-titel; regenboog voor multicolor) — geen losse thumbnail. 'cm' vervalt zodat
             '140 · 158' + de stipjes samen op smalle kaarten passen (letter-maten S·M·L ongemoeid). */
          var dotItems = items.slice(0, 4);
          var dotRest = items.length - dotItems.length;
          var dotsInner = dotItems.map(function (it) { return sykKleurDot(it.t || ''); }).join('');
          var dotsHtml = '<span class="syk-mt-dots" aria-label="' + esc(SYKT.kleurdots || 'ook in andere kleuren') + '">' + dotsInner + (dotRest > 0 ? '<span class="syk-mt-plus">+' + dotRest + '</span>' : '') + '</span>';
          j.el.innerHTML = '<span class="syk-mt-sz">' + esc(j.el.textContent.replace(/\s*cm\b/gi, '')) + '</span>' + dotsHtml;
          j.el.classList.add('syk-rv-mix');
          mixEls.push(j.el); /* overflow-check gebatcht na alle writes (zie rAF hieronder) */
        }
      });
      /* passen de stipjes niet naast de maten (smalle mobiele kaart)? -> stipjes weg = schone maten
         i.p.v. een rommelige afkap-clip. De maat blijft altijd volledig staan. Loopt de matenreeks
         zelf nog over (bv. 6 maten 104-164cm)? -> zachte fade aan de rechterrand i.p.v. harde clip.
         GEBATCHT (adversarial review 14-07): eerst ALLE metingen in een rAF, dan pas de mutaties. */
      if (mixEls.length && window.requestAnimationFrame) {
        requestAnimationFrame(function () {
          var over1 = mixEls.map(function (el) { return el.isConnected !== false && el.clientWidth && el.scrollWidth > el.clientWidth + 1; });
          var nogEen = [];
          mixEls.forEach(function (el, k) {
            if (!over1[k]) return;
            var d0 = el.querySelector('.syk-mt-dots'); if (d0 && d0.parentNode) d0.parentNode.removeChild(d0);
            nogEen.push(el);
          });
          if (nogEen.length) requestAnimationFrame(function () {
            var over2 = nogEen.map(function (el) { return el.scrollWidth > el.clientWidth + 1; });
            nogEen.forEach(function (el, k) { if (over2[k]) el.classList.add('syk-rv-fade'); });
          });
        });
      }
      ookBezig = false;
      setTimeout(verrijkOok, 50); /* volgende golf (max 12 per keer) */
    }).catch(function () { ookBezig = false; });
  }
  /* ---- ATC-knop op kaarten (wens eigenaar): 1 variant = direct toevoegen, meer = maat-kiezer.
     Zelfde kloon-les als de filterbalk: alles gedelegeerd op document, geen wrap-listeners. ---- */
  /* zelfde symbolen als de thema-knoppen (Tabler shopping-cart/check, zoals lookcta en iadd op de
     PDP) — als INLINE svg: het tabler-font laadt niet op de zoekpagina en css-masks bleken daar
     onbetrouwbaar (leeg roze rondje op de geplakte versie) */
  /* thema-standaard knop (identiek aan native collectiekaarten: <button class="circle overlay-tertiary"
     style="--size:32px"><i class="icon-cart">) — instelbaar: stijl thema/eigen kleur, grootte, icoonkleur */
  function sykAtcIcoon(icoon) {
    /* de thema-.circle-regels zijn element-specifiek (button/a) — wij repliceren de cirkel exact
       met de THEMA-variabelen (--tertiary_bg/--tertiary_text = koopknop-kleur, icoonratio .468
       zoals native) op een span: element-onafhankelijk, dus ook veilig binnen rail-anchors */
    var maat = parseInt(D.atcMaat, 10) || 32;
    var eigen = D.atcStijl === 'eigen';
    return '<span class="syk-atc-c' + (eigen ? ' syk-atc-eigenc' : '') + '" style="--size:' + maat + 'px"><i class="' + (icoon || 'icon-cart') + '" aria-hidden="true"></i></span>';
  }
  function sykAtcVink() { return sykAtcIcoon('icon-check'); }
  function sykAtcHtml(url, beschikbaar) {
    if (D.atc === false || beschikbaar === false) return '';
    var m = String(url || '').split('?')[0].match(/\/products\/([^\/?#]+)\/?$/);
    if (!m || m[1].indexOf('.') > -1) return '';
    return '<span class="syk-atc" role="button" tabindex="0" aria-label="' + esc(SYKT.inCart || 'In winkelwagen') + '" aria-haspopup="true" aria-expanded="false" data-handle="' + esc(m[1]) + '">' + sykAtcIcoon() + '</span>';
  }
  function sykAtcSluit(focusTerug) {
    [].forEach.call(document.querySelectorAll('.syk-atc-kies'), function (el) {
      var kaart = el.closest('li.product-card, a.syk-ls-rvkaart');
      var knop = kaart && kaart.querySelector('.syk-atc');
      if (knop) { knop.setAttribute('aria-expanded', 'false'); if (focusTerug) { try { knop.focus(); } catch (e) {} } }
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  }
  /* leverdata-props op de quick-add (wens eigenaar: _deliverydate/_deliverystamp horen in de order,
     precies zoals de PDP ze meegeeft). We zoeken de leverdatum van de TOEGEVOEGDE variant op uit de
     bulk-levertijd (meestal al gecachet bij de kaart-verrijking) en geven 'm mee als verborgen
     line-item properties (zelfde vorm als de PDP: '_deliverydate' = 'woensdag 15 juli', '_deliverystamp' = ms). */
  function sykDelivProps(handle, vid) {
    if (!handle) return Promise.resolve({});
    return haalProduct(handle).then(function (p) {
      if (!p) return {};
      var v = (p.variants || []).filter(function (x) { return x.id === vid; })[0];
      if (!v) return {};
      var key = String(v.barcode || v.sku || v.id);
      return bulkHaal([{ sku: key, quantity: 1, available: true }]).then(function (dmap) {
        var rec = dmap && dmap[key];
        if (!rec || !rec.deliveryDate) return {};
        var dd = new Date(rec.deliveryDate);
        if (isNaN(dd.getTime())) return {};
        /* EXACT de PDP-vorm (adversarial review 14-07): de PDP schrijft 'Vandaag'/'Morgen' i.p.v. de
           volle datum — een afwijkende property-waarde laat DEZELFDE variant in twee cart-regels
           splitsen (properties zijn onderdeel van de regel-sleutel). Zelfde teksten = regels mergen. */
        var n2 = Math.round((new Date(dd.getFullYear(), dd.getMonth(), dd.getDate()) - new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) / 86400000);
        var dtxt = n2 <= 0 ? (I18S.sToday || 'Vandaag') : (n2 === 1 ? (I18S.sTomorrow || 'Morgen') : dd.toLocaleDateString(I18S.locale || 'nl', { weekday: 'long', day: 'numeric', month: 'long' }));
        return { '_deliverydate': dtxt, '_deliverystamp': String(dd.getTime()) };
      });
    }).catch(function () { return {}; });
  }
  function sykAtcVoegToe(vid, knop) {
    /* re-entry-guard (adversarial review 14-07): dubbele tik of toets-repeat mag NOOIT een tweede
       /cart/add sturen zolang de eerste loopt — de leverdata-race hield het venster tot ~1s open. */
    if (knop.classList.contains('syk-atc--bezig')) return;
    knop.classList.add('syk-atc--bezig');
    /* leverdata ophalen, kort gecapt (900ms; de bulk-cache is door de paneel-prefetch vrijwel altijd
       al warm) zodat de add snel voelt en NOOIT blijft hangen als de data niet klaarstaat */
    Promise.race([sykDelivProps(knop.getAttribute('data-handle'), vid), new Promise(function (res) { setTimeout(function () { res({}); }, 900); })])
      .then(function (props) {
        var item = { id: vid, quantity: 1 };
        if (props && (props['_deliverydate'] || props['_deliverystamp'])) item.properties = props;
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
      })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        sykAtcSluit();
        knop.classList.remove('syk-atc--bezig');
        knop.classList.add('syk-atc--ok');
        knop.innerHTML = sykAtcVink();
        telBij(1); verversDrawer();
        setTimeout(function () { knop.classList.remove('syk-atc--ok'); knop.innerHTML = sykAtcIcoon(); }, 1600);
      })
      .catch(function () { knop.classList.remove('syk-atc--bezig'); });
  }
  function sykAtcOpen(knop) {
    var handle = knop.getAttribute('data-handle');
    if (!handle || knop.classList.contains('syk-atc--bezig')) return;
    var kaart = knop.closest('li.product-card, a.syk-ls-rvkaart');
    if (kaart && kaart.querySelector('.syk-atc-kies')) { sykAtcSluit(); return; } /* nogmaals klikken sluit */
    knop.classList.add('syk-atc--bezig');
    haalProduct(handle).then(function (p) {
      knop.classList.remove('syk-atc--bezig');
      if (!p) return;
      var vs = p.variants || [];
      var open = vs.filter(function (v) { return v.available; });
      if (!open.length) return;
      if (vs.length === 1) { sykAtcVoegToe(open[0].id, knop); return; }
      /* prefetch (adversarial review 14-07): warm de bulk-leverdata voor ALLE beschikbare maten
         terwijl de bezoeker naar het kiespaneel kijkt — de 900ms-race bij de maat-klik treft dan
         vrijwel altijd een al-vervulde cache i.p.v. een verse fetch (snellere koopactie op mobiel). */
      try { bulkHaal(open.slice(0, 8).map(function (v) { return { sku: String(v.barcode || v.sku || v.id), quantity: 1, available: true }; })); } catch (e3) {}
      sykAtcSluit();
      if (!kaart) return;
      var paneel = document.createElement('span');
      paneel.className = 'syk-atc-kies';
      paneel.innerHTML = '<b>' + esc(D.tKies || 'Kies je maat') + '</b><span class="syk-atc-maten" role="group" aria-label="' + esc(D.tKies || 'Kies je maat') + '">' +
        vs.map(function (v) {
          var naam = String(v.title || '').replace('Default Title', 'One size');
          return '<span class="syk-atc-maat' + (v.available ? '' : ' syk-atc-maat--uit') + '" role="button" tabindex="' + (v.available ? '0' : '-1') + '"' + (v.available ? ' data-vid="' + v.id + '"' : ' aria-disabled="true"') + ' aria-label="' + esc(naam) + (v.available ? '' : ' – ' + esc(SYKT.uitverkocht || 'uitverkocht')) + '">' + esc(naam) + '</span>';
        }).join('') + '</span>';
      kaart.appendChild(paneel);
      knop.setAttribute('aria-expanded', 'true');
      var eersteMaat = paneel.querySelector('.syk-atc-maat[data-vid]');
      if (eersteMaat) { try { eersteMaat.focus(); } catch (e2) {} }
    }).catch(function () { knop.classList.remove('syk-atc--bezig'); });
  }
  /* capture: swatch-klik wint van de kaart-link eromheen (geneste anchors kunnen niet) */
  function sykKaartKlik(e) {
    if (!e.target || !e.target.closest) return;
    var sw = e.target.closest('.syk-ook');
    if (sw && sw.getAttribute('data-url')) { if (e.preventDefault) { e.preventDefault(); e.stopPropagation(); } location.href = sw.getAttribute('data-url'); return; }
    var knop = e.target.closest('.syk-atc');
    if (knop) { if (e.preventDefault) { e.preventDefault(); e.stopPropagation(); } sykAtcOpen(knop); return; }
    var maat = e.target.closest('.syk-atc-maat');
    if (maat) {
      if (e.preventDefault) { e.preventDefault(); e.stopPropagation(); }
      var vid = parseInt(maat.getAttribute('data-vid') || '', 10);
      var kaart = maat.closest('li.product-card, a.syk-ls-rvkaart');
      var k2 = kaart && kaart.querySelector('.syk-atc');
      if (vid && k2) sykAtcVoegToe(vid, k2);
      return;
    }
    if (e.target.closest('.syk-atc-kies')) { if (e.preventDefault) { e.preventDefault(); e.stopPropagation(); } return; }
    if (document.querySelector('.syk-atc-kies')) sykAtcSluit(); /* klik ernaast sluit de kiezer */
  }
  document.addEventListener('click', function (e) {
    if (sykTapNet(e)) { e.preventDefault(); e.stopPropagation(); return; } /* al afgehandeld op pointer-niveau */
    sykKaartKlik(e);
  }, true);
  /* ---- TAP-MOTOR (melding eigenaar: pills op echt toestel soms niet klikbaar; synthetische
     test-clicks werkten altijd): thema/app-scripts kunnen met preventDefault op touchend het
     click-event doden voordat het ontstaat — dan helpt ook capture niet. Daarom handelen we
     ECHTE taps zelf af op pointer-niveau (down->up, <12px beweging) en onderdrukken we het
     eventueel alsnog komende click-event 700ms zodat niets dubbel vuurt. ---- */
  var sykTapTijd = 0, sykTapX = 0, sykTapY = 0, sykTapId = null;
  /* diagnose op toestel: ?sykdebug=1 toont per tik WELK element geraakt wordt (bovenin beeld) */
  var sykDebug = false;
  try { sykDebug = new URLSearchParams(location.search).get('sykdebug') === '1'; } catch (e) {}
  function sykDebugToon(e) {
    if (!sykDebug) return;
    var el = document.elementFromPoint(e.clientX, e.clientY);
    var pad = [];
    var n2 = el;
    while (n2 && n2 !== document.body && pad.length < 4) { pad.push(n2.tagName.toLowerCase() + (n2.className && typeof n2.className === 'string' ? '.' + n2.className.split(' ').slice(0, 2).join('.') : '')); n2 = n2.parentElement; }
    var box = document.getElementById('syk-tapdebug');
    if (!box) {
      box = document.createElement('div');
      box.id = 'syk-tapdebug';
      box.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:2147483647;background:#111;color:#0f0;font:10px/1.4 monospace;padding:4px 8px;pointer-events:none;word-break:break-all';
      document.body.appendChild(box);
    }
    box.textContent = pad.join(' < ');
  }
  function sykTapDoelwit(e) {
    return !!(e.target && e.target.closest && e.target.closest('.syk-fb-chip,.syk-fb-acckop,.syk-fb-sopt,.syk-fb-toon,.syk-fb-x,.syk-fb-reset,.syk-fb-achip,.syk-fb-wis,.syk-fb-optie,.syk-atc,.syk-atc-maat,.syk-ook,.syk-sr-cats a,[data-syk-sug],.syk-sr-dym a'));
  }
  function sykTapNet(e) { return (Date.now() - sykTapTijd) < 700 && sykTapDoelwit(e); }
  document.addEventListener('pointerdown', function (e) {
    if (e.isPrimary === false) return;
    sykTapId = e.pointerId; sykTapX = e.clientX; sykTapY = e.clientY;
    sykDebugToon(e);
  }, true);
  document.addEventListener('pointercancel', function () { sykTapId = null; }, true);
  document.addEventListener('pointerup', function (e) {
    if (sykTapId == null || e.pointerId !== sykTapId) return;
    sykTapId = null;
    if (Math.abs(e.clientX - sykTapX) > 12 || Math.abs(e.clientY - sykTapY) > 12) return; /* veeg/scroll, geen tap */
    if (!sykTapDoelwit(e)) return;
    sykTapTijd = Date.now();
    /* optie-pill: checkbox zelf togglen + change dispatchen (native label-click kan onderweg gesneuveld zijn) */
    var lab = e.target.closest('.syk-fb-optie');
    if (lab) {
      var inp = lab.querySelector('input[type="checkbox"]');
      if (inp) { inp.checked = !inp.checked; try { inp.dispatchEvent(new Event('change', { bubbles: true })); } catch (e2) {} }
      return;
    }
    var catLink = e.target.closest('.syk-sr-cats a');
    if (catLink && catLink.href) { location.href = catLink.href; return; }
    /* 'Bedoelde je'/zoekterm-pills: zelfde logica als de click-delegatie, maar click-onafhankelijk
       (zelfde reden als de rest van de tap-motor: thema/app-scripts kunnen het click-event doden) */
    var sug = e.target.closest('[data-syk-sug]');
    if (sug) {
      var inpS = zoekInput();
      if (inpS) {
        inpS.value = sug.getAttribute('data-syk-sug') || '';
        inpS.focus();
        try { inpS.dispatchEvent(new Event('input', { bubbles: true })); inpS.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: 'a' })); } catch (e3) {}
      } else if (sug.href) { location.href = sug.href; }
      return;
    }
    var dymA = e.target.closest('.syk-sr-dym a');
    if (dymA && dymA.href) { location.href = dymA.href; return; }
    sykKaartKlik(e);
    if (typeof window.__sykFbKlik === 'function') window.__sykFbKlik(e);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (document.querySelector('.syk-atc-kies')) { e.preventDefault(); sykAtcSluit(true); }
      return;
    }
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    if (e.repeat) { e.preventDefault(); return; } /* toets vasthouden = auto-repeat -> geen add-regen (adversarial review 14-07) */
    if (!e.target || !e.target.closest) return;
    var sw = e.target.closest('.syk-ook');
    if (sw && sw.getAttribute('data-url')) { e.preventDefault(); location.href = sw.getAttribute('data-url'); return; }
    var act = e.target.closest('.syk-atc, .syk-atc-maat');
    if (act) { e.preventDefault(); act.click(); } /* preventDefault stopt ook pagina-scroll bij Spatie */
  }, true);
  /* kaart-labels (wens eigenaar 08-07): 'Bestseller' e.d. op kaarten van producten die in de
     echte verkoop-top staan (syk-trending, best-selling-sortering, dagcache); aan/uit, tekst,
     aantal en kleur instelbaar in de theme editor */
  var sykBestSet = null;   /* verkoop-top: handle -> 'best' | 'pop' (rang-tranches) */
  var sykBadgeMap = null;  /* metafield: handle -> PDP-label (custom.galerij_badge) */
  var sykNieuwSet = null;  /* handle -> true als gepubliceerd binnen het nieuw-venster (default 90 dagen) */
  function sykIsNieuw(pubEpoch) {
    if (D.labelNieuw === false || !pubEpoch) return false;
    var dagen = parseInt(D.nieuwDagen, 10) || 90;
    return (Date.now() / 1000 - parseInt(pubEpoch, 10)) < dagen * 86400;
  }
  function sykLabelBron() { return D.labelBron || 'slim'; }
  function sykAutoTekst(handle) {
    if (sykBestSet && sykBestSet[handle] === 'best') return D.tLabelBest || 'Bestseller';
    if (sykBestSet && sykBestSet[handle] === 'pop') return D.tLabelPop || 'Populair';
    if (sykNieuwSet && sykNieuwSet[handle]) return D.tLabelNieuw || 'Nieuw';
    return '';
  }
  function sykLabelTekst(handle) {
    var bron = sykLabelBron();
    if (bron === 'auto') return sykAutoTekst(handle);
    if (bron === 'metafield') return (sykBadgeMap && sykBadgeMap[handle]) || '';
    /* 'slim' (default): handmatig metafield wint, anders automatisch op verkoopdata */
    return (sykBadgeMap && sykBadgeMap[handle]) || sykAutoTekst(handle);
  }
  function sykLabelIcoon(tekst) {
    /* mobiel: vaste labels worden een icoontje; eigen teksten blijven (kleine) tekst-pill.
       melding eigenaar 21-07: VS16 (\uFE0F) afdwingen — U+2B50 (ster) is dual-presentation en
       rendert zonder selector als MONOCHROOM tekstglyfje dat de witte labelkleur erft =
       onzichtbaar wit bolletje. VS16 is voor emoji-only tekens (vuur/sparkles) onschadelijk. */
    var t2 = String(tekst).toLowerCase();
    var ico = '';
    if (t2 === String(D.tLabelBest || 'Bestseller').toLowerCase()) ico = D.icoBest || '\ud83d\udd25';
    else if (t2 === String(D.tLabelPop || 'Populair').toLowerCase()) ico = D.icoPop || '\u2b50';
    else if (t2 === String(D.tLabelNieuw || 'Nieuw').toLowerCase()) ico = D.icoNieuw || '\u2728';
    if (ico && ico.indexOf('\uFE0F') < 0) ico += '\uFE0F';
    return ico;
  }
  function sykZetLabel(k, tekst) {
    if (!tekst || k.querySelector('.syk-kaartlabel')) return;
    var b = document.createElement('span');
    b.className = 'syk-kaartlabel';
    b.textContent = tekst;
    var ico = sykLabelIcoon(tekst);
    if (ico) b.setAttribute('data-icoon', ico);
    var themaPil = k.querySelector('.label, .s1lb');
    /* elke thema-kaart bevat een VERBORGEN lege .label-placeholder — alleen wijken voor een pil
       die echt zichtbaar is en tekst draagt (anders stond ons label altijd op 40px, midden in de foto) */
    if (themaPil && themaPil.textContent.trim() && themaPil.getBoundingClientRect().height > 0) b.style.top = '40px';
    k.appendChild(b);
  }
  function sykLabelPass() {
    if (D.labelBest === false) return;
    var bron = sykLabelBron();
    if (bron === 'auto' && !sykBestSet) return;
    if (bron === 'metafield' && !sykBadgeMap) return;
    if (bron === 'slim' && (!sykBadgeMap || !sykBestSet)) return; /* pas markeren als BEIDE bronnen er zijn */
    var doelen = document.querySelectorAll('ul.l4cl li.product-card:not([data-syk-label]), a.syk-ls-rvkaart:not([data-syk-label])');
    [].forEach.call(doelen, function (k) {
      k.setAttribute('data-syk-label', '1');
      var a = k.matches('a') ? k : k.querySelector('.h3 a, a[href*="/products/"]');
      var m = a && String(a.getAttribute('href') || '').split('?')[0].match(/\/products\/([^\/?#]+)\/?$/);
      if (m) sykZetLabel(k, sykLabelTekst(m[1]));
    });
  }
  function sykLabelsInit() {
    if (D.labelBest === false) return;
    var bron = sykLabelBron();
    if (bron !== 'metafield') {
      var topBest = parseInt(D.labelTop, 10) || 8;
      var topPop = parseInt(D.labelPopTot, 10) || 16;
      var topLijst = D.top30 && D.top30.h && D.top30.h.length ? D.top30.h : null;
      if (topLijst) {
        /* primaire bron: shop-metafield syk.top_verkoop — top-200 op ECHT verkochte aantallen
           (30-dagen-orderdata, dagelijks ververst door de geplande taak); rangorde = index */
        sykBestSet = {};
        for (var ti = 0; ti < topLijst.length && ti < topPop; ti++) sykBestSet[topLijst[ti]] = ti < topBest ? 'best' : 'pop';
        sykLabelPass(); setTimeout(sykLabelPass, 1500); setTimeout(sykLabelPass, 4000);
        if (bron === 'auto' && D.labelNieuw !== false) {
          /* zonder badges-sectie (bron 'auto') komt 'Nieuw' uit de trending-publicatiedata */
          haalTrending().then(function (data) {
            if (!data || !data.producten) return;
            sykNieuwSet = sykNieuwSet || {};
            data.producten.forEach(function (d) {
              var m = String(d.url || '').split('?')[0].match(/\/products\/([^\/?#]+)\/?$/);
              if (m && sykIsNieuw(d.pub)) sykNieuwSet[m[1]] = true;
            });
            sykLabelPass();
          });
        }
      } else {
        /* terugval zonder metafield-lijst: trending-sectie (best-selling-sortering, top 40) */
        haalTrending().then(function (data) {
          if (!data || !data.producten) return;
          sykBestSet = {};
          sykNieuwSet = sykNieuwSet || {};
          data.producten.forEach(function (d, di) {
            var m = String(d.url || '').split('?')[0].match(/\/products\/([^\/?#]+)\/?$/);
            if (!m) return;
            if (di < topBest) sykBestSet[m[1]] = 'best';
            else if (di < topPop) sykBestSet[m[1]] = 'pop';
            if (sykIsNieuw(d.pub)) sykNieuwSet[m[1]] = true;
          });
          sykLabelPass(); setTimeout(sykLabelPass, 1500); setTimeout(sykLabelPass, 4000);
        });
      }
      if (bron === 'auto') return;
    }
    /* metafield-kant (bron 'metafield' of 'slim'): kleine datasectie levert handle->badge voor de HELE resultatenpagina */
    var sleutel = 'sykBadges2:' + location.search.slice(0, 100);
    var cache = cacheLees(sleutel);
    if (cache) { sykBadgeMap = cache.b || {}; sykNieuwSet = cache.n || {}; sykLabelPass(); setTimeout(sykLabelPass, 1500); return; }
    var params;
    try { params = new URLSearchParams(location.search); } catch (e) { return; }
    params.set('section_id', 'syk-badges');
    fetch(location.pathname + '?' + params.toString(), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (h2) {
        var tmp = document.createElement('div'); tmp.innerHTML = h2;
        var el = tmp.querySelector('[data-syk-badges]');
        sykBadgeMap = {}; sykNieuwSet = {};
        if (el) {
          try {
            var ruw = JSON.parse(el.textContent) || {};
            for (var hk in ruw) {
              var it = ruw[hk];
              if (it && typeof it === 'object') {
                if (it.b) sykBadgeMap[hk] = it.b;
                if (sykIsNieuw(it.p)) sykNieuwSet[hk] = true;
              } else if (it) { sykBadgeMap[hk] = it; } /* oud sectie-formaat (nog niet geplakt) */
            }
          } catch (e2) {}
        }
        cacheSchrijf(sleutel, { b: sykBadgeMap, n: sykNieuwSet });
        sykLabelPass(); setTimeout(sykLabelPass, 1500); setTimeout(sykLabelPass, 4000);
      })
      .catch(function () {});
  }
  var trendCache = null;
  function haalTrending() {
    if (trendCache) return trendCache;
    var uitCache = cacheLees('sykTrend');
    if (uitCache) { trendCache = Promise.resolve(uitCache); return trendCache; }
    trendCache = fetch('/collections/' + encodeURIComponent(D.bestCol || 'all') + '?sort_by=best-selling&section_id=syk-trending', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var el = tmp.querySelector('[data-syk-trending]');
        var data = el ? JSON.parse(el.textContent) : null;
        if (data && data.producten && data.producten.length) { cacheSchrijf('sykTrend', data); return data; }
        return null;
      })
      .catch(function () { return null; });
    return trendCache;
  }
  function vulTrending(doel) {
    /* 'Onze bestsellers' (Shopify best-selling-sortering = echte verkoopstatistiek) +
       'Trending categorieen' (collecties waar die bestsellers in zitten, geteld op frequentie) */
    if ((!D.best && !D.trend) || !doel || doel.getAttribute('data-syk-trend')) return;
    doel.setAttribute('data-syk-trend', '1');
    haalTrending().then(function (data) {
      if (!data || !data.producten) return;
      /* service-artikelen (garantie/toeslag e.d.) horen niet tussen de bestsellers */
      var prods = data.producten.filter(function (d) {
        if (d.beschikbaar === false) return false;
        return !SYK_SERVICE_RE.test(String(d.titel || ''));
      });
      if (D.trend) {
        var telling = {}, info = {};
        prods.forEach(function (d) {
          (d.collecties || []).forEach(function (c) {
            if (!c || !c.h) return;
            telling[c.h] = (telling[c.h] || 0) + 1;
            if (!info[c.h]) info[c.h] = c;
          });
        });
        var top = Object.keys(telling).sort(function (a, b) { return telling[b] - telling[a]; }).slice(0, 6);
        if (top.length >= 2) {
          var blok = document.createElement('div');
          blok.className = 'syk-ls-trendcat';
          blok.innerHTML = '<p class="syk-ls-kop">' + esc(D.tTrend || 'Trending categorieën') + '</p><div class="syk-ls-themas">' +
            top.map(function (h) {
              var c = info[h];
              return '<a class="syk-ls-thema" href="' + esc(c.u) + '">' +
                /* 07-08: ook hier de CDN-maat meegeven — .syk-ls-timg is 32px, dus 64 volstaat;
                   hiervoor werd de originele collectiefoto (tot ~500 kB) geladen voor dat bolletje. */
                (c.img ? '<img class="syk-ls-timg" src="' + esc(sykCdnBreedte(c.img, 64)) + '" alt="" loading="lazy">' : '<span class="syk-ls-temoji" aria-hidden="true">🔥</span>') +
                '<span class="syk-ls-tnaam">' + esc(c.t) + '</span></a>';
            }).join('') + '</div>';
          doel.appendChild(blok);
        }
      }
      if (D.best && prods.length) {
        var wrap = document.createElement('div');
        wrap.className = 'syk-ls-best';
        wrap.innerHTML = '<p class="syk-ls-kop">' + esc(D.tBest || 'Onze bestsellers') + '</p><div class="syk-ls-rvrail"></div>';
        doel.appendChild(wrap);
        var items = [], gezien = {};
        prods.slice(0, 8).forEach(function (d) {
          (d.skus || []).slice(0, 6).forEach(function (sku) { if (!gezien[sku]) { gezien[sku] = 1; items.push({ sku: sku, quantity: 1, available: true }); } });
        });
        bulkHaal(items).then(function (dmap) {
          wrap.querySelector('.syk-ls-rvrail').innerHTML = prods.slice(0, 8).map(function (d) { return bouwKaartHtml(d, dmap); }).join('');
          verrijkOok();
          sykLabelPass();
        });
      }
    });
  }
  function toonLegeStaat() {
    if (!ls || sykNavigeert) return;
    var inp = zoekInput();
    if (!inp || inp.value.trim() !== '') return;
    /* adversarial #3/#5: alleen (her)openen zolang het zoekveld daadwerkelijk focus heeft — de
       uitgestelde naslagen zetten de paginabrede overlay anders TERUG terwijl de klant al op de
       filterchips tikt (overlay vangt dan alle taps: 'filters niet altijd klikbaar') */
    if (document.activeElement !== inp) return;
    if (!ls.querySelector('.syk-ls-leeg')) {
      ls.innerHTML = '';
      ls.appendChild(bouwLegeStaat());
      vulLegeStaat();
    }
    /* cart kan intussen gewijzigd zijn (thema-ATC, drawer-verwijdering) — verse snapshot en
       bij een moduswissel de lege staat herbouwen zodat de look-rail verschijnt/verdwijnt */
    sykCartHaal().then(function () {
      var leeg2 = ls.querySelector('.syk-ls-leeg');
      if (!leeg2) return;
      if ((leeg2.getAttribute('data-syk-cart') || '') !== sykCartModus()) {
        ls.innerHTML = '';
        ls.appendChild(bouwLegeStaat());
        vulLegeStaat();
      }
    });
    document.documentElement.classList.add('search-full', 'search-full-mode');
    var sf = document.getElementById('search');
    if (sf) { sf.classList.add('full', 'has-text'); sf.classList.remove('processing'); }
  }
  function vulLegeStaat() {
    if (!ls) return;
    var leeg = ls.querySelector('.syk-ls-leeg');
    if (!leeg) return;
    var cmL = leeg.getAttribute('data-syk-cart') || '';
    if (cmL) vulCartLook(leeg); /* look-rail bovenaan (insertBefore firstChild, dus boven recent-gezocht) */
    /* recent gezocht bovenaan */
    if (!leeg.querySelector('.syk-ls-recent')) {
      var rs = leesRecent();
      if (rs.length) {
        var blok = document.createElement('div');
        blok.className = 'syk-ls-recent';
        blok.innerHTML = '<p class="syk-ls-kop">' + esc(D.tRecent || 'Recent gezocht') + '</p><div class="syk-ls-pills">' + rs.map(function (r) {
          var esc = r.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
          return '<a class="syk-ls-pill" href="/search?q=' + encodeURIComponent(sykSterTerm(r)) + '" data-syk-sug="' + esc + '">' + esc + '</a>';
        }).join('') + '</div>';
        leeg.insertBefore(blok, leeg.querySelector('.syk-ls-chead') ? leeg.querySelector('.syk-ls-chead').nextSibling : leeg.firstChild);
      }
    }
    /* AFFINITEIT (wens eigenaar 14-07, 'search intuïtiever'): collecties die passen bij de LAATSTE
       zoekopdrachten van deze bezoeker — per recente term de collectie-suggest (dag-cache, eigen
       sykAff:-namespace), samengevoegd + ontdubbeld, als dezelfde foto+naam-chips als de categorie-
       pills. Direct onder 'Recent gezocht' (zelfde persoonlijke context); opt-out via instelling. */
    if (D.affiniteit !== false && !leeg.querySelector('.syk-ls-affiniteit')) {
      var rsA = leesRecent().slice(0, 3);
      if (rsA.length) {
        Promise.all(rsA.map(function (term) {
          var sleutelA = 'sykAff:' + term.toLowerCase();
          var uitC = cacheLees(sleutelA);
          if (uitC) return Promise.resolve(uitC);
          return fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=collection&resources[limit]=4', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (d2) {
              var lijst = ((d2 && d2.resources && d2.resources.results && d2.resources.results.collections) || []).map(function (c) {
                return { title: c.title, url: c.url, img: (c.featured_image && c.featured_image.url) ? c.featured_image.url : '' };
              });
              cacheSchrijf(sleutelA, lijst);
              return lijst;
            }).catch(function () { return []; });
        })).then(function (lijsten) {
          if (!leeg.isConnected || leeg.querySelector('.syk-ls-affiniteit')) return;
          /* ontdubbelen op het PAD, niet op de hele url (melding eigenaar 07-08: 'Ninja masker' en
             'Ninja mes' stonden er twee keer in). Dit blok voegt de collecties van maximaal drie
             recente zoektermen samen, en Shopify hangt er per zoekterm een andere staart aan
             (?_pos=..&_psq=..&_psid=..). Op de hele url vergelijken laat dezelfde collectie dus
             gewoon door. De rest van dit bestand ontdubbelt al op split('?')[0]; nu hier ook. */
          var urlsA = {}, cols = [];
          lijsten.forEach(function (l2) {
            (l2 || []).forEach(function (c) {
              if (!c || !c.url) return;
              var padA = String(c.url).split('?')[0];
              if (urlsA[padA]) return;
              urlsA[padA] = 1;
              cols.push(c);
            });
          });
          cols = cols.slice(0, 8);
          if (!cols.length) return;
          var blokA = document.createElement('div');
          blokA.className = 'syk-ls-affiniteit';
          /* review-fix 07-08: dit is de DERDE plek met dezelfde collectie-chips en die liep achter —
             hardgecodeerde klasse (dus pills terwijl de instelling op tegels stond, in dezelfde
             dropdown), de kale cdn-url (honderden kB per fotootje) en geen letter-terugval. Nu via
             precies dezelfde helpers als de categorie-rail. De telling-klasse hoort hier niet bij:
             deze bron kent sowieso geen aantallen. */
          blokA.innerHTML = '<p class="syk-ls-kop">' + esc(D.tAff || 'Verder zoeken in') + '</p><div class="' + sykCatKlas().replace(' syk-ls-chips--tel', '') + '">' +
            cols.map(function (c) {
              return '<a class="syk-ls-chip"' + (c.img ? '' : ' data-letter="' + esc(String(c.title || '?').trim().charAt(0).toUpperCase()) + '"') + ' href="' + esc(c.url) + '">' +
                (c.img ? '<img src="' + esc(sykCatImg(c.img)) + '" alt="" loading="lazy">' : '') + '<span>' + esc(c.title) + '</span></a>';
            }).join('') + '</div>';
          var naRecent = leeg.querySelector('.syk-ls-recent');
          if (naRecent) leeg.insertBefore(blokA, naRecent.nextSibling);
          else leeg.insertBefore(blokA, leeg.firstChild);
        });
      }
    }
    if (cmL !== 'focus') vulTrending(leeg); /* focus-modus: geen trending/bestsellers — alles op de look */
    /* recent bekeken onderaan: volwaardige PDP-stijl kaarten (verzoek eigenaar: zelfde tegels
       als 'recent bekeken' op de productpagina — foto, titel, prijs, maat-chips, levertijd via bulk-API).
       Blijft OOK in cart-focus-modus staan (wens eigenaar 09-07): verder winkelen waar je was. */
    if (!leeg.querySelector('.syk-ls-rv')) {
      var rv = [];
      try { rv = JSON.parse(localStorage.getItem('recentlyViewedProduct') || '[]'); } catch (e) {}
      var handles = [];
      rv.slice().reverse().forEach(function (x) {
        var m = String((x && x.productUrl) || '').split('?')[0].match(/\/products\/([^\/?#]+)\/?$/);
        if (m && m[1].indexOf('.') === -1 && handles.indexOf(m[1]) === -1) handles.push(m[1]);
      });
      handles = handles.slice(0, 6);
      if (handles.length) {
        var wrap = document.createElement('div');
        wrap.className = 'syk-ls-rv';
        wrap.innerHTML = '<p class="syk-ls-kop">' + esc(D.tRv || 'Recent bekeken') + '</p><div class="syk-ls-rvrail"></div>';
        leeg.appendChild(wrap);
        Promise.all(handles.map(haalProduct)).then(function (ps) {
          var built = [], items = [], gezien = {};
          ps.filter(Boolean).forEach(function (p) {
            var sizeOpt = (p.options || []).indexOf('Maat') > -1 ? 'Maat' : ((p.options || [])[0] || '');
            var sizes = [];
            if (sizeOpt && sizeOpt !== 'Title' && (p.variants || []).length > 1) {
              var seen = {};
              (p.variants || []).forEach(function (v) {
                var name = v.options[(p.options || []).indexOf(sizeOpt)];
                if (name && name !== 'Default Title' && !seen[name] && v.available) { seen[name] = 1; sizes.push({ name: name, av: true }); }
              });
            }
            var skus = sykSkus(p, 6);
            skus.forEach(function (sku) { if (!gezien[sku]) { gezien[sku] = 1; items.push({ sku: sku, quantity: 1, available: true }); } });
            built.push({ skus: skus, p: p, sizes: sizes });
          });
          function render(dmap) {
            var html = built.map(function (b) {
              var p = b.p;
              var img = p.featured_image ? '<img src="' + esc(p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=300') + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
              var prijs = (p.price_min != null && p.price_max != null && p.price_min !== p.price_max)
                ? '<small>' + esc(SYKT.vanaf || 'Vanaf') + '</small> ' + geldEUR(p.price_min || 0)
                : geldEUR(p.price || 0);
              var chips = esc(b.sizes.slice(0, 8).map(function (o) { return o.name; }).join(' \u00b7 '));
              var lever = sykLeverHtml(dmap, b.skus, p.available !== false);
              return '<a class="syk-ls-rvkaart" href="' + esc(p.url) + '">' +
                '<span class="syk-rv-media">' + img + '</span>' +
                '<span class="syk-rv-body"><b class="syk-rv-naam">' + esc(p.title) + '</b>' +
                '<span class="syk-rv-prijs">' + prijs + '</span>' +
                '<span class="syk-rv-maten">' + (chips || '') + '</span>' +
                lever + '</span>' + sykAtcHtml(p.url, p.available !== false) + '</a>';
            }).join('');
            var rail = wrap.querySelector('.syk-ls-rvrail');
            if (html) { rail.innerHTML = html; verrijkOok(); sykLabelPass(); } else wrap.remove();
          }
          if (items.length) { bulkHaal(items).then(render); } else { render({}); }
        });
      }
    }
  }
  if (ls) {
    /* cart-snapshot niet site-breed eager (review #13: +1 request op ELKE paginaweergave in het
       laadvenster) — alleen op de zoekpagina zelf; elders haalt de focus-intentie hem op */
    if (document.body && document.body.classList.contains('template-search')) sykCartHaal();
    /* de zoekpagina rendert een NATIVE .search-placeholders (kale linkjes) die het thema 300ms na
       elke leeg-veld-actie terugzet over onze lege staat heen ('onder water'-scherm) — weghalen
       voordat het thema hem vangt, en via de observer terugslaan als hij toch verschijnt */
    try { [].forEach.call(ls.querySelectorAll('.search-placeholders'), function (el) { el.parentNode.removeChild(el); }); } catch (e) {}
    try {
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          naInjectie();
          vulLegeStaat();
          var inp2 = zoekInput();
          if (inp2 && inp2.value.trim() === '' && (ls.querySelector('.search-placeholders') || !ls.querySelector('.syk-ls'))) toonLegeStaat();
        }, 150);
      }).observe(ls, { childList: true });
    } catch (e) {}
    setTimeout(function () { naInjectie(); vulLegeStaat(); }, 400);
    /* lege-staat tonen bij focus op leeg veld, en terugzetten nadat het thema het paneel
       sluit bij leeg-typen (setTimeout zodat wij NA de thema-handler draaien) */
    document.addEventListener('focusin', function (e) {
      if (e.target && e.target.closest && e.target.closest('#search') && e.target === zoekInput()) {
        sykCartHaal(); /* zoek-intentie: snapshot ophalen; de 50ms-vertraging + herbouw-check in toonLegeStaat vangen de rest */
        sykLsCancel(); sykLsPlan(toonLegeStaat, 50);
      }
    });
    document.addEventListener('keyup', function (e) {
      var inp = zoekInput();
      if (!inp || e.target !== inp) return;
      /* de vroegere +450ms-naslag is geschrapt: de observer + focus-guard dekken het thema-terugzetten al */
      if (inp.value.trim() === '') { sykLsCancel(); sykLsPlan(toonLegeStaat, 30); }
    });
    /* buiten-klik sluit de zoek-modal ALTIJD (melding eigenaar 14-07): eerder sloten we alleen bij een
       LEEG veld en vertrouwden we met een getypte query op het thema — maar dat her-stylet op desktop
       alleen de balk bovenin en laat de suggest-modal gewoon staan. Nu: klik/tik buiten #search en
       #livesearch terwijl de overlay-staat actief is -> sluiten, ongeacht de inhoud van het veld. */
    document.addEventListener('pointerdown', function (e) {
      if (!document.documentElement.classList.contains('search-full-mode')) return;
      if (e.target && e.target.closest && e.target.closest('#search, #livesearch')) return;
      sykLsCancel();
      sluitZoek();
    }, true);
  }
  /* zoekterm bewaren zodra de klant echt doorklikt (niet op elke toetsaanslag) */
  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    if (el.closest('#livesearch .syk-lsp-a, #livesearch .syk-ls-cta, #livesearch .syk-ls-chip')) {
      var inp = zoekInput();
      if (inp) bewaarZoekterm(inp.value);
    }
    /* undo van het auto-herstel: blok-vlag zetten zodat de oorspronkelijke query bij aankomst niet
       opnieuw wordt omgeleid (de href navigeert gewoon; geen preventDefault nodig) */
    var terug = el.closest('[data-syk-adym-terug]');
    if (terug) {
      try { sessionStorage.setItem('sykAdymBlok', terug.getAttribute('data-syk-adym-terug') || ''); } catch (e2) {}
      sykRadar('herstel_undo', { term: terug.getAttribute('data-syk-adym-terug') || '' });
    }
    if (el.closest('.syk-sr-dym a, .syk-ls-dym a')) sykRadar('dym_klik');
  }, true);
  if (document.body && document.body.classList.contains('template-search')) {
    try { bewaarZoekterm(new URLSearchParams(location.search).get('q')); } catch (e) {}
  }
  /* toetsenbord: pijl omlaag/omhoog door de resultaten, Enter opent (native focus-gedrag) */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    if (!ls || !ls.querySelector('.syk-ls')) return;
    var inp = zoekInput();
    var actief = document.activeElement;
    var inZoek = actief === inp || (actief && actief.closest && actief.closest('#livesearch'));
    if (!inZoek) return;
    var doelen = [].slice.call(ls.querySelectorAll('.syk-lsp-a, .syk-ls-cta'));
    if (!doelen.length) return;
    e.preventDefault();
    var i = doelen.indexOf(actief);
    if (e.key === 'ArrowDown') i = Math.min(i + 1, doelen.length - 1);
    else i = i <= 0 ? -1 : i - 1;
    if (i < 0) { if (inp) inp.focus(); } else doelen[i].focus();
  });

  /* ---- gedelegeerde clicks: plusknop, pills (placeholder-staat), C-sluiten ---- */
  function zoekInput() {
    var s = document.getElementById('search');
    return s ? s.querySelector('input[name="q"], input[type="search"]') : null;
  }
  function sluitZoek() {
    sykLsCancel();
    var h = document.documentElement;
    h.classList.remove('search-compact-active', 'search-full', 'search-full-mode');
    /* gemeten top opruimen: bij de volgende opening staat de header mogelijk anders (compact vs vol).
       Een achtergebleven te lage waarde maakt de min-height te hoog en duwt de groene knop opnieuw
       onder het scherm. Zonder de var valt de CSS terug op de veilige 125px tot naInjectie hermeet. */
    try { h.style.removeProperty('--syk-ls-top'); } catch (e11) {}
    var s = document.getElementById('search');
    if (s) {
      s.classList.remove('full', 'processing');
      /* has-text alleen weghalen als het veld echt leeg is — sluit de klant de modal met een getypte
         query, dan blijft de balk de tekst-staat tonen (anders oogt hij kaal terwijl er tekst staat) */
      var inpS = zoekInput();
      if (!inpS || !inpS.value.trim()) s.classList.remove('has-text');
    }
  }
  /* ---- iPHONE-ZOEKVELD-MICROPACK (golf 1, wens eigenaar 14-07): (1) iOS-autocorrect/hoofdletters
     uit — de iPhone herschrijft onbekende carnavalswoorden ('ninjapak') nog vóór het zoeken; voorkomen
     is goedkoper dan repareren met Bedoelde-je. (2) enterkeyhint=search: de toetsenbordknop toont
     'zoek'. (3) duim-grote wis-knop (×): veld leeg + focus + lege-staat-suggest in één tik. Idempotent
     via data-vlag; ook na thema-herbouw (focusin-delegatie raakt altijd het actuele veld). ---- */
  function sykVeldSlim(inp) {
    if (!inp || inp.getAttribute('data-syk-veld')) return;
    inp.setAttribute('data-syk-veld', '1');
    inp.setAttribute('autocorrect', 'off');
    inp.setAttribute('autocapitalize', 'off');
    inp.setAttribute('spellcheck', 'false');
    inp.setAttribute('enterkeyhint', 'search');
    var ouder = inp.parentNode;
    if (ouder && !ouder.querySelector('.syk-veld-x')) {
      /* review-fix 14-07: de absolute × heeft een gepositioneerde voorouder nodig — het thema
         garandeert die niet op <1024px, dus zelf zetten als de ouder static is */
      try { if (getComputedStyle(ouder).position === 'static') ouder.style.position = 'relative'; } catch (ePos) {}
      /* GEEN <button> (melding eigenaar 14-07: 'dubbel zoekertje'): het thema stylet ELKE button in
         #search als de zoekknop — 44x45px, right:0, top:0 én een ::before met het loep-icoon uit zijn
         icoon-font. Onze × kreeg dus dezelfde loep, pal boven de echte. Een <span role="button"> valt
         buiten die regels; toetsenbediening zelf afgehandeld. */
      var x = document.createElement('span');
      x.className = 'syk-veld-x';
      x.setAttribute('role', 'button');
      x.setAttribute('tabindex', '0');
      x.setAttribute('aria-label', SYKT.wisZoek || 'Zoekopdracht wissen');
      x.textContent = '×';
      x.hidden = !inp.value.trim();
      ouder.appendChild(x);
      /* het thema heeft een EIGEN wisknop (a.clear-toggle, <a href="./">) die pas in de zoek-modal
         zichtbaar wordt — pal op de onze: 'dubbel kruisje' (melding eigenaar 14-07). Wij houden de
         onze (die opent óók meteen de zoeksuggesties) en verbergen die van het thema. Markeer-klasse
         zodat de css alleen verbergt wanneer onze × er daadwerkelijk staat (opt-out veldslim = uit
         laat de thema-knop dus gewoon staan). */
      var veldWrap = (inp.closest && inp.closest('#search')) || ouder;
      if (veldWrap && veldWrap.classList) veldWrap.classList.add('syk-veldx-aan');
      function wis(e) {
        if (e) { e.preventDefault(); e.stopPropagation(); }
        inp.value = '';
        try { inp.dispatchEvent(new Event('input', { bubbles: true })); } catch (e2) {}
        x.hidden = true;
        try { inp.focus(); } catch (e3) {}
        sykRadar('wis');
        sykLsCancel(); sykLsPlan(toonLegeStaat, 30); /* zelfde route als het leegmaken via het toetsenbord */
      }
      x.addEventListener('click', wis);
      x.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') wis(e);
      });
      inp.addEventListener('input', function () { x.hidden = !inp.value.trim(); });
      /* de × naast de ECHTE loep zetten i.p.v. op een vaste 52px (melding eigenaar 14-07: op desktop
         is de thema-zoekknop 55px breed, op mobiel 44 — de vaste waarde gaf daar 3px overlap). Breedte
         live meten en 8px lucht laten; herberekenen bij resize/rotatie. Inline !important wint van de
         css-fallback, die blijft staan voor het geval de knop niet gevonden wordt. */
      function plaatsX() {
        try {
          var knopT = ouder.querySelector('button:not(.syk-veld-x), [type="submit"]:not(.syk-veld-x)');
          var bw = knopT ? Math.round(knopT.getBoundingClientRect().width) : 0;
          if (!bw) bw = 44;
          x.style.setProperty('right', (bw + 8) + 'px', 'important');
        } catch (eP) {}
      }
      plaatsX();
      var tX;
      window.addEventListener('resize', function () { clearTimeout(tX); tX = setTimeout(plaatsX, 150); });
    }
  }
  if (CFG['veldslim'] !== false) {
    /* review-fix 14-07: alleen het hoofd-zoekveld (#search) — footer/404-formulieren hebben een
       andere layout waar de ×-positie (right:52px) nooit voor ontworpen is */
    document.addEventListener('focusin', function (e) {
      var t2 = e.target;
      if (t2 && t2.matches && t2.matches('#search input[name="q"]')) sykVeldSlim(t2);
    });
    sykVeldSlim(zoekInput()); /* het zichtbare veld direct bij load (attrs vóór de eerste tik) */
  }
  /* wildcard naar de volle zoekpagina: die matcht anders alleen hele woorden, terwijl de suggest
     prefix-matcht ('legerpak' -> 2 vs 73 resultaten). Ster gaat mee bij submit; ui toont hem nooit. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('#search, form[action*="/search"]')) return;
    var inp = f.querySelector('input[name="q"]');
    var rw = inp ? String(inp.value || '').trim() : '';
    sykNavigeert = true;
    if (!rw) return;
    /* 09-08: heeft deze zoekopdracht een doelgroep/prijs/sortering in zich, dan gaan die params in
       DEZE navigatie mee. Een formulier kan alleen zijn eigen velden meesturen, dus dan nemen we het
       over. Zonder vertaling verandert er niets aan het oude pad. */
    var url = sykZoekUrl(rw);
    var plat = '/search?q=' + encodeURIComponent(sykSterTerm(rw));
    if (url !== plat) { if (e.preventDefault) e.preventDefault(); location.href = url; return; }
    inp.value = sykSterTerm(rw);
  }, true);
  /* enter op het zoekveld: gegarandeerd naar de resultatenpagina (thema-handlers slikten hem soms in) */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('#search input[name="q"], form[action*="/search"] input[name="q"]')) return;
    var term = String(inp.value || '').trim();
    if (!term) return;
    e.preventDefault();
    sykNavigeert = true;
    bewaarZoekterm(term);
    /* ZOEKREGEL (wens eigenaar 21-07): een geaccordeerd synoniem gaat DIRECT naar de doelcollectie —
       één navigatie, geen 0-resultaten-tussenpagina en geen banner. Bestaanscheck (HEAD, redirect-
       bewust) vangt hernoemde/verwijderde collecties; bij twijfel gewoon de zoekpagina. */
    var rhE = D.zoekregels ? sykRegelHandle(term) : '';
    /* 09-08: sykZoekUrl zet de doelgroep/prijs/sortering meteen in DEZE url, zodat de
       resultatenpagina niet alsnog hoeft te herladen (zie sykGroepCacheVul) */
    var naarZoek = function () { location.href = sykZoekUrl(term); };
    if (rhE) {
      /* tijdslimiet (toets 21-07): een hangende HEAD mag een Enter nooit in het niets laten
         verdwijnen — na 1s gewoon naar de zoekpagina (het stille vangnet vangt het daar alsnog) */
      var hKlaar = false;
      var hVal = setTimeout(function () { if (!hKlaar) { hKlaar = true; naarZoek(); } }, 1000);
      fetch('/collections/' + rhE, { method: 'HEAD' }).then(function (rC) {
        if (hKlaar) return; hKlaar = true; clearTimeout(hVal);
        if (!rC || !rC.ok) { naarZoek(); return; }
        var mE = String(rC.url || '').match(/\/collections\/([^\/?#]+)/);
        if (String(rC.url || '') && !mE) { naarZoek(); return; }
        var hE = rhE;
        if (mE) { try { hE = decodeURIComponent(mE[1]).toLowerCase(); } catch (eD2) { hE = mE[1].toLowerCase(); } }
        sykRadar('regel', { van: term, naar: hE }); /* pas loggen als de sprong echt gebeurt */
        location.href = '/collections/' + hE;
      }).catch(function () { if (!hKlaar) { hKlaar = true; clearTimeout(hVal); naarZoek(); } });
      return;
    }
    naarZoek();
  }, true);
  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;

    var add = el.closest('.syk-ls-add');
    if (add) {
      e.preventDefault(); e.stopPropagation();
      if (add.disabled) return;
      add.disabled = true;
      var oud = add.innerHTML;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(add.getAttribute('data-vid'), 10), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () {
          add.innerHTML = '✓'; telBij(1); verversDrawer();
          setTimeout(function () { add.innerHTML = oud; add.disabled = false; }, 1500);
        })
        .catch(function () { add.disabled = false; });
      return;
    }

    var pil = el.closest('[data-syk-sug]');
    if (pil) {
      var inp = zoekInput();
      if (inp) {
        e.preventDefault();
        inp.value = pil.getAttribute('data-syk-sug') || '';
        inp.focus();
        inp.dispatchEvent(new Event('input', { bubbles: true }));
        inp.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: 'a' }));
      } /* geen input vindbaar -> laat de href (zoekpagina) gewoon werken */
      return;
    }

    if (el.closest('.syk-ls-close')) { e.preventDefault(); sluitZoek(); }
  });

  /* ---- variant D: resultatenpagina-verrijking ---- */
  if ((D.resultsPlus && sykIsSearch) || (CFG['collOn'] && sykIsColl)) {
    document.documentElement.classList.add('syk-sr-plus'); /* head-script (pre-header) zet hem meestal al — idempotent */
    /* PRIJS/DOELGROEP-INTENT toepassen (golf 1): draait synchroon vóór al het andere; bij een treffer
       redirecten we één keer naar de vertaalde url (kern-query + sort/filter-params) — de doelpagina
       heeft geen tokens meer in de query, dus sykIntent geeft daar null = geen lus. Nooit bovenop
       actieve filters van de gebruiker. De filterchips op de doelpagina komen vanzelf uit de native
       inputs (Shopify vinkt ze aan op de filter-params), dus de vertaling is zichtbaar en wisbaar. */
    /* koppeling doelgroep -> filter-checkbox onthouden, zodat de VOLGENDE zoekopdracht hem meteen in
       de eerste url kan meesturen en deze herlading niet meer nodig is. Ook op collectiepagina's,
       want die hebben dezelfde filterbalk. Tweede poging na 1,2 s: de filters renderen soms laat. */
    sykGroepCacheVul();
    setTimeout(sykGroepCacheVul, 1200);
    (function () {
      if (!sykIsSearch || D.intent === false) return;
      /* review-fix 14-07: landt deze pagina net via het auto-herstel (sykAdym staat nog), dan mag de
         intent-vertaling NIET direct doorspringen — de banner+undo moeten eerst renderen. De volgende
         eigen zoekopdracht doet de intent alsnog. */
      try { if (sessionStorage.getItem('sykAdym')) return; } catch (eA) {}
      if (/(^|[&?])filter\./.test(location.search)) return;
      var qI = '';
      try { qI = (new URLSearchParams(location.search).get('q') || '').replace(/\*+$/, ''); } catch (e) { return; }
      var it = qI ? sykIntent(qI) : null;
      if (!it) return;
      var blokI = '';
      try { blokI = sessionStorage.getItem('sykIntentBlok') || ''; } catch (e2) {}
      if (blokI.toLowerCase() === qI.toLowerCase()) return; /* vangnet tegen her-vertalen */
      var u;
      try { u = new URL(location.href); } catch (e3) { return; }
      var toegepast = false;
      if (it.sort) { u.searchParams.set('sort_by', it.sort); toegepast = true; }
      if (it.lte) { u.searchParams.set('filter.v.price.lte', String(it.lte)); toegepast = true; }
      var kern = it.kern;
      if (it.groep) {
        /* runtime-validatie: alleen strippen+filteren als de doelgroep echt als filteroptie bestaat */
        var stam = SYK_GROEP_STAM[it.groep] || it.groep;
        var inpG = null;
        [].forEach.call(document.querySelectorAll('form.f8fl input[type="checkbox"]'), function (i2) {
          if (inpG) return;
          var li2 = i2.closest ? i2.closest('li') : null;
          var lbl2 = String((li2 ? li2.textContent : i2.value) || '').replace(/\s+/g, ' ').trim().toLowerCase();
          if (lbl2.indexOf(stam) === 0 && i2.name) inpG = i2;
        });
        if (inpG) { u.searchParams.set(inpG.name, inpG.value); kern = kern.replace(new RegExp('(^| )' + it.groep + '( |$)', 'g'), ' ').replace(/\s+/g, ' ').trim(); toegepast = true; }
      }
      if (!toegepast || !kern) return;
      u.searchParams.set('q', sykSterTerm(kern));
      try { sessionStorage.setItem('sykIntentBlok', kern); } catch (e4) {}
      sykRadar('intent', { van: qI, naar: kern });
      sykNavigeert = true;
      location.replace(u.toString());
    })();
    /* AUTO-HERSTEL-BANNER: verplaatst naar top-level (sykAdymBanner, na dit blok) zodat hij ook
       op een doelcollectie ZONDER collOn rendert — review-fix 17-07. */
    /* geen resultaten? -> herstelblok met populaire zoektermen + belregel (ALLEEN op de zoekpagina;
       een lege gefilterde collectie krijgt geen zoektermen-suggesties) */
    var grid = document.querySelector('main ul.l4cl li.product-card, #root ul.l4cl li.product-card');
    if (sykIsSearch && !grid) {
      var main = document.querySelector('main') || document.getElementById('root');
      if (main && !document.querySelector('.syk-sr-geen')) {
        var pop = String(D.pop || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        var pills = pop.map(function (p) {
          return '<a class="syk-sr-pill" href="/search?q=' + encodeURIComponent(sykSterTerm(p)) + '">' + esc(p) + '</a>';
        }).join('');
        var blok = document.createElement('div');
        blok.className = 'syk-sr-geen';
        blok.innerHTML = (pills ? '<p><strong>' + esc(SYKT.probeerPop || 'Probeer een van deze populaire zoektermen:') + '</strong></p><div class="syk-sr-pills">' + pills + '</div>' : '') +
          '<p class="syk-sr-bel">' + esc(SYKT.hulpBel || 'Hulp nodig? Bel voor advies') + ' <a href="tel:+31778200208">+31 77 820 02 08</a> — 8,7 · 17.492 reviews</p>';
        var anker = main.querySelector('.cart-empty, .no-results, h1');
        if (anker && anker.parentNode) anker.parentNode.insertBefore(blok, anker.nextSibling);
        else main.appendChild(blok);
        /* typtolerantie ook op de volle resultatenpagina — nu met AUTO-HERSTEL (golf 1, wens eigenaar
           14-07): een geverifieerde Bedoelde-je-kandidaat wordt bij 0 resultaten DIRECT toegepast
           (Amazon/Google-patroon) i.p.v. als linkje — de banner op de doelpagina biedt altijd een
           undo. Voorwaarden: geen actieve filters, kandidaat ≠ query, en de blok-vlag (gezet door de
           undo-klik) staat niet op deze query — anti-pingpong. */
        var qGeen = '';
        try { qGeen = (new URLSearchParams(location.search).get('q') || '').replace(/\*+$/, ''); } catch (e) {}
        var naRegels = function () {
        if (D.dym !== false && qGeen) {
          sykDymZoek(qGeen).then(function (term) {
            if (!term) { sykRadar('nul', { term: qGeen }); return; }
            /* review-fix 14-07: een trage dym-fetch mag een intussen gestarte navigatie (nieuwe
               zoekopdracht, intent-redirect) NOOIT kapen */
            if (sykNavigeert || !blok.isConnected) return;
            function toonDymLink() {
              if (sykNavigeert || !blok.isConnected || blok.querySelector('.syk-sr-dym')) return;
              sykRadar('dym', { van: qGeen, naar: term });
              var pDym = document.createElement('p');
              pDym.className = 'syk-sr-dym';
              pDym.innerHTML = esc(D.tDym || 'Bedoelde je') + ' <a href="/search?q=' + encodeURIComponent(sykSterTerm(term)) + '">' + esc(term) + '</a>?';
              blok.insertBefore(pDym, blok.firstChild);
            }
            var blokVlag = '';
            try { blokVlag = sessionStorage.getItem('sykAdymBlok') || ''; } catch (e2) {}
            var heeftFilters = /(^|[&?])filter\./.test(location.search);
            if (D.autoherstel !== false && !heeftFilters && term.toLowerCase() !== qGeen.toLowerCase() && blokVlag.toLowerCase() !== qGeen.toLowerCase()) {
              /* review-fix 14-07: strengere verificatie voor de AUTO-sprong dan voor het linkje —
                 alleen springen als de kandidaat echt PRODUCTEN heeft (een kale collectie-match zou
                 naar een lege productlijst springen) */
              fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=1', { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (d2) {
                  var nP = (d2 && d2.resources && d2.resources.results && d2.resources.results.products || []).length;
                  if (!nP || sykNavigeert) { toonDymLink(); return; }
                  try {
                    sessionStorage.setItem('sykAdym', JSON.stringify({ van: qGeen, naar: term, t: Date.now() }));
                    sessionStorage.setItem('sykAdymBlok', term); /* vanaf de doelterm nooit nog een auto-sprong */
                  } catch (e3) {}
                  sykRadar('herstel', { van: qGeen, naar: term });
                  sykNavigeert = true;
                  location.replace('/search?q=' + encodeURIComponent(sykSterTerm(term)));
                })
                .catch(toonDymLink);
              return;
            }
            toonDymLink();
          });
        } else if (qGeen) { sykRadar('nul', { term: qGeen }); }
        };
        /* ZOEKREGEL vóór dym (21-07, stil): vangnet voor directe /search?q=-links met een
           regel-term — geluidloos door naar de doelcollectie (geen banner; wens eigenaar).
           Actieve filters blokkeren de sprong. Geen regel-treffer -> gewoon het dym-pad. */
        if (qGeen && D.zoekregels) {
          sykRegelsSnel(1200).then(function () {
            var rhG = sykRegelHandle(qGeen);
            var heeftFiltersR = /(^|[&?])filter\./.test(location.search);
            if (rhG && !heeftFiltersR && !sykNavigeert && blok.isConnected) {
              /* review-fix 17-07: eerst checken of de doelcollectie nog BESTAAT (een later
                 verwijderde/hernoemde collectie mag nooit een 404-sprong worden) — kost alleen
                 iets op het toch al lege 0-resultatenpad */
              fetch('/collections/' + rhG, { method: 'HEAD' }).then(function (rC) {
                if (!rC || !rC.ok || sykNavigeert || !blok.isConnected) { naRegels(); return; }
                /* redirect-fix 17-07: een hernoemde collectie geeft via de URL-redirect rC.ok op
                   het NIEUWE pad — spring dan meteen naar dat pad en zet dat in de vlag, anders
                   mist de banner-padcheck en verdwijnt de undo. Redirect naar iets anders dan een
                   collectie (product/homepage) = doel bestaat niet meer -> dym-pad. */
                var uEind = String(rC.url || '');
                var mEind = uEind.match(/\/collections\/([^\/?#]+)/);
                if (uEind && !mEind) { naRegels(); return; }
                var doelH2 = rhG;
                if (mEind) { try { doelH2 = decodeURIComponent(mEind[1]).toLowerCase(); } catch (eD) { doelH2 = mEind[1].toLowerCase(); } }
                /* wens eigenaar 21-07: STIL — geen sykAdym-vlag, geen banner op de doelcollectie */
                sykRadar('regel', { van: qGeen, naar: doelH2 });
                sykNavigeert = true;
                location.replace('/collections/' + doelH2);
              }).catch(naRegels);
              return;
            }
            naRegels();
          });
        } else { naRegels(); }
      }
    }

    /* resultaatkaarten verrijken naar PDP-stijl (verzoek eigenaar): maat-chips + echte
       leverdatum per kaart; data via /products/<handle>.js (pCache) + 1 bulk-call per lading */
    /* toolbar zoals eigenaars voorbeeld: kop + aantal, daaronder Filteren + Sorteren naast elkaar */
    function bouwToolbar() {
      if (D.bar === false) {
        var nt = document.querySelector('main a.f8fl-toggle:not(.syk-sr-filterknop)');
        if (nt) nt.style.visibility = 'visible'; /* css verbergt hem standaard (anti-flits) */
        return;
      }
      if (document.querySelector('.syk-sr-bar')) return;
      /* er zijn MEERDERE a.f8fl-toggle's (de sluitknop in het filterpaneel heeft dezelfde klasse) —
         pak de zichtbare toolbar-knop, niet die binnen het paneel/fieldset */
      var toggle = [].filter.call(document.querySelectorAll('a.f8fl-toggle'), function (t) { return !t.closest('form.f8fl'); })[0]; /* alleen de paneel-close uitsluiten: de echte knop zit ZELF in een form+fieldset (resultaten-template) */
      /* adversarial #19: de f8fl-toggle-KLASSE wordt pas client-side door custom-async toegekend —
         op traag mobiel komt die na onze laatste herkansing. Server-side is de knop een kale
         <a href="#filter">: daarop terugvallen zodat de balk altijd bouwt. */
      if (!toggle) toggle = [].filter.call(document.querySelectorAll('main a[href="#filter"], main a[href$="#filter"]'), function (t) { return !t.closest('form.f8fl'); })[0];
      var teller = document.querySelector('span.fs-count');
      if (!toggle) return;
      var q = '';
      try { q = (new URLSearchParams(location.search).get('q') || '').replace(/\*+$/, ''); } catch (e) {}
      var aantal = teller ? (String(teller.textContent).match(/\d+/) || [''])[0] : '';
      if (aantal === '1000') aantal = '1000+'; /* Shopify telt zoekresultaten tot maximaal 1000 */
      /* titel: op een COLLECTIE de collectienaam (uit de \u2014 door pre-header verborgen \u2014 h1), op de
         zoekpagina 'Zoekresultaten voor "q"'. Op collecties is fs-count leeg -> aantal later async
         uit de telling-sectie. */
      var titelHtml;
      if (sykIsColl) {
        var h1el = document.querySelector('.collection-wrapper h1, main h1');
        var colNaam = (h1el ? h1el.textContent : '').trim() || (document.title || '').split(/[|\u2013\-]/)[0].trim();
        titelHtml = esc(colNaam);
      } else {
        titelHtml = esc(D.tResult || 'Zoekresultaten voor') + ' \u2018' + esc(q) + '\u2019';
      }
      var eersteSort = sykIsColl ? '<option value="manual">' + esc(D.tSortAanbev || 'Aanbevolen') + '</option>' : '<option value="relevance">' + esc(SYKT.relevantie || 'Relevantie') + '</option>';
      var bar = document.createElement('div');
      bar.className = 'syk-sr-bar';
      bar.innerHTML = '<p class="syk-sr-titel" role="heading" aria-level="1">' + titelHtml + '</p>' +
        '<p class="syk-sr-aantal"' + (aantal ? '' : ' hidden') + '><b>' + (aantal || '') + '</b>&nbsp;' + esc(SYKT.resultaten || 'resultaten') + '</p>' +
        '<div class="syk-sr-knoppen"><span class="syk-sr-sort"><i aria-hidden="true">\u21C5</i><b class="syk-sr-sortlbl">' + esc(D.tSort || 'Sorteren') + '</b>' +
        '<select class="syk-sr-sortsel" aria-label="' + esc(D.tSort || 'Sorteren') + '">' +
        eersteSort +
        '<option value="best-selling">' + esc(SYKT.sortPop || 'Populair') + '</option>' +
        '<option value="price-ascending">' + esc(SYKT.sortOp || 'Prijs laag-hoog') + '</option>' +
        '<option value="price-descending">' + esc(SYKT.sortAf || 'Prijs hoog-laag') + '</option>' +
        '<option value="created-descending">' + esc(SYKT.sortNieuw || 'Nieuwste') + '</option>' +
        '</select></span></div>';
      /* collectie: aantal async uit de telling-sectie (fs-count bestaat daar niet) */
      if (sykIsColl && !aantal) {
        var params0; try { params0 = new URLSearchParams(location.search); } catch (e0) { params0 = null; }
        if (params0) { params0.set('section_id', 'syk-telling');
          fetch(location.pathname + '?' + params0.toString(), { headers: { Accept: 'text/html' } })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (h) { var t = document.createElement('div'); t.innerHTML = h; var s = t.querySelector('[data-syk-telling]'); var n = s ? (String(s.textContent).match(/\d+/) || [''])[0] : ''; var el = bar.querySelector('.syk-sr-aantal'); if (n && el) { el.querySelector('b').textContent = (n === '1000' ? '1000+' : n); el.removeAttribute('hidden'); } })
            .catch(function () {});
        }
      }
      /* originele rijen verbergen en de ECHTE filterknop verplaatsen (thema-handler blijft intact) */
      var oudeRij = toggle.closest('p, .cols, div');
      var anker = document.getElementById('srp-suggestions-block') || (oudeRij && oudeRij.parentNode ? oudeRij : null);
      /* debug-balkje eigenaar 08-07: op zijn toestel zat het anker IN form.f8sr>fieldset — de bar
         nestelde daardoor in het formulier en zijn (transparante) box rekte over de pills/categorieen
         heen: elke tap raakte div.syk-sr-bar i.p.v. de knoppen. Nooit in een form invoegen. */
      if (anker && anker.closest) { var ankerForm = anker.closest('form'); if (ankerForm && ankerForm.parentNode) anker = ankerForm; }
      if (anker && anker.parentNode) anker.parentNode.insertBefore(bar, anker);
      else return;
      var knoppen = bar.querySelector('.syk-sr-knoppen');
      if (D.fbar === false) {
        knoppen.insertBefore(toggle, knoppen.firstChild);
        toggle.classList.add('syk-sr-filterknop');
      } /* filterbalk actief: de losse Filteren-knop vervalt (chips vervangen hem) */
      /* oude rijen verbergen — maar NOOIT een container die het grid of andere kernblokken bevat
         (de knop zit in het grote resultaten-formulier; closest() kan anders de hele pagina raken) */
      function verbergRij(el) {
        if (!el || el === bar) return;
        if (el.querySelector('ul.l4cl, #srp-suggestions-block, .syk-sr-bar, form.f8fl')) return;
        if ((el.textContent || '').length > 200) return;
        el.classList.add('syk-sr-oud');
      }
      verbergRij(oudeRij);
      if (teller) { verbergRij(teller.closest('p') || teller); }
      /* 'Weergave 1|2'-regel opruimen (kleine rij, alleen weergave-schakels) */
      var wg = [].find.call(document.querySelectorAll('main p, main div, main span'), function (el2) {
        var t2 = (el2.textContent || '').trim();
        return t2.indexOf(SYKT.weergave || 'Weergave') === 0 && t2.length < 30 && !el2.querySelector('ul');
      });
      if (wg) verbergRij(wg);
      bouwCatsRail(bar);
      /* sorteer: native select over de knop; huidige waarde uit de url */
      var sel = bar.querySelector('.syk-sr-sortsel');
      var lbl = bar.querySelector('.syk-sr-sortlbl');
      var huidige = '';
      try { huidige = new URLSearchParams(location.search).get('sort_by') || 'relevance'; } catch (e) {}
      if ([].some.call(sel.options, function (o2) { return o2.value === huidige; })) sel.value = huidige;
      lbl.textContent = sel.options[sel.selectedIndex].text;
      sel.addEventListener('change', function () {
        try {
          var u = new URL(location.href);
          u.searchParams.set('sort_by', sel.value);
          location.href = u.toString();
        } catch (e) {}
      });
    }
    function bouwCatsRail(bar) {
      /* categorie-chips zoals de live-search, geordend volgens de menustructuur (D.menu) */
      /* CLS (PSI-ronde 22-07): pre-header reserveert de railhoogte alvast via html.syk-cats-wacht
         (margin-bottom op .syk-fb). Die klasse hier loslaten in HETZELFDE frame als de rail-insert
         — of direct wanneer de rail er niet komt (geen q / uit / 0 categorieen) = netto nul shift. */
      var catsWachtKlaar = function () { try { document.documentElement.classList.remove('syk-cats-wacht'); } catch (e) {} };
      if (D.cats === false || document.querySelector('.syk-sr-cats')) { catsWachtKlaar(); return; }
      var q = '';
      try { q = (new URLSearchParams(location.search).get('q') || '').replace(/\*+$/, ''); } catch (e) {}
      if (!q) { catsWachtKlaar(); return; }
      var klaar = function (cols) {
        /* reviewronde 22-07: de rail-check ook HIER — twee bouwCatsRail-aanroepen binnen het
           fetch-venster (thema veegt de bar weg -> herkansing) hangen beide een klaar aan
           dezelfde gededupliceerde vlucht; zonder her-check kwamen er twee rails. De klaar's
           draaien als opeenvolgende microtasks, dus #2 ziet de insert van #1 gegarandeerd. */
        if (document.querySelector('.syk-sr-cats')) { catsWachtKlaar(); return; }
        if (!cols || !cols.length) { catsWachtKlaar(); return; }
        /* EXACT dezelfde ranking als de suggest-modal (sykColCmp, top-level): woord-match >
           samenstelling ('Boerenzakdoek' bij 'zakdoek') > rest; binnen een rang de kortere/generieke
           titel eerst ('Bandanas' vóór 'Bruine bandana'), dan pas de menuvolgorde. Eén bron van
           waarheid, zodat modal en resultatenpagina niet uiteen kunnen lopen. */
        var cmpC = sykColCmp(q);
        cols.sort(function (a, b) { return cmpC(a.title, a.url, b.title, b.url); });
        cols = cols.slice(0, D.catsMax || 8);
        var rail = document.createElement('div');
        rail.className = 'syk-ls syk-sr-cats';
        rail.innerHTML = '<p class="syk-ls-kop">' + esc(D.tCats || 'Categorie\u00ebn') + '</p><div class="' + sykCatKlas() + '">' +
          cols.map(function (c) {
            return '<a class="syk-ls-chip"' + (c.img ? '' : ' data-letter="' + esc(String(c.title || '?').trim().charAt(0).toUpperCase()) + '"') + ' href="' + esc(c.url) + '">' +
              (c.img ? '<img src="' + esc(sykCatImg(c.img)) + '" alt="" loading="lazy">' : '') +
              '<span>' + esc(c.title) + '</span></a>';
          }).join('') + '</div>';
        var anker2 = document.querySelector('.syk-fb') || bar;
        /* anker kan losgekoppeld zijn als het thema de sectie net herbouwde (parentNode null):
           dan de insert overslaan i.p.v. gooien — de wacht-klasse MOET hoe dan ook los
           (anders blijft het gereserveerde gat staan tot de failsafe). */
        if (anker2 && anker2.parentNode) anker2.parentNode.insertBefore(rail, anker2.nextSibling);
        catsWachtKlaar(); /* zelfde frame als de insert: gereserveerde ruimte -> echte rail, nul shift */
        var srp = document.getElementById('srp-suggestions-block');
        if (srp) srp.classList.add('syk-sr-oud'); /* geen dubbele categorie-blokken */
      };
      /* ÉÉN gedeelde bron met de modal (sykColsVoor): query + compound-tweeling ('ninjazwaard' ->
         'ninja zwaard') + kleur-gestripte kern ('rood ninjapak' -> 'ninja pak') + de samenstellings-
         collecties uit de menustructuur ('zakdoek' -> Boerenzakdoek). Dag-gecachet en ontdubbeld. */
      sykColsVoor(q).then(klaar);
    }
    /* ---- filterbalk variant A: chip-bar + panelen, geproxyt op het native form.f8fl ----
       (S&D bepaalt de facetten; wij vervangen alleen de presentatie). LET OP: het thema-script van
       het categorieenblok serialiseert de container opnieuw waardoor gebonden listeners verloren
       gaan (kloon-probleem, zelfde als de toolbar) — daarom ALLES gedelegeerd op document en
       elke keer vers uit de DOM lezen. */
    function fbForm() { return document.querySelector('form.f8fl'); }
    function fbLeesGroepen() {
      var form = fbForm();
      var fs = form && form.querySelector('fieldset');
      if (!fs) return [];
      var groepen = [];
      [].forEach.call(fs.children, function (el) {
        if (el.tagName === 'H4') {
          /* review-fix 21-07: kindnodes met spaties joinen — de EN-prijs-H4 heeft twee spans zonder
             scheidingsteken ('PricePrice'); NL had toevallig een ?-glyph die als spatie werd gestript */
          var rauw = [].map.call(el.childNodes, function (n2) { return n2.textContent || ''; }).join(' ');
          var wrd = rauw.replace(/Close/g, ' ').replace(/[^\w&\s\-\u00C0-\u00FF]/g, ' ').trim().split(/\s+/);
          var uniq = wrd.filter(function (w, i3) { return w && wrd.indexOf(w) === i3; });
          groepen.push({ titel: uniq.join(' '), el: null });
        } else if (groepen.length && !groepen[groepen.length - 1].el && (el.matches('ul.check') || el.matches('p.input-range'))) {
          groepen[groepen.length - 1].el = el;
        }
      });
      groepen = groepen.filter(function (g) { return g.el && g.titel; });
      var verberg = String(D.fbarVerberg || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
      groepen = groepen.filter(function (g) { return verberg.indexOf(g.titel.toLowerCase()) < 0; });
      var volgorde = String(D.fbarVolgorde || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
      if (volgorde.length) groepen.sort(function (a, b) {
        var ia = volgorde.indexOf(a.titel.toLowerCase()), ib = volgorde.indexOf(b.titel.toLowerCase());
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      });
      return groepen;
    }
    function fbInputs(g) { return [].slice.call(g.el.querySelectorAll('input[type="checkbox"]')); }
    function fbPrijs(g) { return [].slice.call(g.el.querySelectorAll('input[name*="price"]')); }
    function fbIsPrijs(g) { return g.el.matches('p.input-range') || fbPrijs(g).length > 0; }
    function fbActief(g) {
      if (fbIsPrijs(g)) {
        try { var u2 = new URLSearchParams(location.search); return (u2.get('filter.v.price.gte') || u2.get('filter.v.price.lte')) ? 1 : 0; } catch (e) { return 0; }
      }
      return fbInputs(g).filter(function (i2) { return i2.checked; }).length;
    }
    var fbPaneelEl = null;
    function fbPaneel() {
      /* het paneel kan in de body-portal staan terwijl het thema de wrap wegveegt/herbouwt (wees-
         paneel, adversarial-ronde #1): eigen referentie eerst, dan body-portal, dan wrap-paneel */
      if (fbPaneelEl && fbPaneelEl.isConnected) return fbPaneelEl;
      return document.querySelector('body > .syk-fb-paneel') || document.querySelector('.syk-fb-paneel');
    }
    function fbOpenGroep() {
      /* open-groep: wrap-attribuut eerst, maar het PANEEL draagt de waarheid ook zelf (data-open-g)
         zodat een thema-herbouw van de wrap de open staat niet kwijtraakt */
      var w = document.querySelector('.syk-fb');
      var v = w ? w.getAttribute('data-open') : null;
      if (v == null || v === '') { var pn = fbPaneel(); v = pn ? pn.getAttribute('data-open-g') : null; }
      return (v == null || v === '') ? null : v;
    }
    function fbOpen() { var v = fbOpenGroep(); if (v == null || v === 'sort') return v === 'sort' ? NaN : null; var n2 = parseInt(v, 10); return isNaN(n2) ? null : n2; }
    function fbKeuzeInGroep(g) {
      if (!g) return 0;
      if (!fbIsPrijs(g)) return fbInputs(g).filter(function (i2) { return i2.checked; }).length;
      var n2 = 0;
      fbPrijs(g).forEach(function (i2) {
        var w2 = String(i2.value || '').trim();
        if (w2 && w2 !== String(i2.getAttribute('min') || '\u0000') && w2 !== String(i2.getAttribute('max') || '\u0000')) n2++;
      });
      return n2;
    }
    /* kleur-helpers (SYK_KLEURKAART/sykKleurKaart/sykYiqLicht/sykKleurDot) staan nu op TOP-LEVEL,
       v\u00f3\u00f3r verrijkOok \u2014 anders zijn ze in strict mode block-scoped en onbereikbaar vanuit verrijkOok
       (kaart-kleurstipjes gaven dan een ReferenceError die de verrijking stil brak). */
    /* leesbaar label voor een filter-optie: de tekst van het thema-<li> ('Kleding & Verkleedsets'),
       met de telling '(15)' eraf. NOOIT de rauwe checkbox-waarde tonen als die een technische GID is
       (gid://shopify/... — wens eigenaar 14-07: die tekst onzichtbaar voor de klant, maar de waarde
       blijft gewoon als filter-functie in de checkbox staan, dus de filter werkt onveranderd door). */
    function fbOptieLabel(i2) {
      var li = i2 && i2.closest ? i2.closest('li') : null;
      var s = String((li ? li.textContent : (i2 ? i2.value : '')) || '').replace(/\s+/g, ' ').trim();
      s = s.replace(/\s*\(\s*\d[\d.\s  ]*\)\s*$/, '').trim(); /* telling '(15)' eraf */
      if (s && !/gid:\/\/|^shopify\//i.test(s)) return s;
      var v = String((i2 && i2.value) || '');
      return /gid:\/\/|^shopify\//i.test(v) ? '' : v; /* rauwe GID nooit zichtbaar */
    }
    function fbTeken() {
      var wrap = document.querySelector('.syk-fb');
      if (!wrap) return;
      var groepen = fbLeesGroepen();
      var open = fbOpen();
      var rij = wrap.querySelector('.syk-fb-rij');
      var railScroll = rij.scrollLeft;
      var sortNu = 'relevance';
      try { sortNu = new URLSearchParams(location.search).get('sort_by') || 'relevance'; } catch (e) {}
      var sortAan = sortNu !== 'relevance';
      var sortOpen = wrap.getAttribute('data-open') === 'sort';
      var alleOpen = wrap.getAttribute('data-open') === 'alle';
      var totaal = fbKeuzeTotaal();
      var alleChip = D.fbarAlle === false ? '' : '<button type="button" class="syk-fb-chip syk-fb-chip--alle' + (totaal ? ' syk-fb-chip--aan' : '') + (alleOpen ? ' syk-fb-chip--open' : '') + '" data-alle="1">' + fbFilterIco() + ' ' + esc(D.tAlle || 'Alle filters') + (totaal ? ' <b class="syk-fb-n">' + totaal + '</b>' : '') + '</button>';
      rij.innerHTML = alleChip + '<button type="button" class="syk-fb-chip syk-fb-chip--sort' + (sortAan ? ' syk-fb-chip--aan' : '') + (sortOpen ? ' syk-fb-chip--open' : '') + '" data-sort="1">' +
        esc(D.tSort || 'Sorteren') + (sortAan ? ' <b class="syk-fb-n">1</b>' : '') + ' ' + fbChev() + '</button>' + groepen.map(function (g, i2) {
        var n2 = fbActief(g);
        return '<button type="button" class="syk-fb-chip' + (n2 ? ' syk-fb-chip--aan' : '') + (open === i2 ? ' syk-fb-chip--open' : '') + '" data-g="' + i2 + '">' +
          esc(g.titel) + (n2 ? ' <b class="syk-fb-n">' + n2 + '</b>' : '') + ' ' + fbChev() + '</button>';
      }).join('');
      rij.scrollLeft = railScroll;
      var chips = [];
      groepen.forEach(function (g, gi) {
        if (fbIsPrijs(g)) {
          if (fbActief(g)) chips.push({ label: (SYKT.prijs || 'Prijs'), g: gi, prijs: true });
        } else {
          var kg = /kleur|farbe|colou?r|couleur|colore/i.test(g.titel);
          fbInputs(g).forEach(function (i2, ii) { if (i2.checked) chips.push({ label: fbOptieLabel(i2) || g.titel, g: gi, i: ii, dot: kg ? sykKleurDot(i2.value) : '' }); });
        }
      });
      var actiefRij = wrap.querySelector('.syk-fb-actief-rij');
      if (chips.length) {
        actiefRij.hidden = false;
        actiefRij.innerHTML = chips.map(function (c) {
          return '<button type="button" class="syk-fb-achip" data-g="' + c.g + '" data-i="' + (c.i != null ? c.i : '') + '" data-prijs="' + (c.prijs ? '1' : '') + '">' + (c.dot || '') + esc(c.label) + ' <i>\u00d7</i></button>';
        }).join('') + '<button type="button" class="syk-fb-wis">' + esc(SYKT.wisAlles || 'Wis alles') + ' (' + chips.length + ')</button>';
      } else { actiefRij.hidden = true; actiefRij.innerHTML = ''; }
    }
    function bouwFilterbar() {
      if (D.fbar === false || document.querySelector('.syk-fb')) return;
      var bar0 = document.querySelector('.syk-sr-bar');
      if (!bar0 || !fbLeesGroepen().length) return;
      document.documentElement.classList.add('syk-fb-actief');
      document.documentElement.classList.toggle('syk-fb-sticky', D.fbarSticky !== false);
      var wrap = document.createElement('div');
      wrap.className = 'syk-fb';
      wrap.innerHTML = '<div class="syk-fb-rij"></div><div class="syk-fb-paneel" hidden></div><div class="syk-fb-actief-rij" hidden></div>';
      bar0.parentNode.insertBefore(wrap, bar0.nextSibling);
      fbTeken();
    }
    function sykTelSleutel(eigenNaam, optie) { return 'sykFbTel:' + location.search.slice(0, 80) + '|' + (eigenNaam || '') + '|' + optie; }
    function sykTelFetch(params) {
      /* telling via de mini-datasectie (~200 bytes); sectie nog niet op het thema -> volledige pagina als terugval */
      var p2 = new URLSearchParams(params.toString());
      p2.set('section_id', 'syk-telling');
      return fetch(location.pathname + '?' + p2.toString(), { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (h2) {
          var m2 = h2.match(/data-syk-telling>\s*(\d+)/);
          if (m2) return m2[1];
          var p3 = new URLSearchParams(params.toString()); p3.delete('section_id');
          return fetch(location.pathname + '?' + p3.toString(), { headers: { Accept: 'text/html' } })
            .then(function (r2) { return r2.text(); })
            .then(function (h3) { var m3 = h3.match(/(\d+)\s+(?:resultaten|results|Ergebnisse|r\u00e9sultats|resultados|risultati)/i); return m3 ? m3[1] : null; });
        });
    }
    var fbTelAbort = null, fbTelTimer = null;
    function fbLiveTeller() {
      clearTimeout(fbTelTimer);
      fbTelTimer = setTimeout(function () {
        try {
          var pn0 = fbPaneel();
          var knop = pn0 ? pn0.querySelector('.syk-fb-toon') : null;
          if (!knop) return;
          var og2 = fbOpenGroep();
          var g = fbLeesGroepen()[parseInt(og2, 10)];
          var keuzes = og2 === 'alle' ? fbKeuzeTotaal() : fbKeuzeInGroep(g);
          /* Zalando-gedrag: zonder keuze een outline-knop ZONDER telling; met keuze gevuld + live telling */
          knop.classList.toggle('syk-fb-toon--vol', keuzes > 0);
          if (!keuzes) { knop.textContent = SYKT.toonAlle || 'Toon alle resultaten'; return; }
          var volgnr = (fbTelAbort = (fbTelAbort || 0) + 1);
          var params = new URLSearchParams(new FormData(fbForm()));
          sykTelFetch(params)
            .then(function (n3) {
              if (volgnr !== fbTelAbort) return; /* verouderd antwoord */
              var pn2 = fbPaneel();
              var k2 = pn2 ? pn2.querySelector('.syk-fb-toon') : null;
              if (n3 != null && k2 && k2.classList.contains('syk-fb-toon--vol')) k2.textContent = (SYKT.toonN || 'Toon {n} resultaten').replace('{n}', n3);
            }).catch(function () {});
        } catch (e) {}
      }, 350);
    }
    function fbIsMobiel() { try { return window.matchMedia('(max-width: 1023.98px)').matches; } catch (e) { return window.innerWidth < 1024; } }
    /* iconen als inline svg (unicode-glyphs renderden per toestel klein, vaag en uit het lood
       — zelfde les als het ATC-icoon): overal identiek en strak op teksthoogte */
    function fbChev(richting) {
      var pad = richting === 'rechts' ? 'M9 6l6 6l-6 6' : 'M6 9l6 6l6 -6';
      return '<i class="syk-fb-chev" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="' + pad + '"/></svg></i>';
    }
    function fbFilterIco() {
      return '<i class="syk-fb-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="14" cy="6" r="2"/><path d="M4 6h8"/><path d="M18 6h2"/><circle cx="8" cy="12" r="2"/><path d="M4 12h2"/><path d="M12 12h8"/><circle cx="15" cy="18" r="2"/><path d="M4 18h9"/><path d="M19 18h1"/></svg></i>';
    }
    function fbOptiesHtml(g) {
      var kleurGroep = /kleur|farbe|colou?r|couleur|colore/i.test(g.titel);
      var eigenNaam = (fbInputs(g)[0] || {}).name;
      return '<div class="syk-fb-opties">' + fbInputs(g).map(function (i2, ii) {
        var lbl = (i2.closest('li') ? i2.closest('li').textContent : i2.value).trim();
        var dot = kleurGroep ? sykKleurDot(i2.value || lbl) : '';
        var telHtml = '';
        if (D.fbarTel !== false) {
          /* dag-cache direct meerenderen: herhaald openen verspringt dan nooit */
          var cacheTel = cacheLees(sykTelSleutel(eigenNaam, i2.value));
          telHtml = '<span class="syk-fb-tel" data-tel-optie="' + esc(i2.value) + '"' + (cacheTel != null ? ' data-tel-klaar="1"' : '') + '>' + (cacheTel != null ? '(' + cacheTel + ')' : '') + '</span>';
        }
        return '<label class="syk-fb-optie' + (dot ? ' syk-fb-optie--kleur' : '') + (i2.checked ? ' syk-fb-optie--aan' : '') + '"><input type="checkbox" data-oi="' + ii + '"' + (i2.checked ? ' checked' : '') + '>' + dot + '<span>' + esc(lbl || i2.value) + '</span>' + telHtml + '</label>';
      }).join('') + '</div>';
    }
    function fbKaartPrijzen() {
      /* histogram-data: prijzen van de geladen kaarten (goedkoop, geen extra fetch) */
      var uit = [];
      [].forEach.call(document.querySelectorAll('ul.l4cl li.product-card .price'), function (el) {
        var m2 = String(el.textContent).replace(/\s/g, '').match(/(\d+)[.,](\d{2})/);
        if (m2) uit.push(parseFloat(m2[1] + '.' + m2[2]));
      });
      return uit;
    }
    function fbPrijsBody(g) {
      var pv = fbPrijs(g);
      var velden = '<div class="syk-fb-prijs"><label>' + esc(SYKT.vanaf || 'Vanaf') + '<input type="number" inputmode="decimal" min="0" placeholder="0" data-pi="0" value="' + esc(pv[0] ? pv[0].value : '') + '"></label><label>' + esc(SYKT.tot || 'Tot') + '<input type="number" inputmode="decimal" min="0" placeholder="150" data-pi="1" value="' + esc(pv[1] ? pv[1].value : '') + '"></label></div>';
      if (D.fbarPrijs === 'velden') return velden;
      /* Zalando-slider met histogram; de velden blijven eronder voor exact typen */
      var min = parseFloat(pv[0] && pv[0].getAttribute('min')) || 0;
      var max = parseFloat(pv[1] && pv[1].getAttribute('max')) || 100;
      if (!(max > min)) return velden;
      var w1 = pv[0] && pv[0].value !== '' ? parseFloat(pv[0].value) : min;
      var w2 = pv[1] && pv[1].value !== '' ? parseFloat(pv[1].value) : max;
      var prijzen = fbKaartPrijzen();
      var histo = '';
      if (prijzen.length >= 6) {
        var bins = [0, 0, 0, 0, 0, 0, 0, 0];
        prijzen.forEach(function (pr) { var b = Math.min(7, Math.max(0, Math.floor((pr - min) / (max - min) * 8))); bins[b]++; });
        var top = Math.max.apply(null, bins) || 1;
        histo = '<div class="syk-fb-histo">' + bins.map(function (b2, bi) {
          var lo = min + (max - min) * bi / 8, hi = min + (max - min) * (bi + 1) / 8;
          var sel = b2 > 0 && hi > w1 && lo < w2; /* lege bins: geen balk en zeker geen roze restlijn */
          return '<i style="height:' + (b2 > 0 ? Math.max(10, Math.round(b2 / top * 100)) : 0) + '%"' + (sel ? ' class="sel"' : '') + '></i>';
        }).join('') + '</div>';
      }
      var pctA = (w1 - min) / (max - min) * 100, pctB = (w2 - min) / (max - min) * 100;
      return '<div class="syk-fb-prijsslider" data-min="' + min + '" data-max="' + max + '">' + histo +
        '<div class="syk-fb-track"><div class="syk-fb-vul" style="left:' + pctA + '%;right:' + (100 - pctB) + '%"></div>' +
        '<input type="range" class="syk-fb-range" data-kant="gte" min="' + min + '" max="' + max + '" step="1" value="' + w1 + '" aria-label="' + esc(SYKT.prijsVanaf || 'Prijs vanaf') + '">' +
        '<input type="range" class="syk-fb-range" data-kant="lte" min="' + min + '" max="' + max + '" step="1" value="' + w2 + '" aria-label="' + esc(SYKT.prijsTot || 'Prijs tot') + '"></div>' +
        '<div class="syk-fb-prijslbl"><b data-lbl="gte">\u20ac ' + Math.round(w1) + '</b><span>' + esc(SYKT.tot2 || 'tot') + '</span><b data-lbl="lte">\u20ac ' + Math.round(w2) + '</b></div>' +
        '</div>' + velden.replace('syk-fb-prijs', 'syk-fb-prijs syk-fb-prijs--klein');
    }
    function fbGroepBody(g) { return fbIsPrijs(g) ? fbPrijsBody(g) : fbOptiesHtml(g); }
    function fbOpenPaneel(gi) {
      var wrap = document.querySelector('.syk-fb');
      var paneel = fbPaneel();
      var g = fbLeesGroepen()[gi];
      if (!g || !paneel) return;
      if (wrap) wrap.setAttribute('data-open', String(gi));
      paneel.setAttribute('data-open-g', String(gi));
      fbPaneelEl = paneel;
      var body = fbGroepBody(g);
      paneel.innerHTML = '<div class="syk-fb-pkop"><button type="button" class="syk-fb-x" aria-label="' + esc(SYKT.sluiten || 'Sluiten') + '">\u00d7</button><b class="syk-fb-ptitel">' + esc(g.titel) + '</b><button type="button" class="syk-fb-reset"' + (fbActief(g) ? '' : ' hidden') + '>' + esc(SYKT.resetten || 'Resetten') + '</button></div>' +
        '<div class="syk-fb-pbody">' + body + '</div>' +
        '<div class="syk-fb-pvoet"><button type="button" class="syk-fb-toon">' + esc(SYKT.toonAlle || 'Toon alle resultaten') + '</button></div>';
      paneel.hidden = false;
      /* PORTAL (mobiel): voorouders (collection-wrapper e.d.) vormen een stacking context die onze
         z-index afkapt — header/titel prikten door het fullscreen-paneel heen (live gemeten). In de
         body staat het paneel buiten elke context; bij sluiten gaat hij terug in de wrap (desktop-
         dropdown blijft parent-relative gepositioneerd). */
      if (fbIsMobiel() && paneel.parentNode !== document.body) document.body.appendChild(paneel);
      document.documentElement.classList.add('syk-fb-open'); /* body-scroll-slot op mobiel */
      fbLiveTeller(); /* teller direct vullen, niet pas na de eerste aanvink */
      fbTellingen(g, paneel);
      fbTeken();
    }
    function fbOpenSort() {
      var wrap = document.querySelector('.syk-fb');
      var paneel = fbPaneel();
      if (!paneel) return;
      if (wrap) wrap.setAttribute('data-open', 'sort');
      paneel.setAttribute('data-open-g', 'sort');
      fbPaneelEl = paneel;
      var huidige = 'relevance';
      try { huidige = new URLSearchParams(location.search).get('sort_by') || 'relevance'; } catch (e) {}
      var opties = [];
      var natSel = document.querySelector('.syk-sr-sortsel');
      if (natSel) [].forEach.call(natSel.options, function (o2) { opties.push([o2.value, o2.textContent.trim()]); });
      if (!opties.length) opties = [['relevance', SYKT.relevantie || 'Relevantie'], ['price-ascending', SYKT.sortOp || 'Prijs laag-hoog'], ['price-descending', SYKT.sortAf || 'Prijs hoog-laag'], ['created-descending', SYKT.sortNieuw || 'Nieuwste']];
      paneel.innerHTML = '<div class="syk-fb-pkop"><button type="button" class="syk-fb-x" aria-label="' + esc(SYKT.sluiten || 'Sluiten') + '">\u00d7</button><b class="syk-fb-ptitel">' + esc(D.tSort || 'Sorteren') + '</b></div>' +
        '<div class="syk-fb-pbody"><div class="syk-fb-sorts">' + opties.map(function (o2) {
          return '<button type="button" class="syk-fb-sopt' + (o2[0] === huidige ? ' syk-fb-sopt--aan' : '') + '" data-sort-waarde="' + esc(o2[0]) + '">' + esc(o2[1]) + '<i aria-hidden="true"></i></button>';
        }).join('') + '</div></div>';
      paneel.hidden = false;
      if (fbIsMobiel() && paneel.parentNode !== document.body) document.body.appendChild(paneel);
      document.documentElement.classList.add('syk-fb-open');
      fbTeken();
    }
    var fbAlleSort = null;
    function fbSorteerOpties() {
      var opties = [];
      var natSel = document.querySelector('.syk-sr-sortsel');
      if (natSel) [].forEach.call(natSel.options, function (o2) { opties.push([o2.value, o2.textContent.trim()]); });
      if (!opties.length) opties = [['relevance', SYKT.relevantie || 'Relevantie'], ['price-ascending', SYKT.sortOp || 'Prijs laag-hoog'], ['price-descending', SYKT.sortAf || 'Prijs hoog-laag'], ['created-descending', SYKT.sortNieuw || 'Nieuwste']];
      return opties;
    }
    function fbAlleRijInfo(g) {
      /* badge + subregel met gekozen waardes voor een accordeon-rij */
      var n2 = fbKeuzeInGroep(g);
      var sub = '';
      if (n2 && !fbIsPrijs(g)) sub = fbInputs(g).filter(function (i2) { return i2.checked; }).map(function (i2) { return fbOptieLabel(i2); }).filter(Boolean).join(', ');
      if (n2 && fbIsPrijs(g)) {
        var pv = fbPrijs(g);
        sub = '\u20ac ' + (pv[0] && pv[0].value !== '' ? pv[0].value : (pv[0] ? pv[0].getAttribute('min') : '0')) + ' \u2013 \u20ac ' + (pv[1] && pv[1].value !== '' ? pv[1].value : (pv[1] ? pv[1].getAttribute('max') : ''));
      }
      if (sub.length > 34) sub = sub.slice(0, 32) + '\u2026';
      return { n: n2, sub: sub };
    }
    function fbOpenAlle() {
      var wrap = document.querySelector('.syk-fb');
      var paneel = fbPaneel();
      if (!paneel) return;
      if (wrap) wrap.setAttribute('data-open', 'alle');
      paneel.setAttribute('data-open-g', 'alle');
      fbPaneelEl = paneel;
      fbAlleSort = null;
      var groepen = fbLeesGroepen();
      var huidigeSort = 'relevance';
      try { huidigeSort = new URLSearchParams(location.search).get('sort_by') || 'relevance'; } catch (e) {}
      var sortOpties = fbSorteerOpties();
      var sortLbl = (sortOpties.filter(function (o2) { return o2[0] === huidigeSort; })[0] || [])[1] || '';
      var html = '<div class="syk-fb-pkop"><button type="button" class="syk-fb-x" aria-label="' + esc(SYKT.sluiten || 'Sluiten') + '">\u00d7</button><b class="syk-fb-ptitel">' + esc(D.tAlle || 'Alle filters') + '</b><button type="button" class="syk-fb-reset" data-alle="1"' + (fbKeuzeTotaal() ? '' : ' hidden') + '>' + esc(SYKT.allesWissen || 'Alles wissen') + '</button></div>' +
        '<div class="syk-fb-pbody"><div class="syk-fb-accs">';
      /* Sorteren als eerste accordeon-rij */
      html += '<div class="syk-fb-acc" data-acc-sort="1"><button type="button" class="syk-fb-acckop">' + esc(D.tSort || 'Sorteren') +
        (huidigeSort !== 'relevance' ? '<span class="syk-fb-accsub">' + esc(sortLbl) + '</span>' : '') +
        fbChev('rechts') + '</button><div class="syk-fb-accbody" hidden><div class="syk-fb-sorts">' +
        sortOpties.map(function (o2) {
          return '<button type="button" class="syk-fb-sopt' + (o2[0] === huidigeSort ? ' syk-fb-sopt--aan' : '') + '" data-in-alle="1" data-sort-waarde="' + esc(o2[0]) + '">' + esc(o2[1]) + '<i aria-hidden="true"></i></button>';
        }).join('') + '</div></div></div>';
      groepen.forEach(function (g, gi) {
        var info = fbAlleRijInfo(g);
        /* INP (PSI-ronde 22-07): accordion-body LEEG laten — honderden optie-nodes (dots/tellers)
           parsen kostte ~600ms presentatie bij 4x-CPU terwijl alles toch hidden start. De body
           wordt gebouwd bij de eerste accordion-tik (acckop-handler), vlak vóór fbTellingen. */
        html += '<div class="syk-fb-acc" data-acc-g="' + gi + '"><button type="button" class="syk-fb-acckop">' + esc(g.titel) +
          (info.n ? '<b class="syk-fb-n">' + info.n + '</b>' : '') +
          (info.sub ? '<span class="syk-fb-accsub">' + esc(info.sub) + '</span>' : '') +
          fbChev('rechts') + '</button><div class="syk-fb-accbody" hidden></div></div>';
      });
      html += '</div></div><div class="syk-fb-pvoet"><button type="button" class="syk-fb-toon">' + esc(SYKT.toonAlle || 'Toon alle resultaten') + '</button></div>';
      paneel.innerHTML = html;
      paneel.hidden = false;
      if (fbIsMobiel() && paneel.parentNode !== document.body) document.body.appendChild(paneel);
      document.documentElement.classList.add('syk-fb-open');
      fbLiveTeller();
      fbTeken();
    }
    function fbSluitPaneel() {
      document.documentElement.classList.remove('syk-fb-open');
      var wrap = document.querySelector('.syk-fb');
      if (wrap) wrap.removeAttribute('data-open');
      /* ALLE instanties sluiten (wees-paneel na thema-herbouw + eventuele reserve in een nieuwe wrap) */
      [].forEach.call(document.querySelectorAll('.syk-fb-paneel'), function (pn) {
        pn.hidden = true; pn.innerHTML = ''; pn.removeAttribute('data-open-g');
        if (pn.parentNode === document.body) {
          if (wrap && !wrap.querySelector('.syk-fb-paneel')) wrap.appendChild(pn);
          else if (wrap) pn.parentNode.removeChild(pn);
        }
      });
      fbPaneelEl = null;
      fbTeken();
    }
    function fbPas(sortWaarde) {
      sykNavigeert = true;
      try {
        if (sortWaarde) {
          var f0 = fbForm();
          var h0 = f0.querySelector('input[name="sort_by"][data-syk]');
          if (!h0) { h0 = document.createElement('input'); h0.type = 'hidden'; h0.name = 'sort_by'; h0.setAttribute('data-syk', '1'); f0.appendChild(h0); }
          h0.value = sortWaarde;
        }
        /* onaangeroerde prijsvelden NIET mee-submitten: het thema vult ze standaard met de volle
           range (gte=min, lte=max) waardoor elke filter-submit fantoom-prijsparams in de url zette
           en een 'Prijs x'-chip toonde zonder dat de klant een prijs koos */
        [].forEach.call(fbForm().querySelectorAll('input[name*="price"]'), function (i2) {
          var w = String(i2.value || '').trim();
          var standaard = !w || w === String(i2.getAttribute('min') || '\u0000') || w === String(i2.getAttribute('max') || '\u0000');
          i2.disabled = standaard; /* symmetrisch: her-enable expliciet (bfcache herstelde disabled-staat) */
        });
        fbForm().submit();
      } catch (e) { location.reload(); }
    }
    function fbSchrijfProxy(g, scope) {
      var paneel = scope || fbPaneel(); /* scope = groep-container in het Alle-filters-paneel */
      if (!paneel) return;
      if (fbIsPrijs(g)) {
        var pv = fbPrijs(g);
        [].forEach.call(paneel.querySelectorAll('input[data-pi]'), function (i2) { var doel = pv[parseInt(i2.getAttribute('data-pi'), 10)]; if (doel) doel.value = i2.value; });
      } else {
        var native = fbInputs(g);
        [].forEach.call(paneel.querySelectorAll('input[data-oi]'), function (i2) { var doel = native[parseInt(i2.getAttribute('data-oi'), 10)]; if (doel) doel.checked = i2.checked; });
      }
    }
    function fbKeuzeTotaal() {
      var n2 = 0;
      fbLeesGroepen().forEach(function (g) { n2 += fbKeuzeInGroep(g); });
      return n2;
    }
    function fbVerwerkKlik(e) {
      if (!e.target || !e.target.closest) return;
      var chip = e.target.closest('.syk-fb-chip');
      if (chip) {
        if (chip.hasAttribute('data-alle')) {
          if (fbOpenGroep() === 'alle') fbSluitPaneel(); else fbOpenAlle();
          return;
        }
        if (chip.hasAttribute('data-sort')) {
          if (fbOpenGroep() === 'sort') fbSluitPaneel(); else fbOpenSort();
          return;
        }
        var gi = parseInt(chip.getAttribute('data-g'), 10); if (fbOpen() === gi) fbSluitPaneel(); else fbOpenPaneel(gi); return;
      }
      var acckop = e.target.closest('.syk-fb-acckop');
      if (acckop) {
        e.preventDefault(); e.stopPropagation();
        var accBody = acckop.parentNode.querySelector('.syk-fb-accbody');
        var accOpen = accBody && accBody.hidden;
        if (accBody) accBody.hidden = !accBody.hidden;
        acckop.parentNode.classList.toggle('syk-fb-acc--open', !!accOpen);
        if (accOpen) {
          var accG = acckop.parentNode.getAttribute('data-acc-g');
          if (accG != null) {
            var accGrp = fbLeesGroepen()[parseInt(accG, 10)];
            /* lazy body (INP): fbOpenAlle laat de accordion-bodies leeg; hier bij de eerste
               open-tik pas bouwen — de proxy (native form) is de bron van waarheid, dus een
               nog-niet-gebouwde body mist nooit staat. Idempotent via firstElementChild. */
            if (accGrp && accBody && !accBody.firstElementChild) accBody.innerHTML = fbGroepBody(accGrp);
            if (accGrp) fbTellingen(accGrp, acckop.parentNode);
          }
        }
        return;
      }
      var sopt = e.target.closest('.syk-fb-sopt');
      if (sopt) {
        e.preventDefault(); e.stopPropagation();
        if (sopt.hasAttribute('data-in-alle')) {
          /* in het overzichtspaneel: keuze markeren, pas toepassen bij 'Toon resultaten' */
          var kast = sopt.closest('.syk-fb-sorts');
          if (kast) [].forEach.call(kast.querySelectorAll('.syk-fb-sopt'), function (s2) { s2.classList.toggle('syk-fb-sopt--aan', s2 === sopt); });
          fbAlleSort = sopt.getAttribute('data-sort-waarde');
          fbLiveTeller();
          return;
        }
        sykNavigeert = true;
        try { var u4 = new URL(location.href); u4.searchParams.set('sort_by', sopt.getAttribute('data-sort-waarde')); location.href = u4.toString(); } catch (e4) {}
        return;
      }
      if (e.target.closest('.syk-fb-toon')) {
        var og = fbOpenGroep();
        if (og === 'alle') { fbPas(fbAlleSort); return; } /* proxy is in het overzicht al live geschreven per change */
        var go = fbLeesGroepen()[parseInt(og, 10)];
        if (go) { fbSchrijfProxy(go); fbPas(); }
        return;
      }
      if (e.target.closest('.syk-fb-x')) { fbSluitPaneel(); return; }
      if (e.target.closest('.syk-fb-reset')) {
        var rst = e.target.closest('.syk-fb-reset');
        if (rst.hasAttribute('data-alle')) {
          fbLeesGroepen().forEach(function (g3) { if (fbIsPrijs(g3)) fbPrijs(g3).forEach(function (i2) { i2.value = ''; }); else fbInputs(g3).forEach(function (i2) { i2.checked = false; }); });
          fbAlleSort = null;
          fbOpenAlle(); /* herrendert het overzicht schoon */
          return;
        }
        var g2 = fbLeesGroepen()[parseInt(fbOpenGroep(), 10)];
        if (g2) {
          if (fbIsPrijs(g2)) fbPrijs(g2).forEach(function (i2) { i2.value = ''; });
          else fbInputs(g2).forEach(function (i2) { i2.checked = false; });
          /* Zalando-gedrag: resetten wist alleen de keuzes; navigeren gebeurt pas bij 'Toon resultaten' */
          var pn3 = fbPaneel();
          if (pn3) {
            [].forEach.call(pn3.querySelectorAll('input[data-oi]'), function (i2) { i2.checked = false; });
            [].forEach.call(pn3.querySelectorAll('input[data-pi]'), function (i2) { i2.value = ''; });
            [].forEach.call(pn3.querySelectorAll('.syk-fb-optie--aan'), function (l2) { l2.classList.remove('syk-fb-optie--aan'); });
            var rk = pn3.querySelector('.syk-fb-reset'); if (rk) rk.hidden = true;
          }
          fbLiveTeller();
        }
        return;
      }
      var achip = e.target.closest('.syk-fb-achip');
      if (achip) {
        var ag = fbLeesGroepen()[parseInt(achip.getAttribute('data-g'), 10)];
        if (ag) {
          if (achip.getAttribute('data-prijs')) fbPrijs(ag).forEach(function (i2) { i2.value = ''; });
          else { var inp2 = fbInputs(ag)[parseInt(achip.getAttribute('data-i'), 10)]; if (inp2) inp2.checked = false; }
          fbPas();
        }
        return;
      }
      if (e.target.closest('.syk-fb-wis')) {
        fbLeesGroepen().forEach(function (g3) { if (fbIsPrijs(g3)) fbPrijs(g3).forEach(function (i2) { i2.value = ''; }); else fbInputs(g3).forEach(function (i2) { i2.checked = false; }); });
        fbPas(); return;
      }
      if (fbOpen() != null && !e.target.closest('.syk-fb, .syk-fb-paneel')) fbSluitPaneel();
    }
    window.__sykFbKlik = fbVerwerkKlik; /* tap-motor (pointer-niveau) roept dezelfde logica aan */
    document.addEventListener('click', function (e) {
      if (sykTapNet(e)) { e.preventDefault(); e.stopPropagation(); return; } /* al afgehandeld op pointer-niveau */
      fbVerwerkKlik(e);
    }, true); /* CAPTURE: thema-handlers (custom-async) doen op mobiel stopPropagation waardoor bubble-taps intermitterend stierven — zelfde les als de atc/swatch-delegatie */
    function fbAlleVerversRij(accEl, g) {
      var kop = accEl.querySelector('.syk-fb-acckop');
      if (!kop) return;
      var info = fbAlleRijInfo(g);
      var badge = kop.querySelector('.syk-fb-n');
      var sub = kop.querySelector('.syk-fb-accsub');
      if (info.n) {
        if (!badge) { badge = document.createElement('b'); badge.className = 'syk-fb-n'; kop.insertBefore(badge, kop.querySelector('.syk-fb-chev')); }
        badge.textContent = info.n;
        if (!sub) { sub = document.createElement('span'); sub.className = 'syk-fb-accsub'; kop.insertBefore(sub, kop.querySelector('.syk-fb-chev')); }
        sub.textContent = info.sub;
      } else {
        if (badge) badge.parentNode.removeChild(badge);
        if (sub) sub.parentNode.removeChild(sub);
      }
    }
    /* auto-inklap na een keuze (wens eigenaar 14-07): klap de accordeon-groep kort na een keuze dicht,
       zodat het 'Alle filters'-paneel opgeruimd blijft en de gekozen waarde als samenvatting in de kop
       verschijnt. Kort UITGESTELD + per groep resettend, zodat meerdere keuzes achter elkaar (bv. Dames
       én Heren) de groep niet tussendoor dichtklappen — pas na een korte pauze sluit hij. */
    function fbAccInklap(accEl) {
      if (!accEl) return;
      if (accEl.__sykInklap) clearTimeout(accEl.__sykInklap);
      /* 400ms (adversarial review 14-07): binnen het 500ms-input-window van de CLS-meting, dus de
         inklap telt niet als layout shift; voelt nog steeds als 'na de keuze'. */
      accEl.__sykInklap = setTimeout(function () {
        accEl.__sykInklap = null;
        if (accEl.isConnected === false) return;
        var body = accEl.querySelector('.syk-fb-accbody');
        if (body && !body.hidden) { body.hidden = true; accEl.classList.remove('syk-fb-acc--open'); }
      }, 400);
    }
    function fbAccInklapStop(accEl) {
      if (accEl && accEl.__sykInklap) { clearTimeout(accEl.__sykInklap); accEl.__sykInklap = null; }
    }
    /* de gebruiker raakt de groep opnieuw aan (tweede optie kiezen, slider slepen) -> inklap-timer
       stoppen; hij herstart pas bij de volgende afgeronde keuze (change-event). */
    ['pointerdown', 'touchstart'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (!e.target || !e.target.closest) return;
        var accB = e.target.closest('.syk-fb-accbody');
        if (accB) fbAccInklapStop(accB.parentNode);
      }, true);
    });
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest || !e.target.closest('.syk-fb-paneel')) return;
      var acc = e.target.closest('[data-acc-g]');
      var g = acc ? fbLeesGroepen()[parseInt(acc.getAttribute('data-acc-g'), 10)] : fbLeesGroepen()[parseInt(fbOpenGroep(), 10)];
      if (!g) return;
      /* pill-feedback ook klasse-gedreven (iOS <15.4 heeft geen :has) */
      var lab = e.target.closest('.syk-fb-optie');
      if (lab) lab.classList.toggle('syk-fb-optie--aan', !!e.target.checked);
      fbSchrijfProxy(g, acc || null);
      var pn4 = fbPaneel();
      var rk = pn4 ? pn4.querySelector('.syk-fb-reset') : null;
      if (rk) rk.hidden = (rk.hasAttribute('data-alle') ? fbKeuzeTotaal() : fbKeuzeInGroep(g)) === 0;
      /* auto-inklap: NIET voor de prijsgroep (slider-interactie is meerstaps; dichtklappen onder de
         vinger breekt het slepen — adversarial review 14-07); annuleren zodra de keuze binnen de
         wachttijd weer ongedaan is gemaakt. */
      if (acc) {
        fbAlleVerversRij(acc, g);
        if (!fbIsPrijs(g) && fbKeuzeInGroep(g) > 0) fbAccInklap(acc);
        else fbAccInklapStop(acc);
      }
      fbLiveTeller();
    }, true);
    /* prijs-slider: dubbele range schrijft live naar de velden + native form + teller */
    document.addEventListener('input', function (e) {
      var t2 = e.target;
      if (!t2 || !t2.classList) return;
      var scope = (t2.closest && (t2.closest('[data-acc-g]') || fbPaneel())) || null;
      if (!scope) return;
      if (t2.classList.contains('syk-fb-range')) {
        var sl = t2.closest('.syk-fb-prijsslider');
        if (!sl) return;
        var mn = parseFloat(sl.getAttribute('data-min')) || 0, mx = parseFloat(sl.getAttribute('data-max')) || 100;
        var rG = sl.querySelector('.syk-fb-range[data-kant="gte"]'), rL = sl.querySelector('.syk-fb-range[data-kant="lte"]');
        var a = Math.min(parseFloat(rG.value), parseFloat(rL.value)), b = Math.max(parseFloat(rG.value), parseFloat(rL.value));
        var vul = sl.querySelector('.syk-fb-vul');
        if (vul) { vul.style.left = ((a - mn) / (mx - mn) * 100) + '%'; vul.style.right = (100 - (b - mn) / (mx - mn) * 100) + '%'; }
        var lG = sl.querySelector('[data-lbl="gte"]'), lL = sl.querySelector('[data-lbl="lte"]');
        if (lG) lG.textContent = '\u20ac ' + Math.round(a);
        if (lL) lL.textContent = '\u20ac ' + Math.round(b);
        [].forEach.call(sl.querySelectorAll('.syk-fb-histo i'), function (bar, bi) {
          var lo = mn + (mx - mn) * bi / 8, hi = mn + (mx - mn) * (bi + 1) / 8;
          bar.classList.toggle('sel', bar.style.height !== '0%' && hi > a && lo < b);
        });
        var v0 = scope.querySelector('input[data-pi="0"]'), v1 = scope.querySelector('input[data-pi="1"]');
        if (v0) v0.value = a <= mn ? '' : a;
        if (v1) v1.value = b >= mx ? '' : b;
        var gS = null;
        var accS = t2.closest('[data-acc-g]');
        gS = accS ? fbLeesGroepen()[parseInt(accS.getAttribute('data-acc-g'), 10)] : fbLeesGroepen()[parseInt(fbOpenGroep(), 10)];
        if (gS) {
          fbSchrijfProxy(gS, accS || null);
          if (accS) fbAlleVerversRij(accS, gS);
          var pn5 = fbPaneel();
          var rk2 = pn5 ? pn5.querySelector('.syk-fb-reset') : null;
          if (rk2) rk2.hidden = (rk2.hasAttribute('data-alle') ? fbKeuzeTotaal() : fbKeuzeInGroep(gS)) === 0;
          fbLiveTeller();
        }
      }
    }, true);
    /* tellingen per optie (instelbaar): 1 fetch per optie bij openen van een groep, dag-cache;
       telt met de FILTERS VAN ANDERE GROEPEN mee (Zalando-semantiek: 'wat krijg ik als ik dit aanvink') */
    var fbTelBezig = 0;
    function fbTellingen(g, scopeEl) {
      if (D.fbarTel === false || !g || fbIsPrijs(g) || !scopeEl) return;
      var spans = [].slice.call(scopeEl.querySelectorAll('.syk-fb-tel'));
      if (!spans.length) return;
      var basis;
      try { basis = new URLSearchParams(new FormData(fbForm())); } catch (e) { return; }
      /* keuzes van DEZE groep uit de basis halen (anders telt de eigen selectie mee) */
      var eigenNaam = (fbInputs(g)[0] || {}).name;
      if (eigenNaam) basis.delete(eigenNaam);
      spans.slice(0, 20).forEach(function (sp) {
        var optie = sp.getAttribute('data-tel-optie');
        if (!optie || sp.getAttribute('data-tel-klaar')) return;
        sp.setAttribute('data-tel-klaar', '1');
        var sleutel = sykTelSleutel(eigenNaam, optie);
        var cache = cacheLees(sleutel);
        if (cache != null) { sp.textContent = '(' + cache + ')'; return; }
        if (fbTelBezig > 6) { sp.removeAttribute('data-tel-klaar'); return; } /* niet meer dan ~6 tegelijk */
        fbTelBezig++;
        var params = new URLSearchParams(basis.toString());
        if (eigenNaam) params.append(eigenNaam, optie);
        sykTelFetch(params)
          .then(function (n3) {
            fbTelBezig--;
            if (n3 != null) { sp.textContent = '(' + n3 + ')'; sp.classList.add('syk-fb-tel--in'); cacheSchrijf(sleutel, n3); }
            else { sp.classList.add('syk-fb-tel--leeg'); } /* geen telling -> gereserveerde ruimte opgeven */
            fbTellingen(g, scopeEl); /* wachtrij zelf leeg laten lopen (volgende ~6) */
          })
          .catch(function () { fbTelBezig--; sp.classList.add('syk-fb-tel--leeg'); fbTellingen(g, scopeEl); });
      });
    }
    /* bfcache (adversarial #7/#10/#11): terug-swipen herstelt de bevroren DOM incl. open portal-
       paneel, scroll-lock en disabled prijsvelden — bij herstel alles resetten */
    window.addEventListener('pageshow', function (e2) {
      if (!e2 || !e2.persisted) return;
      sykNavigeert = false;
      try { fbSluitPaneel(); } catch (e3) {}
      try { var f2 = fbForm(); if (f2) [].forEach.call(f2.querySelectorAll('input[name*="price"]'), function (i2) { i2.disabled = false; }); } catch (e4) {}
      try { sluitZoek(); } catch (e5) {}
    });
    /* rotatie naar desktop-breedte met open portal-paneel: netjes sluiten (adversarial #22) */
    try {
      window.matchMedia('(min-width: 1024px)').addEventListener('change', function (mq) { if (mq.matches) fbSluitPaneel(); });
    } catch (e6) {}
    bouwToolbar();
    bouwFilterbar();
    document.documentElement.classList.add('syk-sr-klaar'); /* skeleton (pre-header) los laten zodra onze balken staan */
    setTimeout(bouwFilterbar, 800);
    /* wildcard overal uit het ZICHT (hij leeft alleen in de url): tabbladtitel, alle q-velden,
       en de native teller/geen-resultaten-teksten — enter plakt hem bij verzenden weer aan */
    function verbergSter() {
      var qRaw = '';
      try { qRaw = new URLSearchParams(location.search).get('q') || ''; } catch (e) {}
      if (!/\*$/.test(qRaw)) return;
      var qSchoon = qRaw.replace(/\*+$/, '');
      try { document.title = document.title.split(qRaw).join(qSchoon); } catch (e) {}
      [].forEach.call(document.querySelectorAll('input[name="q"]'), function (i2) {
        if (/\*$/.test(i2.value)) i2.value = i2.value.replace(/\*+$/, '');
      });
      [].forEach.call(document.querySelectorAll('span.fs-count, .syk-sr-oud, h1, h2'), function (el) {
        if (el.children.length === 0 && el.textContent.indexOf(qRaw) > -1) el.textContent = el.textContent.split(qRaw).join(qSchoon);
      });
    }
    verbergSter();
    setTimeout(verbergSter, 700);
    setTimeout(verbergSter, 2000);
    /* het srp-categorieenblok wordt na het laden client-side herbouwd en kan de bar wegvegen — herkansen */
    setTimeout(bouwToolbar, 600);
    setTimeout(bouwToolbar, 1800);
    setTimeout(verrijkOok, 1500);
    setTimeout(verrijkOok, 3500);
    sykLabelsInit();
    function sykUitFormTillen() {
      var form = null;
      ['.syk-sr-bar', '.syk-fb', '.syk-sr-cats'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el && el.closest) { var f = el.closest('form'); if (f && f.parentNode) form = form || f; }
      });
      if (!form) return;
      var bar2 = document.querySelector('.syk-sr-bar');
      var fb2 = document.querySelector('.syk-fb');
      var cats2 = document.querySelector('.syk-sr-cats');
      [bar2, fb2, cats2].forEach(function (el) { if (el && el.closest('form')) form.parentNode.insertBefore(el, form); });
    }
    var srBezig = false;
    function verrijkKaarten() {
      bouwToolbar();
      bouwFilterbar();
      sykUitFormTillen();
      if (srBezig) return;
      var kaarten = [].slice.call(document.querySelectorAll('ul.l4cl li.product-card:not([data-syk-verrijkt])'));
      if (!kaarten.length) return;
      var nogMeer = kaarten.length > 12;
      kaarten = kaarten.slice(0, 12); /* golven van 12: boven de vouw eerst, de rest volgt direct erna */
      srBezig = true;
      var jobs = [];
      kaarten.forEach(function (li) {
        li.setAttribute('data-syk-verrijkt', '1');
        var a = li.querySelector('.h3 a');
        var m = a && String(a.getAttribute('href') || '').split('?')[0].match(/\/products\/([^\/?#]+)\/?$/);
        if (m && m[1].indexOf('.') === -1) jobs.push({ li: li, handle: m[1] });
      });
      if (!jobs.length) { srBezig = false; return; }
      Promise.all(jobs.map(function (j) { return haalProduct(j.handle); })).then(function (ps) {
        var bulkItems = [], srGezien = {};
        jobs.forEach(function (j, i) {
          var p = ps[i]; if (!p) return;
          j.p = p;
          /* review-fix 14-07: sold SYNCHROON op de kaart markeren — de .syk-rv-sold-badge komt pas na
             de bulk-fetch en verrijkOok claimt de rijen eerder; zonder dit attribuut miste het
             uitverkocht-vangnet de meeste sold-kaarten */
          if (p.available === false) j.li.setAttribute('data-syk-sold', '1');
          var sizeOpt = (p.options || []).indexOf('Maat') > -1 ? 'Maat' : ((p.options || [])[0] || '');
          var chips = [];
          if (sizeOpt && sizeOpt !== 'Title' && (p.variants || []).length > 1) {
            var seen = {};
            (p.variants || []).forEach(function (v) {
              var name = v.options[(p.options || []).indexOf(sizeOpt)];
              if (name && name !== 'Default Title' && !seen[name] && v.available) { seen[name] = 1; chips.push({ name: name, av: true }); }
            });
          }
          if (!j.li.querySelector('.syk-rv-maten')) {
            /* rij ALTIJD plaatsen (leeg bij variantloze producten): vaste rij-hoogtes houden prijs/levertijd over alle kaarten op een lijn */
            var div = document.createElement('span');
            div.className = 'syk-rv-maten';
            div.textContent = chips.slice(0, 8).map(function (o) { return o.name; }).join(' \u00b7 ');
            var info = j.li.querySelector('.h3') && j.li.querySelector('.h3').parentNode;
            if (info) info.appendChild(div);
          }
          if (D.atc !== false) {
            /* native kaartknoppen (quick-add-form + quickshop-linkbtn) verbergen: sinds layout_productcard
               weer 'variant picker' is (nodig voor de PDP) rendert het thema ze ook op zoekkaarten -> dubbel */
            [].forEach.call(j.li.querySelectorAll('form[action*="/cart/add"], .link-btn'), function (nk) { nk.style.setProperty('display', 'none', 'important'); });
            /* de quick-add-verbergklasse op ELKE verrijkte kaart, ook uitverkocht (adversarial review
               14-07): een soldout-kaart kreeg geen .syk-atc-op, dus de native groene variantkiezer
               bleef daar op tap onthulbaar. */
            j.li.classList.add('syk-atc-op');
          }
          if (D.atc !== false && p.available !== false && !j.li.querySelector('.syk-atc')) {
            var atc = document.createElement('span');
            atc.className = 'syk-atc';
            atc.setAttribute('role', 'button'); atc.setAttribute('tabindex', '0');
            atc.setAttribute('aria-label', SYKT.inCart || 'In winkelwagen'); atc.setAttribute('data-handle', j.handle);
            atc.setAttribute('aria-haspopup', 'true'); atc.setAttribute('aria-expanded', 'false');
            atc.innerHTML = sykAtcIcoon();
            /* Podium-kaart: de knop zweeft op de fotorand -> in de figure hangen (CSS positioneert 'm
               absoluut op de onderrand). Andere skins: gewoon als laatste kaart-kind (bar/bol onder de info). */
            var atcOuder = (D.kaart === 'podium' && j.li.querySelector('figure')) ? j.li.querySelector('figure') : j.li;
            atcOuder.appendChild(atc);
          }
          j.skus = (p.available !== false) ? sykSkus(p, 6) : [];
          j.skus.forEach(function (sku) { if (!srGezien[sku]) { srGezien[sku] = 1; bulkItems.push({ sku: sku, quantity: 1, available: true }); } });
        });
        function schrijfLever(dmap) {
          jobs.forEach(function (j) {
            if (!j.p) return;
            var stock = j.li.querySelector('p.stock');
            if (!stock) return;
            var lhtml = sykLeverHtml(dmap, j.skus, j.p.available !== false);
            if (lhtml) stock.innerHTML = lhtml; /* leeg = storing -> thema-tekst laten staan */
          });
          srBezig = false;
          verrijkOok();
          sykLabelPass();
          setTimeout(verrijkKaarten, nogMeer ? 0 : 200); /* volgende golf direct; daarna paginering-vangnet */
        }
        if (bulkItems.length) { bulkHaal(bulkItems).then(schrijfLever); } else { schrijfLever(cacheLees('sykBulk') || {}); } /* golf zonder nieuwe sku's: dag-cache meegeven i.p.v. {} */
      }).catch(function () { srBezig = false; });
    }
    verrijkKaarten();
    /* observer op een STABIELE voorouder (adversarial #9: het thema vervangt bij de srp-herbouw de
       ul.l4cl-node zelf — een observer op de oude node ziet dan nooit meer iets) */
    var gridOuder = document.querySelector('main') || document.body;
    try {
      var srT;
      new MutationObserver(function () {
        clearTimeout(srT);
        srT = setTimeout(function () {
          verrijkKaarten();
          /* sub-collectie-pills herbouwen als het thema de sectie verving (adversarial review 14-07):
             sykSubcolBouw is idempotent (data-syk-subpills + rail-opruiming), alleen de trigger ontbrak. */
          if (typeof sykSubcolBouw === 'function') { try { sykSubcolBouw(); } catch (e2) {} }
        }, 250);
      }).observe(gridOuder, { childList: true, subtree: true });
    } catch (e) {}
  }
  /* AUTO-HERSTEL-BANNER (golf 1; top-level sinds 17-07): alleen nog voor het TYPFOUT-auto-herstel
     op de zoekpagina ('Geen resultaten voor X — we tonen Y' + undo). Zoekregel-synoniemen zijn
     sinds 21-07 STIL (wens eigenaar): suggest toont direct, Enter gaat direct naar de collectie.
     Draait ná het blok hierboven, dus de intent-check leest de vlag vóór deze hem consumeert. */
  (function sykAdymBanner() {
    var d0 = null;
    try { d0 = JSON.parse(sessionStorage.getItem('sykAdym') || 'null'); } catch (e) {}
    try { sessionStorage.removeItem('sykAdym'); } catch (e0) {} /* opruimen ook als de JSON corrupt was */
    if (!d0 || !d0.naar) return;
    /* 21-07: de col-tak (regel-sprong-banner) is vervallen — synoniemen zijn nu stil/direct;
       alleen het typfout-auto-herstel toont nog een banner (zoekpagina). */
    if (!sykIsSearch) return;
    /* review-fix 14-07: alleen een VERSE vlag honoreren (15s) — een afgebroken redirect mag geen
       valse banner achterlaten op een latere eigen zoekopdracht */
    if (d0.t && Date.now() - d0.t > 15000) return;
    var qNu = '';
    try { qNu = (new URLSearchParams(location.search).get('q') || '').replace(/\*+$/, ''); } catch (e2) {}
    if (qNu.toLowerCase() !== String(d0.naar).toLowerCase()) return;
    /* zichtbare tekst van lange termen afkappen (mobiel-overflow); de href houdt de volle term */
    var vanKort = String(d0.van).length > 24 ? String(d0.van).slice(0, 22) + '…' : String(d0.van);
    var naarTekst = String(d0.naar);
    var b = document.createElement('div');
    b.className = 'syk-adym';
    b.innerHTML = (SYKT.bannerTonen || 'Geen resultaten voor ‘{van}’ — we tonen <b>{naar}</b>. ').replace('{van}', function () { return esc(vanKort); }).replace('{naar}', function () { return esc(naarTekst); }) +
      '<a href="/search?q=' + encodeURIComponent(d0.van) + '" data-syk-adym-terug="' + esc(d0.van) + '">' + (SYKT.tochZoeken || 'Toch zoeken naar ‘{q}’').replace('{q}', function () { return esc(vanKort); }) + '</a>';
    var mainB = document.querySelector('main') || document.body;
    var ankerB = mainB.querySelector('h1');
    if (ankerB && ankerB.parentNode) ankerB.parentNode.insertBefore(b, ankerB.nextSibling);
    else mainB.insertBefore(b, mainB.firstChild);
  })();
})();
